(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["abandon-cart-popup"]) return;
  try {
    
  (function () {
    if (!window.customElements) return;
    if (customElements.get("x-abandon-cart")) return;

    var STORAGE_KEY = "seed-abandon-cart"; // localStorage: cross-session cart memory + one-time `shown`
    var SESSION_KEY = "seed-abandon-cart-session"; // sessionStorage: marks THIS session active -> suppress
    var MAX_AGE_MS = 14 * 24 * 60 * 60 * 1000; // 14-day window since the cart was first seen

    customElements.define(
      "x-abandon-cart",
      class extends HTMLElement {
        connectedCallback() {
          if (this._initialised) return;
          this._initialised = true;

          this.sig = this.dataset.cartSig || "";
          this.canShow = this.dataset.canShow === "true";

          this.onCartUpdated = this.onCartUpdated.bind(this);
          document.addEventListener("cart:updated", this.onCartUpdated);

          // cart:added fires SYNCHRONOUSLY the instant an item is added -- BEFORE the
          // drawer re-render / server refresh that later produces cart:updated (which
          // can lag by a full round-trip). Seed + mark storage here so the record
          // exists even if the shopper closes the tab immediately after adding.
          this.onCartAdded = this.onCartAdded.bind(this);
          document.addEventListener("cart:added", this.onCartAdded);

          this.evaluate();
        }

        disconnectedCallback() {
          document.removeEventListener("cart:updated", this.onCartUpdated);
          document.removeEventListener("cart:added", this.onCartAdded);
        }

        /* Persistence is fail-open: blocked storage should not block the popup flow.
           localStorage record: { sig, firstSeenAt, shown }. */
        readRecord() {
          try {
            var raw = window.localStorage.getItem(STORAGE_KEY);
            return raw ? JSON.parse(raw) : null;
          } catch (error) {
            return null;
          }
        }

        writeRecord(record) {
          try {
            window.localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
          } catch (error) {
            /* storage unavailable (private mode) -- fail open. */
          }
        }

        /* sessionStorage marks the CURRENT session active so the reminder is
           suppressed this session -- it is a RETURN-visit prompt. */
        sessionActive() {
          try {
            return window.sessionStorage.getItem(SESSION_KEY) === "1";
          } catch (error) {
            return false;
          }
        }

        markSessionActive() {
          try {
            window.sessionStorage.setItem(SESSION_KEY, "1");
          } catch (error) {
            /* fail open */
          }
        }

        parseSig(sig) {
          var map = {};
          (sig || "").split(";").forEach(function (pair) {
            if (!pair) return;
            var parts = pair.split(":");
            var id = parts[0];
            var qty = parseInt(parts[1], 10);
            if (id) map[id] = isNaN(qty) ? 0 : qty;
          });
          return map;
        }

        /* Is `nextSig` an ADD relative to `prevSig`? A new variant id, or a
           higher quantity for an existing one. Order-independent. */
        isAdd(prevSig, nextSig) {
          var prev = this.parseSig(prevSig);
          var next = this.parseSig(nextSig);
          for (var id in next) {
            if (!Object.prototype.hasOwnProperty.call(next, id)) continue;
            if (!(id in prev) || next[id] > prev[id]) return true;
          }
          return false;
        }

        /* Return-visit trigger. The controller keeps the cross-session record
           current on every page, but opens only when `canShow` is true. sessionStorage
           suppresses the session that built or changed the cart; localStorage limits
           the prompt to once per cart state within MAX_AGE_MS. */
        evaluate() {
          var sessionActive = this.sessionActive();
          var record = this.readRecord();
          var existedBefore = !!record; // a cross-session record BEFORE this load?
          var now = Date.now();
          var added = false;
          var hasItems = this.sig !== "";

          // --- Book-keeping: keep the cross-session record in sync wherever a cart
          //     exists (every page), so a returning shopper is recognised on the
          //     FIRST reopen rather than the second.
          if (hasItems) {
            if (!record) {
              record = { sig: this.sig, firstSeenAt: now, shown: false };
            } else {
              // Reconcile from the full server signature on every load. A larger
              // server sig on the first load of a session reflects prior-session cart
              // state, not a new in-session add; only active sessions may re-arm.
              if (sessionActive && record.sig && this.isAdd(record.sig, this.sig)) {
                record.shown = false; // reset-on-add -> eligible on a FUTURE session
                added = true;
              }
              record.sig = this.sig;
            }
            this.writeRecord(record);
          }

          // --- Show: only on a page that renders the overlay (Home/PLP/PDP + stock).
          if (!this.canShow) return;

          // An add detected on THIS load while the session is active suppresses the
          // popup for the CURRENT session and re-arms it for the next.
          if (added) {
            this.markSessionActive();
            return;
          }

          // Per-session gate: never show within the active session (including the
          // session the cart was added in) -- only a later session.
          if (sessionActive) return;
          this.markSessionActive();

          if (!existedBefore) return; // record first created THIS load = build session
          if (record.shown) return; // already shown for this cart state -> don't nag
          if (now - record.firstSeenAt > MAX_AGE_MS) return; // 14-day window

          record.shown = true;
          this.writeRecord(record);
          this.openOverlay();
        }

        openOverlay() {
          // Hold off while a PLP back-navigation restore is positioning: taking the
          // scroll-lock now pins the body and the restore's scroll-to-product becomes
          // a no-op, landing the shopper on the first page. Open once it signals done.
          if (window.__coveoPlpRestore) {
            var self = this;
            document.addEventListener(
              "coveo:plp-restore-done",
              function () {
                self.openOverlay();
              },
              { once: true },
            );
            return;
          }
          var overlay = this.querySelector("x-overlay");
          if (overlay && typeof overlay.open === "function") {
            overlay.open();
            return;
          }
          // The overlay base element may upgrade after this one; wait for it.
          if (customElements.whenDefined) {
            var self = this;
            customElements.whenDefined("x-overlay").then(function () {
              var el = self.querySelector("x-overlay");
              if (el && typeof el.open === "function") el.open();
            });
          }
        }

        /* cart:added fires before the cart drawer re-render. Seed storage and mark
           this session active immediately; the full signature is reconciled from
           cart:updated or the next server render. */
        onCartAdded() {
          var record = this.readRecord();
          if (!record) {
            record = { sig: "", firstSeenAt: Date.now(), shown: false };
          } else {
            record.shown = false; // an add -> re-arm for a FUTURE session
          }
          this.markSessionActive(); // build session -> suppress showing this session
          this.writeRecord(record);
        }

        /* Runtime cart changes keep storage in sync. Adds clear `shown` for a later
           session, while the current session stays suppressed. */
        onCartUpdated(event) {
          var cart = event.detail && event.detail.cart;
          if (!cart) return;

          /* Thin { item_count } payloads only happen on adds. They seed/re-arm the
             record and suppress the current session; the full signature is reconciled
             on the next full cart payload or server render. */
          if (!cart.items) {
            if (typeof cart.item_count === "number") {
              var liteRecord = this.readRecord();
              if (!liteRecord) {
                liteRecord = { sig: "", firstSeenAt: Date.now(), shown: false };
              } else {
                liteRecord.shown = false; // re-arm for a FUTURE session
              }
              this.markSessionActive(); // ...but suppress the CURRENT one
              this.writeRecord(liteRecord);
            }
            return;
          }

          var nextSig = cart.items
            .map(function (item) {
              return item.variant_id + ":" + item.quantity + ";";
            })
            .join("");

          var record = this.readRecord();
          if (!record) {
            record = { sig: nextSig, firstSeenAt: Date.now(), shown: false };
            this.markSessionActive(); // first add -> build session -> suppress it
            this.writeRecord(record);
          } else {
            if (record.sig && this.isAdd(record.sig, nextSig)) {
              record.shown = false; // re-arm for a FUTURE session...
              this.markSessionActive(); // ...but suppress the CURRENT one (no reshow this session)
            }
            record.sig = nextSig;
            this.writeRecord(record);
          }
          this.sig = nextSig;
        }
      },
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class XAnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll("[data-slide]"));
      this.toggle = this.querySelector("[data-toggle]");
      this.index = 0;
      this.paused = false;
      this.suspended = false;
      this.timer = null;
      this.frame = null;
      this.interval = parseInt(this.dataset.interval, 10) || 3000;
      this.reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      // Pause-on-hover/focus is only wired on hover-capable (non-touch) devices.
      // On touch, a tap fires an emulated mouseenter/focusin with no reliable
      // matching mouseleave/focusout, which would strand `suspended = true` and
      // stop rotation permanently after a manual slide interaction.
      // Touch devices keep auto-rotating; the explicit toggle still pauses.
      this.canHover = window.matchMedia("(hover: hover)").matches;

      if (this.slides.length <= 1 || this.reduceMotion) {
        if (this.toggle) this.toggle.hidden = true;
        return;
      }

      this.onToggle = this.togglePlay.bind(this);
      this.onEnter = this.suspend.bind(this);
      this.onLeave = this.unsuspend.bind(this);
      this.onVisibility = this.handleVisibility.bind(this);

      this.toggle.addEventListener("click", this.onToggle);
      if (this.canHover) {
        this.addEventListener("mouseenter", this.onEnter);
        this.addEventListener("mouseleave", this.onLeave);
        this.addEventListener("focusin", this.onEnter);
        this.addEventListener("focusout", this.onLeave);
      }
      document.addEventListener("visibilitychange", this.onVisibility);

      this.start();
    }

    disconnectedCallback() {
      this.stop();
      if (!this.toggle) return;
      this.toggle.removeEventListener("click", this.onToggle);
      if (this.canHover) {
        this.removeEventListener("mouseenter", this.onEnter);
        this.removeEventListener("mouseleave", this.onLeave);
        this.removeEventListener("focusin", this.onEnter);
        this.removeEventListener("focusout", this.onLeave);
      }
      document.removeEventListener("visibilitychange", this.onVisibility);
    }

    start() {
      // Idempotent: clear any pending tick/frame before (re)scheduling so timers
      // never stack and drift can't accumulate.
      this.stop();
      this.scheduleNext();
    }

    stop() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      // Cancel a pending commit barrier. If cancelled before phase 2 runs, the
      // entering slide is left parked at its start edge and the current slide
      // stays active -- a consistent state, never two-active or stranded.
      if (this.frame) {
        cancelAnimationFrame(this.frame);
        this.frame = null;
      }
    }

    scheduleNext() {
      this.timer = setTimeout(this.advance.bind(this), this.interval);
    }

    canRun() {
      return !this.paused && !this.suspended && !document.hidden;
    }

    suspend() {
      this.suspended = true;
      this.stop();
    }

    unsuspend() {
      this.suspended = false;
      if (this.canRun()) this.start();
    }

    handleVisibility() {
      if (document.hidden) {
        this.stop();
      } else if (this.canRun()) {
        this.start();
      }
    }

    togglePlay() {
      this.paused = !this.paused;
      this.toggle.setAttribute("aria-pressed", String(this.paused));
      this.toggle.setAttribute(
        "aria-label",
        this.paused ? this.toggle.dataset.labelPlay : this.toggle.dataset.labelPause,
      );
      if (this.paused) {
        this.stop();
      } else if (this.canRun()) {
        this.start();
      }
    }

    advance() {
      this.timer = null;
      this.show((this.index + 1) % this.slides.length);
      // Self-correcting chain: queue the next rotation only after the current one
      // is set up, so timer drift can't accumulate and a tick can't outrun the
      // previous transition (the interval far exceeds the roll duration).
      this.scheduleNext();
    }

    show(nextIndex) {
      const current = this.slides[this.index];
      const upcoming = this.slides[nextIndex];
      if (upcoming === current) return;

      // Phase 1 -- park the entering slide at its below-the-viewport start edge
      // (translateY(100%)) with its transition suppressed. A slide re-entering
      // from data-exiting sits above the bar (-100%); resetting it to the rest
      // edge must NOT animate, or it would roll down from the top. The reflow
      // commits the start position while the transition is off.
      upcoming.style.transition = "none";
      upcoming.removeAttribute("data-exiting");
      upcoming.removeAttribute("data-active");
      void upcoming.offsetWidth;
      upcoming.style.transition = "";

      // Phase 2 -- commit barrier. Only after the start edge has painted (a
      // double rAF, with the transition re-enabled) do we animate to active, so
      // the browser can never coalesce start + end into an instant jump. Every
      // rotation animates, every cycle -- including the two-slide case where the
      // re-entering slide is repositioned each tick.
      this.frame = requestAnimationFrame(() => {
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          current.removeAttribute("data-active");
          current.setAttribute("data-exiting", "");
          current.setAttribute("inert", "");
          upcoming.setAttribute("data-active", "");
          upcoming.removeAttribute("inert");
          this.index = nextIndex;
        });
      });
    }
  }

  if (!customElements.get("x-announcement-bar")) {
    customElements.define("x-announcement-bar", XAnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["callout-content-blocks"] && !Shopify.designMode) return;
  try {
    
  /* <x-callout-interleave> - overlays merchant-authored callout tiles onto the
     Coveo Atomic PLP product grid at configured positions (see the section
     comment for the architecture). */
  class XCalloutInterleave extends HTMLElement {
    connectedCallback() {
      this._alive = true; // cleared on disconnect so the async init can bail
      this.tiles = Array.prototype.slice
        .call(this.querySelectorAll("[data-callout-position]"))
        .map(function (el) {
          return {
            pos: parseInt(el.dataset.calloutPosition, 10),
            size: el.dataset.calloutSize,
            node: el,
          };
        })
        .filter(function (t) {
          return !isNaN(t.pos);
        })
        .sort(function (a, b) {
          return a.pos - b.pos;
        });
      if (!this.tiles.length) return;

      this.listSelector = this.dataset.listSelector || "atomic-commerce-product-list";
      // Wait for the Atomic product list AND the shared engine, both set
      // asynchronously by the PLP init. No-op (forever) off a Coveo PLP.
      this.waitFor(
        function () {
          return document.querySelector(this.listSelector) && window.__coveoEngine;
        }.bind(this),
        this.start.bind(this),
      );
    }

    waitFor(test, done, tries) {
      tries = tries || 0;
      if (!this._alive) return; // disconnected while polling - stop rescheduling
      if (test()) {
        done();
        return;
      }
      if (tries > 100) return; // ~10s, then give up (not a Coveo PLP / proxy down)
      this._pollTimer = setTimeout(
        function () {
          this.waitFor(test, done, tries + 1);
        }.bind(this),
        100,
      );
    }

    async start() {
      this.productList = document.querySelector(this.listSelector);
      try {
        const mod =
          await import("https://static.cloud.coveo.com/shopify/v1/headless/commerce.esm.js");
        if (typeof mod.buildProductListing !== "function") return;
        if (!this._alive) return; // disconnected during the dynamic import
        // A SECOND product-listing controller over the SAME engine = a pure
        // observer on the store Atomic already drives (addReducers is idempotent).
        this.controller = mod.buildProductListing(window.__coveoEngine);
      } catch (e) {
        return; // module/engine unavailable; leave the tiles hidden
      }

      this.container =
        document.querySelector(this.dataset.overlayTarget || ".coveo-results") ||
        this.productList.parentElement;
      if (!this.container) return;
      if (getComputedStyle(this.container).position === "static") {
        this.container.style.position = "relative";
        this._setContainerPosition = true;
      }

      this.overlay = document.createElement("div");
      this.overlay.className = "coveo-callout-overlay";
      this.container.appendChild(this.overlay);
      this.tiles.forEach(
        function (t) {
          this.overlay.appendChild(t.node);
        }.bind(this),
      );

      this.unsubscribe = this.controller.subscribe(this.onTick.bind(this));
      this.onTick();

      this._onResize = this.place.bind(this);
      window.addEventListener("resize", this._onResize, { passive: true });

      // Coveo serializes the cards into Shadow DOM after the state tick, and
      // each cell's height keeps growing as its product image loads. A ResizeObserver
      // on the product-list host re-places the tiles whenever the grid reaches (or
      // changes) its real geometry; without it the first place() can measure
      // 0-height cells and collapse every tile to nothing.
      if (typeof ResizeObserver === "function") {
        this._ro = new ResizeObserver(
          function () {
            this.place();
          }.bind(this),
        );
        this._ro.observe(this.productList);
      }
    }

    onTick() {
      const s = this.controller && this.controller.state;
      // Skip ONLY the setView/setContext reset tick (no responseId yet) emitted
      // before a refetch fulfils - NOT a legitimate zero-results response (valid
      // responseId, products:[]), which must reach place() so the overlay hides
      // over the empty grid rather than leaving stale tiles floating.
      if (!s || !s.responseId || !s.products) return;
      this.productCount = s.products.length;
      this.place();
      // Cards lay out after this tick, so schedule one RAF pass to catch the real
      // cell geometry; the ResizeObserver keeps it in sync.
      var self = this;
      requestAnimationFrame(function () {
        self.place();
      });
    }

    place() {
      if (!this.overlay || !this.productList) return;
      const root =
        this.productList.shadowRoot &&
        this.productList.shadowRoot.querySelector('[part="result-list"]');
      if (!root || !root.children.length) {
        this.overlay.style.display = "none";
        return;
      }
      this.overlay.style.display = "block";

      // The real grid cells: each child of [part=result-list] is one product card.
      // Snapping tiles to these measured rects (not a reconstructed CSS grid) is what
      // keeps a tile aligned to whole cells with no peek-through of the card beneath.
      const cards = root.children;
      const cardCount = cards.length;
      const contRect = this.container.getBoundingClientRect();
      const rootRect = root.getBoundingClientRect();
      const gcs = getComputedStyle(root);
      const cols = gcs.gridTemplateColumns.split(" ").filter(Boolean).length || 1;
      const isMobile = window.matchMedia("(max-width: 768px)").matches;

      this.tiles.forEach(
        function (t) {
          const node = t.node;
          const idx0 = t.pos - 1; // 1-based slot -> 0-based card index
          // Defer a tile whose slot has not loaded yet (out of range / pre-load-more).
          if (idx0 < 0 || idx0 >= cardCount) {
            node.style.display = "none";
            return;
          }

          const span = t.size === "large" ? 2 : 1;
          const rowIdx = Math.floor(idx0 / cols);

          if (isMobile) {
            // Mobile: every size covers the FULL grid width at the slot's row -
            // one full-width editorial tile, the height of one card.
            const firstInRow = cards[rowIdx * cols] || cards[idx0];
            const rowRect = firstInRow.getBoundingClientRect();
            if (!rowRect.height) {
              node.style.display = "none";
              return;
            }
            node.style.display = "";
            node.style.left = rootRect.left - contRect.left + "px";
            node.style.top = rowRect.top - contRect.top + "px";
            node.style.width = rootRect.width + "px";
            node.style.height = rowRect.height + "px";
            return;
          }

          // Wide (full-width band): cover EVERY column at the slot's row - a
          // landscape editorial band the height of one product row (the
          // "Split Image Hero" disruptor). Desktop/tablet only; mobile already
          // collapsed to full width above.
          if (t.size === "wide") {
            const firstInRow = cards[rowIdx * cols];
            if (!firstInRow) {
              node.style.display = "none";
              return;
            }
            const rowRect = firstInRow.getBoundingClientRect();
            if (!rowRect.height) {
              node.style.display = "none";
              return;
            }
            node.style.display = "";
            node.style.left = rootRect.left - contRect.left + "px";
            node.style.top = rowRect.top - contRect.top + "px";
            node.style.width = rootRect.width + "px";
            node.style.height = rowRect.height + "px";
            return;
          }

          // Desktop/tablet: clamp a large (span-2) tile so its 2-wide block stays
          // inside the grid - a tile in the last column shifts one column left.
          let colIdx = idx0 % cols;
          if (colIdx + span > cols) colIdx = cols - span;
          if (colIdx < 0) colIdx = 0;

          const tlCard = cards[rowIdx * cols + colIdx];
          if (!tlCard) {
            node.style.display = "none";
            return;
          }
          const tlRect = tlCard.getBoundingClientRect();
          // Not laid out yet (height 0): defer this pass; the ResizeObserver /
          // deferred re-place shows the tile once the cell has real height.
          if (!tlRect.height) {
            node.style.display = "none";
            return;
          }

          // Cover the exact cell(s). A large tile spans a 2x2 block, so it needs the
          // bottom-right card of that block present in the loaded grid to measure the
          // exact union of the four cells.
          let width = tlRect.width;
          let height = tlRect.height;
          if (span > 1) {
            const brCard = cards[(rowIdx + span - 1) * cols + (colIdx + span - 1)];
            // If that cell is not in the grid (the grid is too short - a small
            // collection, or before load-more reveals more rows), DEFER the tile
            // rather than estimate a 2-row height off one cell: that estimate
            // overshoots the last row and spills the tile past the grid into the
            // content below (the footer). Deferring matches the out-of-range rule
            // for the anchor cell, applied to the large tile's full 2x2 footprint -
            // the tile reappears once its four cells exist.
            if (!brCard) {
              node.style.display = "none";
              return;
            }
            const brRect = brCard.getBoundingClientRect();
            if (!brRect.height) {
              node.style.display = "none";
              return;
            }
            width = brRect.right - tlRect.left;
            height = brRect.bottom - tlRect.top;
          }

          node.style.display = "";
          node.style.left = tlRect.left - contRect.left + "px";
          node.style.top = tlRect.top - contRect.top + "px";
          node.style.width = width + "px";
          node.style.height = height + "px";
        }.bind(this),
      );
    }

    disconnectedCallback() {
      // Mark dead + cancel any in-flight poll FIRST, so a disconnect mid-init
      // (theme-editor re-render during the waitFor poll or the dynamic import)
      // can't complete start() on a detached element and leak an overlay +
      // subscription. The guards in waitFor()/start() honour this flag.
      this._alive = false;
      if (this._pollTimer) clearTimeout(this._pollTimer);
      if (this.unsubscribe) this.unsubscribe();
      if (this._ro) this._ro.disconnect();
      if (this._onResize) window.removeEventListener("resize", this._onResize);
      if (this.overlay) this.overlay.remove();
      if (this._setContainerPosition && this.container) {
        this.container.style.position = "";
      }
    }
  }

  if (!customElements.get("x-callout-interleave")) {
    customElements.define("x-callout-interleave", XCalloutInterleave);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    /* Document-level singleton (mirrors overlay / shop-the-look): one cart
       runtime backs every page. The guard keeps it single-init across
       shopify:section:load in the editor; all listeners are delegated on
       `document`, so they survive the SRA swaps this runtime performs. */
    if (window.__seedCartRuntimeInit) return;
    window.__seedCartRuntimeInit = true;

    var QTY_DEBOUNCE_MS = 250;

    /* ---- routes / discovery ---- */

    function routeRoot() {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        return window.Shopify.routes.root;
      }
      return "/";
    }

    function drawerHost() {
      return document.querySelector('x-overlay[data-overlay-id="cart-drawer"]');
    }

    /* Read the id off the rendered .shopify-section wrapper and strip the prefix
       -- never hardcode a section id. */
    function sectionIdFromEl(el) {
      var section = el ? el.closest(".shopify-section") : null;
      if (!section || !section.id) return null;
      return section.id.replace(/^shopify-section-/, "");
    }

    /* Always the global drawer section; plus the /cart main section ONLY when
       it is on the page (its inner div carries .shopify-section--cart). */
    function discoverSections() {
      var ids = [];
      var drawerId = sectionIdFromEl(drawerHost());
      if (drawerId) ids.push(drawerId);
      var cartInner = document.querySelector(".shopify-section--cart");
      var cartId = sectionIdFromEl(cartInner);
      if (cartId && ids.indexOf(cartId) === -1) ids.push(cartId);
      return { ids: ids, drawerId: drawerId, cartId: cartId };
    }

    function parseHTML(html) {
      return new DOMParser().parseFromString(html, "text/html");
    }

    /* The bundled add round-trip is cart/add.js WITH bundled sections, whose
       response is { items, sections } ONLY -- it does NOT carry cart.item_count
       (unlike change.js / update.js which return the full cart). So the
       render-then-show add path reads the count off the freshly-rendered drawer
       section instead: the heading hook stamps cart.item_count in
       [data-cart-item-count]. Returns null when the drawer section or hook is
       absent (older cached markup), so onAdded can fall back to the two-trip
       refresh rather than zero the badge. */
    function countFromSections(sections, ctx) {
      if (!sections || !ctx.drawerId || sections[ctx.drawerId] == null) return null;
      var el = parseHTML(sections[ctx.drawerId]).querySelector("[data-cart-item-count]");
      if (!el) return null;
      var n = parseInt(el.getAttribute("data-cart-item-count"), 10);
      return isNaN(n) ? null : n;
    }

    /* ---- status / busy + per-line in-flight ---- */

    function statusEls() {
      return document.querySelectorAll("[data-cart-status]");
    }

    function setBusy(on) {
      var els = statusEls();
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (on) {
          el.removeAttribute("data-cart-state");
          el.textContent = el.getAttribute("data-busy-msg") || "";
        } else if (el.getAttribute("data-cart-state") !== "error") {
          el.textContent = "";
        }
      }
    }

    /* Show the server's actionable `description` when a rejection carries one
       (postCart's parsed 422 body), else fall back to the static cart.error
       string stamped on [data-error-msg]. */
    function setError(message) {
      var els = statusEls();
      for (var i = 0; i < els.length; i++) {
        els[i].setAttribute("data-cart-state", "error");
        els[i].textContent = message || els[i].getAttribute("data-error-msg") || "";
      }
    }

    /* Pull the human message off a rejected cart response: the AJAX cart errors
       carry `description` (the actionable line); anything without one (a raw
       Response, a network error) yields null so setError falls back. */
    function errMessage(err) {
      if (
        err &&
        typeof err === "object" &&
        typeof err.description === "string" &&
        err.description
      ) {
        return err.description;
      }
      return null;
    }

    /* Find live lines by stable data-line-id, not position or key. Positions shift
       after removals, keys regenerate under discounts, and matching in JS avoids
       CSS selector escaping for property-derived ids. Both cart page and drawer
       lines share the id, so all visible copies are returned. */
    function lineEls(lineId) {
      if (!lineId) return [];
      /* Merged bundle groups carry the parent line's stable data-line-id/data-line-index,
         so they resolve like single cart lines. */
      var all = document.querySelectorAll(
        "x-cart-line-item[data-line-id], [data-bundle-group][data-line-id]",
      );
      var out = [];
      for (var i = 0; i < all.length; i++) {
        if (all[i].getAttribute("data-line-id") === lineId) out.push(all[i]);
      }
      return out;
    }

    /* A merged bundle parent's CURRENT 1-based position, resolved LIVE from the DOM at
       call time. Returns null when it is no longer present (already removed). Standard
       product rows are addressed by their live line-item keys instead (see rowKeys): a row
       covers several cart lines, and a position addresses just one of them. */
    function indexForLineId(lineId) {
      var els = lineEls(lineId);
      return els.length ? Number(els[0].getAttribute("data-line-index")) : null;
    }

    function setLineBusy(lineId, on) {
      var els = lineEls(lineId);
      for (var i = 0; i < els.length; i++) {
        if (on) els[i].setAttribute("aria-busy", "true");
        else els[i].removeAttribute("aria-busy");
      }
    }

    /* Undo the stepper's optimistic commit when its qty change is rejected: the
       line is NOT re-rendered on failure, so without this the picker keeps the
       value the server refused. Calls the quantity-picker's own revert() (no
       re-dispatch), keeping the component self-contained. */
    function revertQty(lineId) {
      var els = lineEls(lineId);
      for (var i = 0; i < els.length; i++) {
        var picker = els[i].querySelector("x-quantity-picker");
        if (picker && typeof picker.revert === "function") picker.revert();
      }
    }

    /* ---- counts (live OUTSIDE the swapped regions -> set directly) ---- */

    /* Cart-page recommendations sit outside swapped regions and are not rediscovered
       for static collection re-renders, so remove-to-empty toggles visibility from
       cart.item_count. Server renders them filled-only; empty->filled from an empty
       cart page waits for reload because there is no add surface there. */
    function togglePageRecs(count) {
      var recs = document.querySelectorAll(".shopify-section--cart-recommendations");
      for (var i = 0; i < recs.length; i++) {
        if (count > 0) recs[i].removeAttribute("hidden");
        else recs[i].setAttribute("hidden", "");
      }
    }

    /* The last count painted into the badge/heading, kept current on every apply
       path. onAdded reads it to drop a stale, out-of-order add response that
       would move the count backwards. */
    var lastShownCount = -1;

    /* The last count the SERVER reported, before optimistic adjustment. A render is
       answered against the cart as the server knows it, which still counts every line
       whose removal has only been painted, so the paint subtracts those -- and the
       un-adjusted figure has to be kept to subtract from again as further removals
       queue up behind it. */
    var lastServerCount = -1;

    /* The `cart.item_count` stamped on the drawer heading by the page render: the
       starting truth before any mutation. The runtime never rewrites the attribute
       (the heading lives outside every swapped region, and its TEXT is what the paint
       rewrites), so it stands in until a response supplies a count. */
    function seededCount() {
      var el = document.querySelector("[data-cart-item-count]");
      var n = el ? parseInt(el.getAttribute("data-cart-item-count"), 10) : NaN;
      return isNaN(n) ? -1 : n;
    }

    function updateCounts(cart) {
      lastServerCount = cart && typeof cart.item_count === "number" ? cart.item_count : 0;
      paintCounts();
    }

    function paintCounts() {
      var base = lastServerCount >= 0 ? lastServerCount : seededCount();
      if (base < 0) return; // no trustworthy figure to paint from yet
      var count = Math.max(0, base - droppedQuantity());
      lastShownCount = count;

      togglePageRecs(count);

      var badges = document.querySelectorAll("[data-cart-count]");
      for (var i = 0; i < badges.length; i++) {
        badges[i].textContent = count;
        if (count > 0) badges[i].removeAttribute("hidden");
        else badges[i].setAttribute("hidden", "");
      }

      var headings = document.querySelectorAll("[data-cart-heading-count]");
      for (var j = 0; j < headings.length; j++) {
        var h = headings[j];
        if (count > 0) {
          var tpl = h.getAttribute("data-count-template") || "Cart ([count])";
          h.textContent = tpl.replace("[count]", count);
        } else {
          h.textContent = h.getAttribute("data-empty-label") || "Cart";
        }
      }
    }

    /* ---- reconcile: patch the live DOM into the server's shape ----
     * A mutation re-renders whole sections, but REPLACING a region re-creates
     * every line the shopper did not touch: thumbnails re-decode, custom elements
     * re-boot, the wishlist heart re-resolves and the progress bars snap to their
     * new value instead of animating to it. That is the flash. So the fresh markup
     * is patched INTO the live nodes: rows are matched by their stable line id, and
     * only what actually differs is written.
     *
     * OPAQUE elements opt out: they derive JS state from their markup when they are
     * constructed (the stepper's revert target and min/max, the wishlist button's
     * product + representative variant), and patching their attributes underneath
     * would leave that state stale. They are replaced whole so their
     * connectedCallback re-reads it -- which is also how the heart recovers the
     * saved state the server render does not know (it re-syncs from SWYM on
     * connect). Identical markup never reaches this branch at all. */

    var MORPH_OPAQUE = "x-quantity-picker,x-size-select,x-wishlist-button";
    var MORPH_KEYED = "[data-line-id],[data-bundle-group]";

    /* A node's identity for sibling matching: the stable line id of the line it
       renders, else its tag name. Only the node itself and its FIRST element child
       (the `<li>` wrapper case) are inspected -- an ancestor must never inherit a
       descendant's id, or removing the first line would make the whole list read as
       a different node and get replaced wholesale. */
    function morphId(node) {
      if (node.nodeType !== 1) return node.nodeName;
      var keyed = null;
      if (node.matches(MORPH_KEYED)) {
        keyed = node;
      } else if (node.firstElementChild && node.firstElementChild.matches(MORPH_KEYED)) {
        keyed = node.firstElementChild;
      }
      if (!keyed) return node.nodeName;
      return (
        keyed.getAttribute("data-line-id") ||
        keyed.getAttribute("data-bundle-group") ||
        node.nodeName
      );
    }

    /* The collapse of a removed row is the RUNTIME's state, not the render's: a render
       still carrying the line was answered before the server was told about it, so
       patching these attributes would put the row back on screen. They are held until
       the removal is released -- after which the render governs again, which is how a
       REJECTED removal restores the row. */
    var RUNTIME_OWNED = /^(?:data-line-dropping|inert|style)$/;

    function syncAttrs(live, fresh) {
      var i;
      var keep = live.hasAttribute("data-line-dropping") && !!removedLines[morphId(live)];
      for (i = live.attributes.length - 1; i >= 0; i--) {
        var name = live.attributes[i].name;
        if (keep && RUNTIME_OWNED.test(name)) continue;
        if (!fresh.hasAttribute(name)) live.removeAttribute(name);
      }
      for (i = 0; i < fresh.attributes.length; i++) {
        var attr = fresh.attributes[i];
        if (keep && RUNTIME_OWNED.test(attr.name)) continue;
        if (live.getAttribute(attr.name) !== attr.value) live.setAttribute(attr.name, attr.value);
      }
    }

    function morph(live, fresh) {
      if (live.isEqualNode(fresh)) return; // identical subtree -> do not touch it at all
      if (live.nodeType === 3) {
        live.nodeValue = fresh.nodeValue;
        return;
      }
      if (live.nodeType !== 1 || live.nodeName !== fresh.nodeName || live.matches(MORPH_OPAQUE)) {
        live.replaceWith(fresh);
        return;
      }
      syncAttrs(live, fresh);
      morphChildren(live, fresh);
    }

    function idIndexOf(nodes, from, id) {
      for (var i = from; i < nodes.length; i++) {
        if (morphId(nodes[i]) === id) return i;
      }
      return -1;
    }

    /* Whitespace-only text between markup lines is the separator that arrived WITH
       the node beside it, so it leaves and arrives with it. Dropping a row and
       keeping its separator leaves the two child lists one node out of step, which
       pairs every later row with the wrong counterpart. Inline whitespace that does
       carry meaning (the space between a sale price and its struck compare) is
       matched as an ordinary node, never skipped. */
    function isSeparator(node) {
      return !!node && node.nodeType === 3 && !/\S/.test(node.nodeValue);
    }

    /* Two cursors over snapshots of both child lists, paired by morphId. A node
       present on one side only is dropped or inserted rather than paired with an
       unrelated sibling -- otherwise one removed line (or a snippet that renders
       nothing this time, e.g. gwp-progress past its threshold) shifts every later
       node onto the wrong counterpart and re-creates the whole list. */
    function morphChildren(live, fresh) {
      var liveKids = [].slice.call(live.childNodes);
      var freshKids = [].slice.call(fresh.childNodes);
      var l = 0;
      var f = 0;
      while (l < liveKids.length || f < freshKids.length) {
        var liveKid = liveKids[l];
        var freshKid = freshKids[f];
        if (!freshKid) {
          liveKid.remove();
          l++;
        } else if (
          removedLines[morphId(freshKid)] &&
          idIndexOf(liveKids, l, morphId(freshKid)) === -1
        ) {
          /* A line the shopper has removed, still rendered because the server had not
             been told when this render was asked for, and no longer on screen: the
             reconcile must never bring it back. Skipped only when it has no live row
             left to pair with -- the row it was collapsed in is still reindexed by the
             ordinary pairing below. */
          f++;
          if (isSeparator(freshKids[f])) f++;
        } else if (!liveKid) {
          live.appendChild(freshKid);
          f++;
        } else if (morphId(liveKid) === morphId(freshKid)) {
          morph(liveKid, freshKid);
          l++;
          f++;
        } else if (idIndexOf(freshKids, f + 1, morphId(liveKid)) === -1) {
          liveKid.remove();
          l++;
          if (isSeparator(liveKids[l])) {
            liveKids[l].remove();
            l++;
          }
        } else {
          live.insertBefore(freshKid, liveKid);
          f++;
          if (isSeparator(freshKids[f])) {
            live.insertBefore(freshKids[f], liveKid);
            f++;
          }
        }
      }
    }

    /* ---- DOM swaps (dialog root stays stable; focus/scroll preserved) ---- */

    function swapRegion(scope, doc, region) {
      var live = scope.querySelector('[data-cart-region="' + region + '"]');
      var fresh = doc.querySelector('[data-cart-region="' + region + '"]');
      if (live && fresh) morph(live, fresh);
    }

    /* Drawer: never touch .overlay__header or the <dialog> itself. Reconcile the
       items region inside .overlay__content (restoring its scroll), then
       .overlay__footer -- which overlay omits ENTIRELY when empty, so that branch is
       also the empty<->filled footer add/remove. */
    function swapDrawer(doc) {
      var host = drawerHost();
      var liveDialog = host ? host.querySelector("dialog.overlay") : null;
      /* Limit the fresh-doc lookup to the cart drawer's own x-overlay. This section
         also renders sibling dialogs, so a plain dialog lookup can grab the wrong
         overlay and leave the drawer stale. */
      var newHost = doc.querySelector('x-overlay[data-overlay-id="cart-drawer"]');
      var newDialog = newHost ? newHost.querySelector("dialog.overlay") : null;
      if (!liveDialog || !newDialog) return;

      var liveContent = liveDialog.querySelector(".overlay__content");
      var liveItems = liveDialog.querySelector('[data-cart-region="drawer-items"]');
      var newItems = newDialog.querySelector('[data-cart-region="drawer-items"]');
      var scrollTop = liveContent ? liveContent.scrollTop : 0;

      /* Preserve keyboard focus across the swap (the qty stepper is the realistic
         case): remember the focused control's line + action, restore the
         equivalent control after the new items are in. */
      var active = document.activeElement;
      var refocus = null;
      if (active && liveItems && liveItems.contains(active)) {
        var line = active.closest("x-cart-line-item");
        if (line) {
          refocus = {
            lineId: line.getAttribute("data-line-id"),
            action: active.getAttribute("data-action"),
          };
        }
      }

      if (liveItems && newItems) morph(liveItems, newItems);
      if (liveContent) liveContent.scrollTop = scrollTop;

      if (refocus && refocus.lineId) {
        // Match by STABLE id, not position -- the same line keeps its id across a qty
        // re-render even though its key regenerates and its index may shift.
        var newLine = null;
        var candidates = liveDialog.querySelectorAll("x-cart-line-item[data-line-id]");
        for (var ci = 0; ci < candidates.length; ci++) {
          if (candidates[ci].getAttribute("data-line-id") === refocus.lineId) {
            newLine = candidates[ci];
            break;
          }
        }
        if (newLine) {
          var target = null;
          if (refocus.action)
            target = newLine.querySelector('[data-action="' + refocus.action + '"]');
          if (!target || target.disabled)
            target = newLine.querySelector("[data-action]:not([disabled])");
          if (target) target.focus();
        }
      }

      var liveFooter = liveDialog.querySelector(".overlay__footer");
      var newFooter = newDialog.querySelector(".overlay__footer");
      if (newFooter && liveFooter) morph(liveFooter, newFooter);
      else if (newFooter && !liveFooter) liveDialog.appendChild(newFooter);
      else if (!newFooter && liveFooter) liveFooter.remove();
    }

    /* /cart page: no dialog to preserve. The empty state renders OUTSIDE any
       [data-cart-region] (a direct child of .cart), so an empty<->filled flip is
       a whole-section innerHTML swap; a filled->filled change is a region swap. */
    function swapPage(doc, sectionId) {
      var wrapper = document.getElementById("shopify-section-" + sectionId);
      if (!wrapper) return;
      var liveFilled = !!wrapper.querySelector('[data-cart-region="page"]');
      var newFilled = !!doc.querySelector('[data-cart-region="page"]');
      if (liveFilled !== newFilled) {
        var newWrap = doc.querySelector(".shopify-section");
        var y = window.scrollY;
        wrapper.innerHTML = newWrap ? newWrap.innerHTML : doc.body ? doc.body.innerHTML : "";
        window.scrollTo(0, y);
      } else if (liveFilled && newFilled) {
        swapRegion(wrapper, doc, "page-items");
        swapRegion(wrapper, doc, "page-summary");
      }
    }

    /* Apply a cart state: swap whatever sections came back, sync the counts, and
       fan out ONE cart:updated. `sections` is the {id: html} map (from the cart
       route response's .sections, or the SRA GET body). */
    function applyState(cart, sections, ctx, opts) {
      if (sections) {
        if (ctx.drawerId && sections[ctx.drawerId] != null) {
          swapDrawer(parseHTML(sections[ctx.drawerId]));
        }
        if (ctx.cartId && sections[ctx.cartId] != null) {
          swapPage(parseHTML(sections[ctx.cartId]), ctx.cartId);
        }
      }
      updateCounts(cart);
      /* The add paths pass deferBroadcast: their `cart` is count-only (add returns no
         cart), so they paint from it and then broadcastCart() emits ONE cart:updated
         carrying server truth. Every other path already holds a full cart. */
      if (opts && opts.deferBroadcast) return;
      emitUpdated(cart);
    }

    /* ---- cart:updated broadcast ----
     * Add responses do not include a full cart, so the add paths paint count-only
     * state first, then read server truth once here. Reads are coalesced: one in
     * flight, one trailing read if more adds settle meanwhile. */
    var broadcastInflight = false;
    var broadcastPending = false;

    function emitUpdated(cart) {
      document.dispatchEvent(
        new CustomEvent("cart:updated", {
          bubbles: true,
          detail: { cart: cart },
        }),
      );
    }

    function broadcastCart() {
      if (broadcastInflight) {
        broadcastPending = true;
        return;
      }
      broadcastInflight = true;
      /* Failure fallback: the deferred add paths emit NO other cart:updated, so a failed
         read must still signal consumers. Emit the legacy { item_count } shape -- every
         consumer already copes with it (gift-with-purchase guards Array.isArray(cart.items)
         and refetches; coveo-cart-sync refetches unconditionally), so the signal self-heals
         where silence would leave the engine cart / GWP / recs stale. */
      function emitFallback() {
        emitUpdated({ item_count: lastShownCount < 0 ? 0 : lastShownCount });
      }
      fetchCart()
        .then(function (cart) {
          updateCounts(cart);
          emitUpdated(cart);
        })
        .catch(emitFallback)
        .then(function () {
          broadcastInflight = false;
          if (broadcastPending) {
            broadcastPending = false;
            broadcastCart();
          }
        });
    }

    /* ---- fetch helpers ---- */

    function postCart(endpoint, body) {
      return fetch(routeRoot() + "cart/" + endpoint + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(body),
      }).then(function (res) {
        if (res.ok) return res.json();
        /* Failure: parse the cart AJAX error body ({ status, message, description })
           and reject WITH it, so callers can surface Shopify's actionable message
           (e.g. an over-stock 422: "You can only add N of this item..."). If the
           body isn't JSON, reject with the raw Response -- callers see no
           `description` and fall back to the generic cart.error string. */
        return res.json().then(
          function (data) {
            return Promise.reject(data);
          },
          function () {
            return Promise.reject(res);
          },
        );
      });
    }

    /* Re-render the cart surfaces through the cart AJAX API's `sections` param --
       NOT the GET `?sections=` Section Rendering API.

       Why: the cart-drawer is a header section-GROUP section. The GET SRA renders
       group sections only against the index path; requested against any other page
       it returns an EMPTY string -- so an add fired from a non-cart page got an
       empty drawer section and swapDrawer bailed. The cart AJAX endpoints
       (change.js / update.js) instead render BOTH the /cart main section and the
       global drawer in one response. `sections_url` is pinned to the cart route so
       both always render in a context that contains them, whatever page the
       shopper is on. */
    function cartSectionsBody(ctx, body) {
      body = body || {};
      if (ctx.ids.length) {
        body.sections = ctx.ids.join(",");
        body.sections_url = routeRoot() + "cart";
      }
      return body;
    }

    /* Write line quantities in ONE request, keyed by line-item key: change.js for a
       single line, update.js for two or more.

       A round is never split across requests. A line-item key is a hash of the line
       INCLUDING its discount allocations, and any write can re-allocate a discount --
       so the first call of a multi-call round regenerates the keys the later calls were
       going to use, and change.js answers a key it cannot resolve with 400 "no valid id
       or line parameter". update.js takes the whole map, applies it against the
       pre-update cart and re-splits the buckets itself, so no key in the round can go
       stale. (Multiple line keys reach here whenever a quantity-tiered discount splits
       one variant across cart lines, or a removal round covers several rows.)

       Endpoint choice by size, not preference: change.js is the one cart mutation whose
       quantity DECREASES emit the storefront's product_removed_from_cart pixel event --
       update.js decreases emit nothing, leaving them invisible to every pixel-fed
       integration (Braze et al.), while increases emit product_added_to_cart from
       either. Single-line writes -- every undiscounted row's quantity change and
       removal -- therefore stay on change.js, and only a multi-line round trades that
       event for a write that cannot corrupt the cart.

       The section render is bundled into the request when asked for. Resolves with the
       resulting cart; null for an empty list. */
    function changeLines(entries, ctx, withSections) {
      if (!entries.length) return Promise.resolve(null);
      if (entries.length === 1) {
        var one = { id: entries[0].key, quantity: entries[0].quantity };
        return postCart("change", withSections ? cartSectionsBody(ctx, one) : one);
      }
      var updates = {};
      for (var i = 0; i < entries.length; i++) updates[entries[i].key] = entries[i].quantity;
      var many = { updates: updates };
      return postCart("update", withSections ? cartSectionsBody(ctx, many) : many);
    }

    /* Fallback re-render (un-bundled add only). When a producer POSTs cart/add.js
       WITHOUT bundling sections, cart:added carries no section HTML, so this no-op
       update.js carrying the `sections` request returns the cart plus freshly
       rendered sections in one round-trip (a plain cart.js GET would refresh the
       count but not the section HTML). The bundled add path (onAdded) skips this
       -- it renders from the add response itself. */
    function refreshFromServer() {
      var ctx = discoverSections();
      return postCart("update", cartSectionsBody(ctx)).then(function (cart) {
        applyState(cart, cart.sections, ctx);
        return cart;
      });
    }

    /* refreshFromServer with the same error handling as the primary mutation path: a
       "line already gone" fallback still round-trips, so if THAT read fails the shopper
       must see an error (and the line's busy state cleared) rather than a silent stale
       drawer + an unhandled rejection. */
    function refreshOrError(lineId) {
      return refreshFromServer().catch(function (err) {
        if (lineId) setLineBusy(lineId, false);
        setError(errMessage(err));
      });
    }

    /* ---- drawer open (reuse overlay's API + shop-the-look's path) ---- */

    function openCartDrawer() {
      var host = drawerHost();
      if (host && typeof host.open === "function") {
        host.open();
        return;
      }
      var trigger = document.querySelector('[data-overlay-trigger="cart-drawer"]');
      if (trigger) trigger.click();
    }

    /* ---- pending add stand-in ----
     * A dimmed copy of the real product appears when the add POST starts, then the
     * server-rendered line replaces it with the swapped drawer-items region.
     * clearPendingLine handles the paths where no swap happens: failed adds and the
     * burst safety net.
     *
     * It intentionally is not x-cart-line-item and has no data-line-id, so line lookup
     * can never treat it as an addressable cart line. */
    var pendingEmptyRegion = null; // the region we un-emptied, so failure can restore it

    /* Rebuild the real line's price markup from the producer's already-formatted money
       strings, so the stand-in carries the same classes and the same sale treatment as the
       line that replaces it.

       `preview.price` / `preview.compareAt` are already-formatted PER-UNIT money strings,
       so they cannot be multiplied out client-side.

       Known limit: the real row shows the group's line TOTAL, and an automatic discount
       cannot be known client-side, so a multi-unit or discounted add shows the per-unit
       undiscounted figure for the length of the round-trip, then the real row lands. */
    function priceMarkup(preview) {
      function esc(s) {
        return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
          return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
        });
      }
      if (!preview.price) return "";
      /* Line and bundle-group share one sale markup, differing only in the class prefix. */
      var prefix = preview.kind === "bundle" ? "cart-bundle-group__" : "cart-line-item__";
      if (preview.compareAt) {
        /* The single space matches the whitespace between these two inline elements in the real
           markup -- without it the figures butt together. */
        return (
          '<span class="' +
          prefix +
          'price-sale text-body-sm">' +
          esc(preview.price) +
          "</span>" +
          ' <s class="' +
          prefix +
          'price-compare text-body-sm">' +
          esc(preview.compareAt) +
          "</s>"
        );
      }
      /* Non-sale: a bundle group has no `__price-current` element -- its price is flat text. */
      if (preview.kind === "bundle") return esc(preview.price);
      return (
        '<span class="cart-line-item__price-current text-body-sm">' + esc(preview.price) + "</span>"
      );
    }

    /* Prefer an already decoded image candidate for the same CDN asset, so the
       pending line does not trigger a cold request. Producers send a canonical
       image_url, but the page may have decoded a different srcset width; matching
       by CDN path reuses that warm candidate and falls back to the supplied URL. */
    function warmImageUrl(url) {
      if (!url) return "";
      /* Compare PATHNAME, not the raw string: Liquid's `image_url` emits a protocol-relative
         URL ("//shop.myshopify.com/cdn/...") while `currentSrc` is absolute ("https://..."),
         so a plain string compare never matches and silently falls back to the cold URL. */
      function pathOf(u) {
        try {
          return new URL(u, window.location.href).pathname;
        } catch (e) {
          return "";
        }
      }
      var want = pathOf(url);
      if (!want) return url;
      var imgs = document.querySelectorAll("img");
      for (var i = 0; i < imgs.length; i++) {
        var cur = imgs[i].currentSrc;
        if (cur && imgs[i].complete && imgs[i].naturalWidth > 0 && pathOf(cur) === want) {
          return cur;
        }
      }
      return url;
    }

    function pendingRegion() {
      var host = drawerHost();
      var dialog = host ? host.querySelector("dialog.overlay") : null;
      return dialog ? dialog.querySelector('[data-cart-region="drawer-items"]') : null;
    }

    function showPendingLine(preview) {
      var host = drawerHost();
      /* A bundle is grouped into ONE cart-bundle-group presentation, not a cart line, so it
         gets its own stand-in template -- using the line template would show something
         structurally different from what replaces it. */
      var tplSel =
        preview.kind === "bundle"
          ? "[data-cart-pending-bundle-template]"
          : "[data-cart-pending-template]";
      var tpl = host ? host.querySelector(tplSel) : null;
      var region = pendingRegion();
      if (!tpl || !tpl.content || !region) return;

      clearPendingLine(); // a rapid second add replaces the stand-in rather than stacking them

      var node = tpl.content.firstElementChild.cloneNode(true);

      var img = node.querySelector("[data-pending-image]");
      if (img && preview.image) {
        img.src = warmImageUrl(preview.image); // an already-decoded candidate -> no pop-in
        img.alt = ""; // decorative: the title beside it already names the product
      }

      var title = node.querySelector("[data-pending-title]");
      if (title) title.textContent = preview.title || "";

      /* Price is the only field injected as HTML, because the real line's price IS markup
         (sale + struck compare, or current). The producer builds it from the same money
         strings the PDP rendered -- no user input is involved. */
      var price = node.querySelector("[data-pending-price]");
      if (price) {
        price.innerHTML = priceMarkup(preview);
        /* The bundle group carries `text-body-sm` on the price span ITSELF when there is no
           sale, but not when the sale/compare pair is nested inside it. Mirror that exactly. */
        if (preview.kind === "bundle" && !preview.compareAt) price.classList.add("text-body-sm");
      }

      var colour = node.querySelector("[data-pending-colour]");
      if (colour && preview.colour) {
        colour.textContent = preview.colour;
        colour.hidden = false;
      }

      /* The size control is the real (disabled) size-select; its visible text is the
         [data-size-select-value] span, not the <select>.

         REMOVE it (don't hide it) when the product has no size choice -- a single-variant /
         one-size line renders no dropdown (cart-line-item `cli_show_size`), so a stand-in that
         kept one would flash a control the real line drops. `hidden` won't do: size-select's
         own `x-size-select { display: flex }` outranks the `[hidden]` UA rule, so the node
         would stay visible (the same specificity trap as the empty-cart bars). `sizeSelectable`
         is the producer's copy of `has_size` / a >1-distinct-size check; treat a missing flag
         as "show only if a size value was supplied" for backward safety. */
      var sizeRoot = node.querySelector("x-size-select");
      var showSize = preview.sizeSelectable !== false && (preview.sizeSelectable || preview.size);
      if (sizeRoot && !showSize) {
        sizeRoot.remove();
      } else {
        var sizeValue = node.querySelector("[data-size-select-value]");
        if (sizeValue) sizeValue.textContent = preview.size || "";
      }

      var qtyInput = node.querySelector(".quantity-picker__input");
      if (qtyInput) qtyInput.value = String(preview.quantity > 0 ? preview.quantity : 1);

      var li = document.createElement("li");
      li.className = "cart-drawer__item";
      li.setAttribute("data-cart-pending-item", "");
      li.appendChild(node);

      var list = region.querySelector(".cart-drawer__items");
      if (list) {
        list.insertBefore(li, list.firstChild); // a new line lands at the top
        return;
      }
      /* Empty cart: there is no list to insert into, so stand one up — the real render
         replaces the whole region anyway.

         Dropping --empty makes the drawer look filled: it reveals the pre-rendered
         progress bars, hides the empty message, and restores the body padding the
         empty variant zeroes. Restored if the add fails. */
      if (region.classList.contains("cart-drawer__body--empty")) {
        region.classList.remove("cart-drawer__body--empty");
        pendingEmptyRegion = region;
      }
      var ul = document.createElement("ul");
      ul.className = "cart-drawer__items";
      ul.setAttribute("role", "list");
      ul.setAttribute("data-cart-pending-item", "");
      ul.appendChild(li);
      region.appendChild(ul);
    }

    function clearPendingLine() {
      var nodes = document.querySelectorAll("[data-cart-pending-item]");
      for (var i = 0; i < nodes.length; i++) nodes[i].remove();
      /* Only re-empty a region that is still empty: on a SUCCESSFUL add from an empty
         cart the region now holds server-rendered lines (the reconcile patches it in
         place rather than replacing it), and re-adding the modifier would hide a
         filled cart behind the empty message. */
      if (pendingEmptyRegion) {
        if (!pendingEmptyRegion.querySelector(MORPH_KEYED))
          pendingEmptyRegion.classList.add("cart-drawer__body--empty");
        pendingEmptyRegion = null;
      }
    }

    /* ---- row addressing ----
     * A row is every cart line sharing its variant, its properties AND its discounts.
     * Shopify splits a variant across several lines when a discount covers only part of
     * its quantity, allocating per set -- 5 coasters under "3 for $10" come back as 3
     * discounted + 2 at full price -- and it re-splits on every write. Lines under the
     * same discount are one offer and make up one row; lines under a different discount,
     * or none, are a different price and a row of their own.
     *
     * A row's quantity is written by collapsing THAT ROW onto its first live line key and
     * zeroing the row's other keys, in ONE update.js. The other rows' lines are left
     * alone, so the variant's new total is exactly "the other rows, plus what was asked
     * for here" -- which is why no total has to be computed client-side. Shopify then
     * re-allocates the discount over that total, and units can move between rows as it
     * does: on 3 + 2, one "+" buys a sixth coaster, so the whole 6 fall under "3 for $10"
     * and the full-price row is gone. The cart is right and each row still reads as one
     * price.
     *
     * The keys are read from server truth immediately before the write, never from the
     * rendered markup: a line-item key that has been superseded does NOT fail, it falls
     * back to matching on its variant prefix and lands on whichever line is first, which
     * is how an absolute quantity ends up on the wrong line and corrupts the cart. */

    function fetchCart() {
      return fetch(routeRoot() + "cart.js", { headers: { Accept: "application/json" } }).then(
        function (res) {
          return res.ok ? res.json() : Promise.reject(res);
        },
      );
    }

    /* Row identity strings are compared across a boundary that escapes text differently:
       the rendered [data-line-props] / [data-line-discounts] come from Liquid, which
       HTML-escapes property values and discount titles (`&` -> `&amp;`), while the cart.js
       objects carry the same text raw (`&`). Decode both to plain text before comparing so
       a discount named "25% Off Girl & Baby Girl Dresses" -- or a property value holding an
       `&` -- matches its live line instead of falling through to a no-op re-render. No-op
       for entity-free strings, so raw cart.js values and unescaped rows are untouched. */
    function decodeEntities(value) {
      if (value == null) return value;
      var str = String(value);
      if (str.indexOf("&") === -1) return str;
      var el = decodeEntities._el || (decodeEntities._el = document.createElement("textarea"));
      el.innerHTML = str;
      return el.value;
    }

    /* The two halves of a row's identity beyond its variant, each computed the same way
       on both sides of the comparison -- the row's rendered [data-line-props] /
       [data-line-discounts] and the cart JSON's own objects -- so neither side depends on
       the other's encoding. Sorted, because neither order is guaranteed to match. */
    function propsSig(props) {
      if (!props) return "";
      /* Liquid renders `properties | json` as [[key, value], ...] while cart.js returns a
         plain object, so both shapes arrive here and must reduce to the same string. */
      var pairs = Array.isArray(props)
        ? props.map(function (pair) {
            return decodeEntities(pair[0]) + "=" + decodeEntities(pair[1]);
          })
        : Object.keys(props).map(function (key) {
            return decodeEntities(key) + "=" + decodeEntities(props[key]);
          });
      return pairs.sort().join(";");
    }

    function discountSig(titles) {
      if (!titles || !titles.length) return "";
      return titles.map(decodeEntities).sort().join("\n");
    }

    function jsonAttr(el, name, fallback) {
      try {
        return JSON.parse(el.getAttribute(name) || fallback);
      } catch (e) {
        return JSON.parse(fallback);
      }
    }

    function cartLineDiscounts(item) {
      var allocations = item.line_level_discount_allocations || [];
      var titles = [];
      for (var i = 0; i < allocations.length; i++) {
        var app = allocations[i].discount_application || {};
        var title = app.title || app.code;
        if (title) titles.push(title);
      }
      return titles;
    }

    /* Every live line-item key the row covers, in cart order. */
    function rowKeys(el, cart) {
      var variantId = String(el.getAttribute("data-variant-id") || "");
      var props = propsSig(jsonAttr(el, "data-line-props", "{}"));
      var discounts = discountSig(jsonAttr(el, "data-line-discounts", "[]"));
      var items = (cart && cart.items) || [];
      var keys = [];
      for (var i = 0; i < items.length; i++) {
        if (String(items[i].variant_id) !== variantId) continue;
        if (propsSig(items[i].properties) !== props) continue;
        if (discountSig(cartLineDiscounts(items[i])) !== discounts) continue;
        keys.push(items[i].key);
      }
      return keys;
    }

    /* Set a row's quantity (0 removes it). Resolves the row's live line keys, then
       collapses the whole row onto its first key and zeroes the rest in ONE write
       (see changeLines) -- the row's new total is exactly what was asked for, and
       Shopify re-allocates the discount over it. A row that has vanished
       server-side re-renders truth instead of writing anything. `skipRender` omits
       the section render for a caller that renders after a further mutation of its
       own (the variant swap), so the shopper never sees an intermediate cart. */
    function setRowQuantity(lineId, quantity, skipRender) {
      return fetchCart().then(function (cart) {
        var els = lineEls(lineId);
        if (!els.length) return refreshFromServer();
        var keys = rowKeys(els[0], cart);
        if (!keys.length) return refreshFromServer();
        var entries = [];
        for (var i = 1; i < keys.length; i++) entries.push({ key: keys[i], quantity: 0 });
        entries.push({ key: keys[0], quantity: quantity });
        if (skipRender) return changeLines(entries, null, false);
        var ctx = discoverSections();
        return changeLines(entries, ctx, true).then(function (c) {
          applyState(c, c.sections, ctx);
          return c;
        });
      });
    }

    /* A product row covers cart lines and is written by key; a merged bundle parent is a
       single, non-groupable cart line and stays addressed by position. */
    function isKeyedRow(el) {
      return !!el && el.hasAttribute("data-line-props");
    }

    /* ---- mutations ----
     * Rows are identified by stable data-line-id. The row's lines (or, for a merged bundle
     * parent, its position) are resolved inside each queued task, after earlier mutations
     * have committed their swaps. That keeps quick removals on different rows correct;
     * same-row quantity edits still coalesce before entering the queue. Add flows use
     * their own coalescing below. */

    var qtyTimers = {};
    var qtyPending = {};
    var mutationChain = Promise.resolve();
    var mutationsInFlight = 0;

    /* Serialise one cart mutation on the chain. `task` returns a promise and owns
       its own error UI (revert / setError); the chain settles on both outcomes so a
       rejected op never wedges the queue or the busy state. */
    function runMutation(task) {
      mutationsInFlight++;
      setBusy(true);
      var ran = mutationChain.then(task, task);
      mutationChain = ran.then(settle, settle);
      return ran;
      function settle() {
        mutationsInFlight--;
        if (mutationsInFlight === 0) setBusy(false);
      }
    }

    function scheduleQty(lineId, value) {
      qtyPending[lineId] = value;
      clearTimeout(qtyTimers[lineId]);
      qtyTimers[lineId] = setTimeout(function () {
        flushQty(lineId);
      }, QTY_DEBOUNCE_MS);
    }

    function flushQty(lineId) {
      if (!(lineId in qtyPending)) return;
      var value = qtyPending[lineId];
      delete qtyPending[lineId];
      setLineBusy(lineId, true);
      runMutation(function () {
        if (!lineEls(lineId).length) {
          setLineBusy(lineId, false);
          return;
        } // row gone -> nothing to change
        return setRowQuantity(lineId, value).catch(function (err) {
          setLineBusy(lineId, false);
          revertQty(lineId); // re-sync the stepper to server truth
          setError(errMessage(err));
        });
      });
    }

    /* ---- optimistic removal ----
     * A removal is final on screen the frame it is asked for: the row collapses out
     * of the list and the count drops with it. The server render only confirms it --
     * nothing the server sends can put the row back, because every render in flight
     * when the shopper clicked was answered against a cart that still holds the line.
     *
     * The node is NOT detached -- it stays zero-height and `inert` until the render
     * that confirms the removal drops it. That keeps every queued mutation's row (and,
     * for a merged bundle parent, the position it resolves) addressable, and makes a
     * REJECTED removal self-healing: the entry is released first, so truth re-renders
     * and the reconcile restores the row from the fresh markup. */

    /* Lines removed on screen but not yet confirmed, keyed the way the reconcile keys
       rows (`morphId`), each holding the quantity it took out of the count and the
       rows showing it (the drawer and the cart page render the same line). An entry is
       what makes the reconcile leave those rows alone -- collapsed, never re-inserted
       -- until the render that actually confirms the removal. */
    var removedLines = Object.create(null);

    function collapseRow(row) {
      row.setAttribute("data-line-dropping", "");
      row.inert = true; // out of reach of pointer, focus and assistive tech at once
      /* A keyword length cannot be interpolated, so pin the current height in JS and
         let CSS animate it (plus padding, border and opacity) to zero. */
      row.style.blockSize = row.getBoundingClientRect().height + "px";
      requestAnimationFrame(function () {
        row.style.blockSize = "0px";
      });
    }

    /* Collapse every row showing a line and take it out of the count. `key` is the
       line's `morphId`, so the reconcile recognises the same row from the render. */
    function markRemoved(key, rows, quantity) {
      for (var i = 0; i < rows.length; i++) collapseRow(rows[i]);
      // A bundle group stamps no quantity, so its count waits for the render (NaN -> 0).
      removedLines[key] = { quantity: quantity > 0 ? quantity : 0, rows: rows };
      paintCounts();
    }

    /* Hand lines back to the reconcile, once their removal has settled either way:
       confirmed, the render has already detached the rows; rejected, the re-render
       that follows restores them (releasing first is what lets it). */
    function releaseRemoved(keys) {
      for (var i = 0; i < keys.length; i++) delete removedLines[keys[i]];
    }

    /* What the paint subtracts from server truth: every line still collapsed on
       screen. A row the confirming render has detached stops counting itself at that
       render, ahead of its entry being released. */
    function droppedQuantity() {
      var total = 0;
      for (var key in removedLines) {
        var entry = removedLines[key];
        for (var i = 0; i < entry.rows.length; i++) {
          if (entry.rows[i].isConnected) {
            total += entry.quantity;
            break;
          }
        }
      }
      return total;
    }

    /* A remove supersedes this row's OWN debounced qty change (the remove wins). Other
       rows' pending qty is left alone: flushQty re-resolves each row's group from server
       truth at dequeue, so this remove cannot make another row's pending change stale. */
    function removeLine(lineId) {
      if (removedLines[lineId]) return; // already removed on screen (e.g. double-clicked)
      clearTimeout(qtyTimers[lineId]);
      delete qtyPending[lineId];

      var els = lineEls(lineId);
      if (!els.length) return;
      var rows = [];
      for (var i = 0; i < els.length; i++) rows.push(els[i].closest("li") || els[i]);
      markRemoved(lineId, rows, parseInt(els[0].getAttribute("data-quantity"), 10));

      removeQueue.push(lineId);
      scheduleRemoveFlush();
    }

    /* Removals coalesce into ONE round of calls and ONE render. Answering each click
       on its own re-renders the whole cart per click, and every render in between
       paints a cart the shopper has already moved past -- totals and progress bars
       stepping backwards through states, and `cart:updated` consumers (the
       gift-with-purchase diff) reacting to each one. Nothing waits on this: the row is
       already gone from the list, so the round only has to settle, not be watched. */
    var removeQueue = [];
    var removeFlushing = false;
    var removeTimer = null;

    /* The round leaves on the next tick, never later: a removal must be on its way to
       the server before the shopper can reach Checkout, so the batching window is the
       one that costs nothing -- the round-trip already in flight. Clicks landing
       during it ride the next round. */
    function scheduleRemoveFlush() {
      clearTimeout(removeTimer);
      removeTimer = setTimeout(function () {
        if (removeFlushing) return; // a round is in flight; its settle re-schedules
        removeFlushing = true;
        runMutation(function () {
          return flushRemovals().then(settleFlush, settleFlush);
        });
      }, 0);
    }

    function settleFlush() {
      removeFlushing = false;
      if (removeQueue.length) scheduleRemoveFlush(); // clicked while the round was in flight
    }

    /* Remove each merged bundle parent -- the one row that is a single cart line -- by
       position, with its own change.js, HIGHEST FIRST: removing a later line cannot move
       an earlier one, so one snapshot of positions stays valid for the whole round and
       none of them needs a render to re-resolve. `render` carries `sections` on the last
       call, and is false when a keyed round follows and will render instead. */
    function removeAt(positions, ctx, render) {
      if (!positions.length) return Promise.resolve(null);
      var index = positions.shift();
      var last = positions.length === 0;
      var body = { line: index, quantity: 0 };
      var withSections = last && render;
      return postCart("change", withSections ? cartSectionsBody(ctx, body) : body).then(
        function (cart) {
          if (last) return withSections ? cart : null;
          return removeAt(positions, ctx, render);
        },
      );
    }

    /* Zero every line of every keyed row in one write (see changeLines): a row's
       lines are one offer priced one way, so the round covers them all at once.
       Keys come from server truth read here, after any positional call above has
       already left. */
    function zeroRows(rows, ctx) {
      return fetchCart().then(function (cart) {
        var entries = [];
        for (var i = 0; i < rows.length; i++) {
          var keys = rowKeys(rows[i], cart);
          for (var k = 0; k < keys.length; k++) entries.push({ key: keys[k], quantity: 0 });
        }
        if (!entries.length) return null; // nothing of these rows is left -> let truth govern
        return changeLines(entries, ctx, true);
      });
    }

    function flushRemovals() {
      var batch = removeQueue.splice(0, removeQueue.length);
      if (!batch.length) return Promise.resolve();
      var keyed = [];
      var positions = [];
      for (var i = 0; i < batch.length; i++) {
        var live = lineEls(batch[i])[0];
        if (!live) continue; // already gone from the DOM -> nothing to address
        if (isKeyedRow(live)) {
          keyed.push(live);
          continue;
        }
        var index = indexForLineId(batch[i]); // live position at dequeue
        if (index) positions.push(index);
      }
      positions.sort(function (a, b) {
        return b - a;
      });
      var ctx = discoverSections();
      return removeAt(positions, ctx, keyed.length === 0)
        .then(function (cart) {
          if (!keyed.length) return cart;
          return zeroRows(keyed, ctx);
        })
        .then(function (cart) {
          if (cart) {
            applyState(cart, cart.sections, ctx);
            releaseRemoved(batch);
            return;
          }
          releaseRemoved(batch); // nothing addressable was left -> let truth govern
          return refreshFromServer();
        })
        .catch(function (err) {
          releaseRemoved(batch); // truth has to be able to put the rows back
          setError(errMessage(err));
          return refreshFromServer().catch(function () {});
        });
    }

    /* Remove every line of a pre-registration bundle group, addressed by member key
       in one write (see changeLines). Rejections surface the shared error. */
    function removeMany(row, keys) {
      if (!keys || !keys.length || !row) return;
      /* Grouped members are addressed by key, not position, so the row collapses at
         once with no index bookkeeping -- and the group is keyed for the reconcile by
         its `morphId` like any other row. */
      var key = morphId(row);
      if (removedLines[key]) return;
      var entries = [];
      for (var i = 0; i < keys.length; i++) entries.push({ key: keys[i], quantity: 0 });
      markRemoved(key, [row], NaN);
      /* On the shared chain like every other mutation: keys make this one immune to a
         reindex, but its render is not -- unserialised it can paint a cart snapshot
         taken before a queued removal over the top of it. */
      runMutation(function () {
        var ctx = discoverSections();
        return changeLines(entries, ctx, true).then(
          function (cart) {
            applyState(cart, cart.sections, ctx);
            releaseRemoved([key]);
          },
          function (err) {
            releaseRemoved([key]); // truth has to be able to put the row back
            setError(errMessage(err));
            return refreshFromServer().catch(function () {});
          },
        );
      });
    }

    /* Edit variant: remove the outgoing ROW before adding the incoming variant, so the
       add cannot re-bucket the group being removed. The whole group goes (its quantity
       moves to the new variant), and the add bundles section rendering, making the swap
       two round-trips: remove, then add+render. If the add fails, surface the error and
       re-render truth so the cart remains consistent.

       Bundled add responses carry sections but no item_count; countFromSections reads
       the fresh drawer heading, then broadcastCart reads full server truth post-paint.
       If usable sections are missing, fall back to refreshFromServer. */
    function editVariant(detail) {
      var lineId = detail.lineId;
      var fromId = String(detail.fromVariantId || "");
      var toId = String(detail.toVariantId || "");
      // No-op guard: never swap a variant for itself (nothing to change).
      if (!lineId || !toId || toId === fromId) return;
      clearTimeout(qtyTimers[lineId]); // supersede only THIS line's pending qty
      delete qtyPending[lineId];
      var qty = detail.quantity && detail.quantity > 0 ? detail.quantity : 1;
      setLineBusy(lineId, true);
      runMutation(function () {
        if (!lineEls(lineId).length) return refreshOrError(lineId); // already gone -> show truth
        var ctx = discoverSections();
        return setRowQuantity(lineId, 0, true)
          .then(function () {
            return postCart(
              "add",
              cartSectionsBody(ctx, { items: [{ id: detail.toVariantId, quantity: qty }] }),
            );
          })
          .then(function (res) {
            var count = res && res.sections ? countFromSections(res.sections, ctx) : null;
            if (count == null) return refreshFromServer(); // no usable sections -> re-render truth
            applyState({ item_count: count }, res.sections, ctx, { deferBroadcast: true });
            broadcastCart(); // server truth once, post-paint (coalesced)
          })
          .catch(function (err) {
            setLineBusy(lineId, false);
            setError(errMessage(err));
            return refreshFromServer().catch(function () {}); // error already surfaced; just avoid an unhandled rejection
          });
      });
    }

    /* Re-configure one line: the gift-card editor's write. Personalisation-only
       edits keep the variant, so they are ONE change.js that replaces the line's
       properties in place -- nothing is added and nothing removed, so the write
       is structurally incapable of leaving the shopper two cards. Only an amount
       change (a different variant) needs a new line: it is added FIRST, so a
       failed add leaves the original untouched, and only then are the original
       row's keys re-read from server truth and zeroed. A key captured before the
       add would already be void -- Shopify rehashes a line key when the line's
       own properties or discount allocations change, which is exactly what this
       write does. */
    function editLine(detail) {
      var lineId = detail.lineId;
      var toId = String(detail.variantId || "");
      if (!lineId || !toId) return;
      var properties = detail.properties || {};
      setLineBusy(lineId, true);
      runMutation(function () {
        var ctx = discoverSections();
        function failed(err) {
          setLineBusy(lineId, false);
          setError(errMessage(err));
          return refreshFromServer().catch(function () {}); // error already surfaced
        }
        return fetchCart().then(function (cart) {
          var els = lineEls(lineId);
          if (!els.length) return refreshOrError(lineId); // already gone -> show truth
          var row = els[0];
          var keys = rowKeys(row, cart);
          if (!keys.length) return refreshOrError(lineId);
          var quantity = Number(row.getAttribute("data-quantity")) || 1;
          /* A row spanning several cart lines cannot be re-propertied by one
             change.js, so it takes the add-then-remove path even when the variant
             is unchanged (a gift-card line is quantity 1 and never splits, so this
             is a guard, not the common case). */
          if (String(row.getAttribute("data-variant-id")) === toId && keys.length === 1) {
            return postCart(
              "change",
              cartSectionsBody(ctx, { id: keys[0], quantity: quantity, properties: properties }),
            )
              .then(function (updated) {
                applyState(updated, updated.sections, ctx);
                return updated;
              })
              .catch(failed);
          }
          return postCart("add", {
            items: [{ id: detail.variantId, quantity: quantity, properties: properties }],
          })
            .then(fetchCart)
            .then(function (fresh) {
              var live = rowKeys(row, fresh);
              /* The original went while the add was in flight -- the add alone is
                 already the intended one-line result, so just render truth. */
              if (!live.length) return refreshFromServer();
              var entries = [];
              for (var i = 0; i < live.length; i++) entries.push({ key: live[i], quantity: 0 });
              return changeLines(entries, ctx, true).then(function (updated) {
                applyState(updated, updated.sections, ctx);
                return updated;
              });
            })
            .catch(failed);
        });
      });
    }

    /* Fallback refresh (un-bundled producer only). Coalesce overlapping adds:
       only ONE refreshFromServer runs at a time; adds arriving mid-refresh set a
       pending flag and trigger a single trailing refresh on settle, instead of N
       overlapping round-trips racing. The trailing refresh re-reads server truth,
       so the count never lags. */
    var addInflight = false;
    var addPending = false;

    function refreshAfterAdd() {
      if (addInflight) {
        addPending = true;
        return;
      }
      addInflight = true;
      setBusy(true);
      refreshFromServer()
        .then(function () {
          setBusy(false);
        })
        .catch(function (err) {
          setError(errMessage(err));
        })
        .then(function () {
          addInflight = false;
          if (addPending) {
            addPending = false;
            refreshAfterAdd(); // one trailing refresh picks up everything added in between
          }
        });
    }

    /* Bundled-add concurrency tracking. cart:prepare-bundled-sections fires
       immediately before each bundled add POST, so it is the deterministic "add
       starting" signal paired with cart:added regardless of response order. */
    var addsInFlight = 0;
    var addsThisBurst = 0;
    var burstSafetyTimer = null;

    /* Self-healing safety. A bundled add that FAILS produces no cart:added (the
       add-core takes its error path), so its prepare-increment would otherwise leak
       and wedge addsInFlight above zero forever. Each prepare (re)arms this; a clean
       burst close clears it. If it ever fires, the burst is force-closed (reconcile if
       it held 2+ adds, then reset) so the counter never leaks. The window is longer
       than any real add round-trip, so it never pre-empts a live burst. */
    function armBurstSafety() {
      clearTimeout(burstSafetyTimer);
      burstSafetyTimer = setTimeout(function () {
        if (addsThisBurst > 1) refreshAfterAdd();
        addsInFlight = 0;
        addsThisBurst = 0;
        /* Backstop for a pending stand-in whose producer fails without announcing
           cart:add-failed; successful producers clear this before it fires. */
        clearPendingLine();
      }, 4000);
    }

    /* Returns { settled, reconciled } so callers avoid duplicate server-truth reads:
       refreshAfterAdd already dispatches a full cart:updated after reconciliation. */
    function closeBurstIfSettled() {
      if (addsInFlight !== 0) return { settled: false, reconciled: false };
      clearTimeout(burstSafetyTimer);
      /* Concurrency reconcile: when 2+ adds overlap, Shopify can render each bundled
         section against a cart snapshot that misses a sibling in-flight add, so the
         section count under-reports true cart. Once the LAST in-flight add settles,
         reconcile a multi-add burst to server truth with ONE update.js. A lone add
         (addsThisBurst === 1) never reconciles -- the common path stays one trip. */
      var reconciled = addsThisBurst > 1;
      if (reconciled) refreshAfterAdd();
      addsThisBurst = 0;
      return { settled: true, reconciled: reconciled };
    }

    /* cart:added -- render then show. If the producer bundled sections into the add
       request, populate the drawer before opening it. add.js returns no item_count,
       so countFromSections reads the freshly rendered drawer heading.

       Without sections or a readable count, open first and let the coalesced
       refreshFromServer path re-render and publish the full cart. */
    function onAdded(event) {
      var item = event && event.detail ? event.detail.item : null;
      var ctx = discoverSections();
      var count = item && item.sections ? countFromSections(item.sections, ctx) : null;

      if (addsInFlight > 0) addsInFlight--; // pair with the prepare that preceded this

      if (item && item.sections && count != null) {
        /* Independent adds can resolve OUT OF ORDER, so a later-arriving response may
           carry a stale, lower count + drawer state than one already shown. Adds only
           raise the count, so the highest count is the most complete cart -- apply this
           response only when it does not move the count backwards (drop the stale one;
           the fresher state stays). A lone add always applies (lastShownCount starts at
           -1, then tracks the live count). */
        if (count >= lastShownCount) {
          applyState({ item_count: count }, item.sections, ctx, { deferBroadcast: true });
        }
        openCartDrawer();
        var burst = closeBurstIfSettled();
        /* Paint is done; read server truth once unless this settle already reconciled a
           multi-add burst or another in-flight add will broadcast when it settles. */
        if (burst.settled && !burst.reconciled) broadcastCart();
        /* Accepted edge: a lone bundled add can race a concurrent remove and briefly
           paint the add's cart snapshot until the next mutation reconciles. Serialising
           add-vs-remove would add a round-trip to the common path. */
        return;
      }

      /* Fallback path already settles on server truth via refreshFromServer. Only
         reset the burst + clear the safety timer once THIS is the last in-flight add
         (mirrors closeBurstIfSettled): a still-in-flight sibling that then FAILS
         produces no cart:added, so its re-armed timer must survive to force-close the
         burst -- clearing it here unconditionally would wedge addsInFlight above zero. */
      if (addsInFlight === 0) {
        addsThisBurst = 0;
        clearTimeout(burstSafetyTimer);
      }
      openCartDrawer();
      refreshAfterAdd();
    }

    /* ---- delegated wiring (survives swaps + section reloads) ---- */

    /* Reset drawer scroll on each genuine open. The persistent dialog preserves
       scrollTop across closes; overlay:open fires only on closed->open, so this does
       not disturb in-drawer mutation scroll preservation. */
    /* GA4 view_cart on drawer open. The native cart_viewed event fires on the cart
       page only, so drawer opens publish custom_view_cart without another request:
       the Liquid JSON island seeds the cart and cart:updated keeps it current. Skip
       on the cart page, where cart_viewed already covers it. */
    var viewCartData = null; // latest cart in /cart.js shape (seed, then cart:updated)
    var viewCartDrawerOpen = false;
    var viewCartFired = false;

    (function seedViewCart() {
      var el = document.querySelector("[data-cart-ga4-seed]");
      if (!el) return;
      try {
        viewCartData = JSON.parse(el.textContent);
      } catch (e) {
        viewCartData = null;
      }
    })();

    function mapViewCart(cart) {
      if (!cart || !Array.isArray(cart.items) || !cart.items.length) return null;
      var items = cart.items.map(function (line, index) {
        return {
          index: index,
          quantity: line.quantity,
          item_id: String(line.sku || line.variant_id || line.product_id || ""),
          item_name: line.product_title,
          item_brand: line.vendor,
          item_category: line.product_type,
          item_variant: line.variant_title,
          price: (line.original_price || 0) / 100,
          discount: (line.total_discount || 0) / 100,
          affiliation: "Online Store",
        };
      });
      return { currency: cart.currency, value: (cart.total_price || 0) / 100, items: items };
    }

    function fireViewCart() {
      if (viewCartFired || !viewCartDrawerOpen) return;
      if (document.querySelector(".shopify-section--cart")) return; // /cart page: cart_viewed covers it
      var api = window.Shopify && window.Shopify.analytics;
      if (!api || typeof api.publish !== "function") return;
      var ecommerce = mapViewCart(viewCartData);
      if (!ecommerce) return;
      viewCartFired = true;
      api.publish("custom_view_cart", { ecommerce: ecommerce });
    }

    /* Keep the cart current from the runtime's existing broadcast -- no extra fetch.
       Ignore the fallback { item_count } shape (no items array). When the drawer is
       already open from an ADD, this settled cart is what view_cart reports. */
    document.addEventListener("cart:updated", function (event) {
      var cart = event.detail && event.detail.cart;
      if (cart && Array.isArray(cart.items)) viewCartData = cart;
      fireViewCart();
    });

    document.addEventListener("overlay:open", function (event) {
      if (!event.detail || event.detail.id !== "cart-drawer") return;
      var host = drawerHost();
      var content = host ? host.querySelector(".overlay__content") : null;
      if (content) content.scrollTop = 0;
      viewCartDrawerOpen = true;
      viewCartFired = false;
      /* Manual open: cart is settled -> fire now from the seed/last cart. An ADD-driven
         open shows the optimistic stand-in ([data-cart-pending-item]) with a PRE-add
         cart; its real cart lands via cart:updated a beat later, so defer to that to
         avoid reporting the stale cart. */
      if (!document.querySelector("[data-cart-pending-item]")) fireViewCart();
    });

    document.addEventListener("overlay:close", function (event) {
      if (event.detail && event.detail.id === "cart-drawer") viewCartDrawerOpen = false;
    });

    document.addEventListener("quantity:change", function (event) {
      var d = event.detail;
      if (!d) return;
      // Identify the line by stable id. Programmatic dispatchers pass detail.lineId;
      // quantity-picker events read it from the enclosing custom element.
      var lineId = d.lineId;
      if (!lineId) {
        var lineEl =
          event.target && event.target.closest ? event.target.closest("x-cart-line-item") : null;
        lineId = lineEl ? lineEl.getAttribute("data-line-id") : null;
      }
      if (!lineId) return;
      scheduleQty(lineId, d.value);
    });

    document.addEventListener("cart-line-item:change-variant", function (event) {
      var d = event.detail;
      if (!d || !d.lineId || !d.toVariantId) return;
      editVariant(d);
    });

    document.addEventListener("cart:request-edit-line", function (event) {
      if (event.detail) editLine(event.detail);
    });

    document.addEventListener("click", function (event) {
      var remove = event.target.closest("a.cart-line-item__remove");
      if (!remove) return;
      // Identify by stable id; removeLine resolves the live position at execution time.
      var lineEl = remove.closest("x-cart-line-item");
      var lineId = lineEl ? lineEl.getAttribute("data-line-id") : null;
      if (!lineId) return; // no id -> let the native href fallback navigate
      event.preventDefault();
      removeLine(lineId);
    });

    /* Pre-registration bundle remove-all: one control carries member keys in
       data-line-item-keys. No keys leaves the native href fallback to remove one member. */
    document.addEventListener("click", function (event) {
      var removeAll = event.target.closest("[data-line-item-keys]");
      if (!removeAll) return;
      var raw = removeAll.getAttribute("data-line-item-keys");
      if (!raw) return;
      event.preventDefault();
      removeMany(removeAll.closest("li"), raw.split(",").filter(Boolean));
    });

    /* Merged-bundle remove-all. A merged bundle is one parent cart line; nested
       item_components are not addressable by Cart AJAX. Remove the parent by stable line id
       and live position, or let the native href fallback remove the parent when no id exists. */
    document.addEventListener("click", function (event) {
      var removeBundle = event.target.closest("[data-remove-bundle-line]");
      if (!removeBundle) return;
      var lineId = removeBundle.getAttribute("data-remove-bundle-line");
      if (!lineId) return;
      event.preventDefault();
      removeLine(lineId);
    });

    /* Render-then-show producer contract. Producers dispatch a fresh Set before
       cart/add.js; the runtime adds renderable section ids so the add response can
       carry the drawer markup. Empty Set lets producers omit sections and fall back
       to the two-trip refresh. */
    document.addEventListener("cart:prepare-bundled-sections", function (event) {
      var set = event.detail && event.detail.sections;
      if (!set || typeof set.add !== "function") return;
      var ids = discoverSections().ids;
      for (var i = 0; i < ids.length; i++) set.add(ids[i]);
      /* Fires once per bundling producer right before its add POST -- the
         deterministic "add starting" signal the concurrency reconcile pairs with
         the matching cart:added (see onAdded). armBurstSafety guards against a
         failed add (no cart:added) leaking the in-flight counter. */
      addsInFlight++;
      addsThisBurst++;
      armBurstSafety();
      /* Paint the dimmed real-product stand-in and reveal the drawer immediately when
         a producer supplies preview data. Silent programmatic adds never dispatch this
         event, so they cannot pop the drawer. */
      var preview = event.detail && event.detail.preview;
      if (preview) {
        showPendingLine(preview);
        openCartDrawer();
      }
    });

    /* A failed add produces no cart:added, so the pending line would otherwise sit there
       until armBurstSafety's 4s backstop -- and a phantom product in an OPEN drawer reads
       as "added" when it was not (quick-add's error path opens the drawer to show its
       error, so the two would appear side by side). Producers announce the failure and the
       stand-in goes immediately. */
    document.addEventListener("cart:add-failed", function () {
      clearPendingLine();
    });

    document.addEventListener("cart:added", onAdded);

    /* cart:request-add -- the SILENT add intent for programmatic lines (the
       gift-with-purchase auto-gift). Unlike a producer's cart:added path this
       never opens the drawer (an auto-add must not pop the drawer over the
       /cart page). Bundles the section render into the add call so the new
       line paints in ONE round-trip (same render-then-show as onAdded); falls
       back to the coalesced two-trip refresh when no sections come back. A
       failed add (e.g. out of stock) changes nothing, so it only swallows the
       rejection. */
    document.addEventListener("cart:request-add", function (event) {
      var d = event.detail;
      if (!d || !d.id) return;
      var ctx = discoverSections();
      setBusy(true);
      postCart(
        "add",
        cartSectionsBody(ctx, {
          items: [{ id: d.id, quantity: d.quantity || 1, properties: d.properties || {} }],
        }),
      )
        .then(function (data) {
          setBusy(false);
          var count = data && data.sections ? countFromSections(data.sections, ctx) : null;
          if (data && data.sections && count != null) {
            if (count >= lastShownCount) {
              applyState({ item_count: count }, data.sections, ctx, { deferBroadcast: true });
            }
            broadcastCart();
          } else {
            refreshAfterAdd();
          }
        })
        .catch(function () {
          setBusy(false);
        });
    });

    /* Stale merged-bundle reprice. Cart Transform recomputes a merged bundle's price
       only on a cart mutation; checkout is correct, but an idle cart can show stale
       pricing. cart-bundle-group stamps [data-bundle-reprice] when rendered pricing
       disagrees with bundle metafields. One hidden cart-attribute write forces a
       transform-backed re-render, then the attribute is cleared so it never reaches
       the order. Run once per page load to avoid loops if the marker persists. */
    var repriceAttempted = false;
    function maybeRepriceBundles() {
      if (repriceAttempted) return;
      if (!document.querySelector("[data-bundle-reprice]")) return;
      repriceAttempted = true;
      runMutation(function () {
        var ctx = discoverSections();
        return postCart(
          "update",
          cartSectionsBody(ctx, {
            attributes: { _bundle_reprice: String(Date.now()) },
          }),
        )
          .then(function (cart) {
            applyState(cart, cart.sections, ctx);
            return postCart("update", { attributes: { _bundle_reprice: "" } });
          })
          .catch(function () {});
      });
    }
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", maybeRepriceBundles);
    } else {
      maybeRepriceBundles();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
    
  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      this.epoch = parseInt(this.dataset.saleEndEpoch || "", 10);
      this.timerOnly = this.dataset.timerOnly === "true";
      this.cells = {
        days: this.querySelector("[data-days]"),
        hours: this.querySelector("[data-hours]"),
        minutes: this.querySelector("[data-minutes]"),
        seconds: this.querySelector("[data-seconds]"),
      };
      if (!this.epoch || Number.isNaN(this.epoch)) {
        return;
      }
      this.tick();
      this.interval = window.setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      if (this.interval) {
        window.clearInterval(this.interval);
        this.interval = null;
      }
    }

    tick() {
      const remaining = this.epoch - Date.now();
      this.setState(remaining);
      if (remaining > 0) {
        this.render(remaining);
      } else if (this.interval) {
        window.clearInterval(this.interval);
        this.interval = null;
      }
    }

    setState(remaining) {
      const SHORT_MS = 3600000;
      let state;
      if (remaining <= 0) {
        state = "ended";
      } else if (this.timerOnly) {
        state = "timer-only";
      } else if (remaining <= SHORT_MS) {
        state = "short";
      } else {
        state = "default";
      }
      if (this.dataset.state !== state) {
        this.dataset.state = state;
      }
    }

    render(remaining) {
      const totalSeconds = Math.floor(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      const pad = function (n) {
        return String(n).padStart(2, "0");
      };
      if (this.cells.days) {
        this.cells.days.textContent = days;
      }
      if (this.cells.hours) {
        this.cells.hours.textContent = pad(hours);
      }
      if (this.cells.minutes) {
        this.cells.minutes.textContent = pad(minutes);
      }
      if (this.cells.seconds) {
        this.cells.seconds.textContent = pad(seconds);
      }
    }
  }

  if (!customElements.get("countdown-timer")) {
    customElements.define("countdown-timer", CountdownTimer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["embed-code"] && !Shopify.designMode) return;
  try {
    
  /* Job-detail takeover: mirror the ?ja-job= URL param onto a body class so
     the CSS above can hide every other section when a single role is open.
     Covers deep-links / reloads (initial sync), browser back/forward
     (popstate) and the JobAdder widget's own history.pushState navigation
     (enablePushState) so opening/closing a job without a reload stays in sync. */
  (function () {
    if (window.__embedCodeJaJobView) return;
    window.__embedCodeJaJobView = true;

    function sync() {
      var isJob = /[?&]ja-job=/.test(window.location.search);
      document.body.classList.toggle("ja-job-view", isJob);
    }

    sync();
    window.addEventListener("popstate", sync);

    ["pushState", "replaceState"].forEach(function (method) {
      var original = history[method];
      history[method] = function () {
        var result = original.apply(this, arguments);
        sync();
        return result;
      };
    });

    /* Pager scroll: JobAdder scrolls to the top of the job LIST on page
       change (animateScrollOnPageChange), which leaves the filter bar above
       the viewport. Override it -- scroll the section top (heading + filters)
       to just below the sticky header. The next page is fetched over the
       network, so the timing of JobAdder's scroll varies; instead of a fixed
       delay we watch the widget for the re-render (MutationObserver) and
       scroll once it settles, so ours lands last and wins. The header height
       is measured live (the theme has no fixed header-height var). */
    function scrollToFilters(section) {
      var header = document.querySelector(".header--sticky") || document.querySelector(".header");
      var offset = header ? header.getBoundingClientRect().height : 0;
      var top = section.getBoundingClientRect().top + window.pageYOffset - offset - 8;
      window.scrollTo({ top: top > 0 ? top : 0, behavior: "smooth" });
    }

    var pendingScroll = null; // 'filters' (pager) | 'top' (view job) | null
    var scrollTimer = null;

    // Capture phase so it fires even if the widget stops the click bubbling.
    document.addEventListener(
      "click",
      function (event) {
        if (event.target.closest(".embed-code .ja-pager a")) {
          pendingScroll = "filters";
        } else if (event.target.closest(".embed-code .ja-job-list .view-details")) {
          pendingScroll = "top";
        }
      },
      true,
    );

    function scheduleScroll() {
      if (!pendingScroll) return;
      if (scrollTimer) window.clearTimeout(scrollTimer);
      var action = pendingScroll;
      // Debounce: scroll ~250ms after the LAST re-render mutation, by which
      // point JobAdder has already done its own scroll, so ours wins.
      scrollTimer = window.setTimeout(function () {
        if (action === "top") {
          window.scrollTo({ top: 0, behavior: "smooth" });
        } else {
          var section =
            document.querySelector(".shopify-section--embed-code") ||
            document.querySelector(".embed-code");
          if (section) scrollToFilters(section);
        }
        pendingScroll = null;
      }, 250);
    }

    var embeds = document.querySelectorAll(".embed-code");
    for (var i = 0; i < embeds.length; i++) {
      new MutationObserver(scheduleScroll).observe(embeds[i], {
        childList: true,
        subtree: true,
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-stories"] && !Shopify.designMode) return;
  try {
    
  /* Wires the external prev/next arrows to the composed carousel's public
     prev()/next() API and reflects its at-start/at-end edges onto the buttons'
     disabled state. The carousel owns scroll-snap, keyboard and swipe; this
     element only adds the desktop arrow affordance. When the carousel reports
     BOTH edges at once there is a single page (content fits), so the nav hides --
     mirroring the carousel's own single-page indicator hide. */
  class FeaturedStoriesCarousel extends HTMLElement {
    connectedCallback() {
      this.carousel = this.querySelector("x-carousel");
      this.nav = this.querySelector("[data-fs-nav]");
      this.prevButton = this.querySelector("[data-fs-prev]");
      this.nextButton = this.querySelector("[data-fs-next]");
      if (!this.carousel) return;

      this._onPrev = () => this.carousel.prev();
      this._onNext = () => this.carousel.next();
      this._onChange = () => this._syncEdges();

      if (this.prevButton) this.prevButton.addEventListener("click", this._onPrev);
      if (this.nextButton) this.nextButton.addEventListener("click", this._onNext);
      this.carousel.addEventListener("carousel:change", this._onChange);

      // Tile widths (and therefore the page count) change on resize.
      this._resizeObserver = new ResizeObserver(() => this._syncEdges());
      this._resizeObserver.observe(this.carousel);

      this._syncEdges();
      requestAnimationFrame(() => this._syncEdges());
    }

    disconnectedCallback() {
      if (this.prevButton) this.prevButton.removeEventListener("click", this._onPrev);
      if (this.nextButton) this.nextButton.removeEventListener("click", this._onNext);
      this.carousel?.removeEventListener("carousel:change", this._onChange);
      this._resizeObserver?.disconnect();
      this._resizeObserver = null;
    }

    _syncEdges() {
      if (!this.carousel) return;
      const atStart = this.carousel.hasAttribute("data-at-start");
      const atEnd = this.carousel.hasAttribute("data-at-end");
      if (this.prevButton) this.prevButton.disabled = atStart;
      if (this.nextButton) this.nextButton.disabled = atEnd;
      // Clearing the inline value hands display back to the stylesheet, so the
      // mobile `display: none` rule still wins below the breakpoint.
      if (this.nav) this.nav.style.display = atStart && atEnd ? "none" : "";
    }
  }

  if (!customElements.get("x-fs-carousel")) {
    customElements.define("x-fs-carousel", FeaturedStoriesCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["form"] && !Shopify.designMode) return;
  try {
    
  class SeedForm extends HTMLElement {
    connectedCallback() {
      this.alert = this.querySelector("[data-form-error]");
      this.messages = {
        required: this.getAttribute("data-error-required") || "",
        email: this.getAttribute("data-error-email") || "",
        number: this.getAttribute("data-error-number") || "",
        phone: this.getAttribute("data-error-phone") || "",
        generic: this.getAttribute("data-error-generic") || "",
      };

      // Successful post-backs need focus so screen-reader users land on the status.
      const success = this.querySelector("[data-form-success]");
      if (success) {
        success.focus();
        return;
      }

      // Errors stay silent until the first submit attempt; after that, fields
      // re-validate live so a message clears the moment its field is corrected.
      // This stops "required" surfacing before the user has tried to submit.
      this.submitted = false;
      this.onSubmit = this.onSubmit.bind(this);
      this.onSubmitClick = this.onSubmitClick.bind(this);
      this.onBlur = this.onBlur.bind(this);
      this.onChange = this.onChange.bind(this);
      this.onInput = this.onInput.bind(this);
      this.wire(0);

      // Server-side errors (Shopify rejection / no-JS post-back that then loads
      // with JS): map each onto its field's inline message, focus the first,
      // announce, and drop the no-JS summary block.
      this.applyServerErrors();
    }

    // Attach the submit guard + live-revalidation listeners, then hand validation
    // over to JS. If the element upgraded BEFORE its inner `<form>` was parsed,
    // `this.querySelector('form')` is null here -- retry on the next frame instead
    // of bailing, so the styled validation still wires up once the form exists.
    // Critically, `noValidate` is set LAST, only once the submit guard is proven
    // attached: if we never reach that point (the element never upgrades, or the
    // form never appears), native `required` stays enabled as a real no-JS
    // fallback rather than being pre-emptively disabled with nothing to replace it.
    wire(attempt) {
      this.form = this.querySelector("form");
      if (!this.form) {
        if (attempt < 20) requestAnimationFrame(() => this.wire(attempt + 1));
        return;
      }
      this.form.addEventListener("submit", this.onSubmit);
      this.form.addEventListener("blur", this.onBlur, true);
      this.form.addEventListener("change", this.onChange, true);
      this.form.addEventListener("input", this.onInput, true);
      this.form.noValidate = true;

      // Validation ALSO gates the submit button's click (not just the submit
      // event): Shopify's captcha bootstrap listens for `submit` at the
      // document level and, once it fires, re-submits the form
      // programmatically -- a path no submit listener can cancel, so an
      // invalid form would show its errors AND still post. Blocking the click
      // means the submit event never exists for an invalid form. The implicit
      // Enter-key submission routes through the default button's click, so
      // this covers the keyboard path too; onSubmit stays as the fail-closed
      // second gate for anything that synthesises a submit event directly.
      const submitBtn = this.form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.addEventListener("click", this.onSubmitClick);
    }

    get blocks() {
      return Array.from(this.querySelectorAll("[data-form-input]"));
    }

    // A block's error is "live" once the form has been submitted, or once it is
    // already showing an error (so a correction can clear it). Before the first
    // submit nothing validates, so no message appears prematurely.
    isLive(block) {
      return this.submitted || block.classList.contains("has-error");
    }

    onBlur(event) {
      const block = event.target.closest("[data-form-input]");
      if (!block) return;
      // Value-bearing fields validate on blur. Checkbox/radio toggle by click,
      // and a label-forwarded click blurs the input MID-TOGGLE -- so a blur read
      // would see the pre-toggle state and leave a stale "required" error on a
      // box that ends up checked. Those validate on `change` (post-toggle).
      const type = block.getAttribute("data-field-type");
      if (type === "radio" || type === "checkbox") return;
      if (this.isLive(block)) this.revalidate(block);
    }

    onChange(event) {
      const block = event.target.closest("[data-form-input]");
      if (!block) return;
      const type = block.getAttribute("data-field-type");
      if (type !== "radio" && type !== "checkbox") return;
      if (this.isLive(block)) this.revalidate(block);
    }

    onInput(event) {
      // Clear a showing error the instant its field becomes valid, rather than
      // waiting for blur.
      const block = event.target.closest("[data-form-input]");
      if (block && block.classList.contains("has-error")) this.revalidate(block);
    }

    revalidate(block) {
      this.validateBlock(block);
      if (this.alert && !this.blocks.some((b) => b.classList.contains("has-error"))) {
        this.alert.textContent = "";
      }
    }

    // The submit gate. Driven by the NATIVE `required` attribute the controls
    // already emit (the single source of truth) rather than a bespoke data-*
    // flag: the form may submit only when every required control is filled AND
    // every filled control is valid. `noValidate` disables the browser's own
    // submit blocking (so messaging can be styled), but `checkValidity()` still
    // reports each control's native validity here regardless.
    isSubmittable() {
      const controls = Array.from(this.form.querySelectorAll("input, select, textarea"));
      return controls.every((control) => {
        if (control.hasAttribute("required")) {
          if (control.type === "checkbox" || control.type === "radio") {
            // A checkbox/radio group is filled once ANY control of its name is
            // checked (radio = one-of, required checkbox group = at-least-one).
            const group = controls.filter((c) => c.name === control.name);
            if (!group.some((c) => c.checked)) return false;
          } else if (String(control.value || "").trim() === "") {
            return false;
          }
        }
        // A filled-but-invalid control (malformed email, bad number, …) also
        // blocks submission via its native constraints.
        if (typeof control.checkValidity === "function" && !control.checkValidity()) {
          return false;
        }
        return true;
      });
    }

    // The click gate. Runs BEFORE any submit event exists (see wire), so an
    // invalid form never reaches the captcha bootstrap's uncancellable
    // re-submission path. stopImmediatePropagation keeps other click-driven
    // machinery (analytics, ripple JS, ...) from acting on a blocked attempt.
    onSubmitClick(event) {
      if (!this.validateAll()) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }

    // The submit gate -- fail-closed second line behind onSubmitClick for
    // anything that fires a submit event without clicking the button. A VALID
    // form is let through untouched: we do NOT preventDefault or call
    // form.submit(), so the native submit event keeps firing and Shopify's
    // own spam-protection / captcha (which hooks that event) still runs.
    onSubmit(event) {
      if (!this.validateAll()) event.preventDefault();
    }

    // Validate every block, surface the styled inline messages, and on failure
    // focus the first invalid field and announce via the status region.
    // Returns true only when the form is safe to submit. Fail closed: `ok`
    // starts false and only a fully clean validation pass flips it, so a
    // thrown validation error can never let an unchecked form through (it is
    // logged rather than rethrown -- both callers must still see `false`).
    validateAll() {
      this.submitted = true;
      let ok = false;
      try {
        // Surface the styled inline messages for every field (required + the
        // JS-only email/number/phone/dob format checks), for all field types.
        this.blocks.forEach((block) => this.validateBlock(block));
        // Submittable = every required field filled AND nothing invalid. The
        // `has-error` term folds in the JS-only checks (phone/dob format and the
        // required checkbox GROUP "at least one") that `checkValidity()` cannot
        // express.
        ok =
          this.isSubmittable() &&
          !this.blocks.some((block) => block.classList.contains("has-error"));
      } catch (error) {
        console.error("[x-form] validation failed", error);
      }

      if (ok) {
        if (this.alert) this.alert.textContent = "";
        return true;
      }

      const firstInvalid = this.blocks.find((block) => block.classList.contains("has-error"));
      const focusable = firstInvalid
        ? firstInvalid.querySelector(
            '.input__control, .textarea__control, .date-picker__control, input[type="radio"], input[type="checkbox"]',
          )
        : null;
      if (focusable) focusable.focus();
      if (this.alert) this.alert.textContent = this.messages.generic;
      return false;
    }

    // Map Shopify's server-side form.errors (rendered as rows in the no-JS
    // summary) onto the matching fields' inline messages -- the same per-field
    // error UI as client validation -- then remove the summary so JS users get
    // only inline errors. Marks the form submitted so a correction clears the
    // error live, moves focus to the first affected field and announces.
    applyServerErrors() {
      const summary = this.querySelector("[data-form-server-errors]");
      if (!summary) return;

      // EVERY server-error row, not just the field-bound ones: a category
      // outside the email/author/body map (this form's own phone/custom fields,
      // or a generic `form`/spam/captcha rejection) renders as a
      // `data-server-error-general` row with no field to bind to. We must never
      // silently drop those -- a JS user would otherwise get no message, no
      // announcement, no focus. Map what maps inline; leave the rest visible.
      const rows = Array.from(
        summary.querySelectorAll("[data-server-error-for], [data-server-error-general]"),
      );
      let firstControl = null;
      let allMapped = true;

      rows.forEach((row) => {
        const base = row.getAttribute("data-server-error-for");
        // No base (general row) -- can't bind to a field, keep it in the summary.
        if (!base) {
          allMapped = false;
          return;
        }
        const message = row.getAttribute("data-server-error-message") || "";
        const block = this.blocks.find((b) =>
          b.querySelector('[name="contact[' + base + ']"], [name="contact[' + base + '][]"]'),
        );
        // A mapped category whose field isn't on this form (or a row with no
        // message) also can't go inline -- leave that row visible too.
        if (!block || !message) {
          allMapped = false;
          return;
        }
        const control = block.querySelector(
          '.input__control, .textarea__control, .date-picker__control, input[type="radio"], input[type="checkbox"]',
        );
        this.applyError(block, message, control);
        row.remove(); // this error now lives on its field's inline message
        if (!firstControl) firstControl = control;
      });

      // Only drop the whole summary once EVERY error is carried inline; if any
      // row couldn't be mapped, keep the summary (now holding just those rows)
      // visible so the error is never lost for a JS user.
      if (allMapped) summary.remove();

      if (firstControl) {
        // Treat like a failed submit so live re-validation clears each error the
        // moment its field is corrected, then focus the first affected field.
        this.submitted = true;
        firstControl.focus();
      }
      // Announce whenever ANY server error surfaced -- whether it landed inline
      // or stayed in the summary -- so assistive tech is always told it failed.
      if (rows.length && this.alert) this.alert.textContent = this.messages.generic;
    }

    validateBlock(block) {
      const type = block.getAttribute("data-field-type");
      const required = block.getAttribute("data-required") === "true";
      let message = "";

      if (type === "radio" || type === "checkbox") {
        const inputs = block.querySelectorAll('input[type="radio"], input[type="checkbox"]');
        const anyChecked = Array.prototype.some.call(inputs, (i) => i.checked);
        if (required && inputs.length && !anyChecked) message = this.messages.required;
        this.applyError(block, message, inputs[0]);
        return !message;
      }

      // text / number / email / dob -> one value-bearing control.
      const valueCtl = block.querySelector('[name^="contact["]');
      const focusCtl =
        block.querySelector(".input__control, .textarea__control, .date-picker__control") ||
        valueCtl;
      const value = valueCtl ? String(valueCtl.value || "").trim() : "";
      const nativeInput = block.querySelector(".input__control");

      if (required && value === "") {
        message = this.messages.required;
      } else if (value !== "") {
        if (type === "email" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          message = this.messages.email;
        } else if (type === "number" && isNaN(Number(value))) {
          message = this.messages.number;
        } else if (type === "tel") {
          // Delegate the AU/NZ mobile rule to the input component (single source
          // of the regex -- input.liquid's x-input.isValidPhone); <x-form> keeps
          // ownership of the message + the silent-until-submit-then-live timing.
          const region = block.getAttribute("data-phone-region") || "au";
          const xInput = block.querySelector("x-input");
          const phoneValid =
            xInput && typeof xInput.isValidPhone === "function"
              ? xInput.isValidPhone(value, region)
              : true;
          if (!phoneValid) message = this.messages.phone;
        }
      }
      // type="number" rejects non-numeric input natively (value clears, badInput set).
      if (
        !message &&
        type === "number" &&
        nativeInput &&
        nativeInput.validity &&
        nativeInput.validity.badInput
      ) {
        message = this.messages.number;
      }

      this.applyError(block, message, focusCtl);
      return !message;
    }

    // Add or remove a single aria-describedby token without disturbing any other
    // ids the control may carry (e.g. a hint). Critically this REMOVES the message
    // association when the error clears -- otherwise a corrected field keeps
    // pointing at an emptied message node, which is a stale programmatic
    // relationship (WCAG 4.1.2 Name, Role, Value).
    toggleDescribedBy(control, id, on) {
      if (!control || !id) return;
      const tokens = (control.getAttribute("aria-describedby") || "")
        .split(/\s+/)
        .filter(Boolean)
        .filter((token) => token !== id);
      if (on) tokens.push(id);
      if (tokens.length) {
        control.setAttribute("aria-describedby", tokens.join(" "));
      } else {
        control.removeAttribute("aria-describedby");
      }
    }

    applyError(block, message, control) {
      block.classList.toggle("has-error", !!message);
      const field = block.querySelector(".form-field");

      if (field) {
        field.classList.toggle("form-field--error", !!message);
        let msgEl = field.querySelector(".form-field__message");
        if (!msgEl) {
          const footer = document.createElement("div");
          footer.className = "form-field__footer";
          msgEl = document.createElement("span");
          msgEl.className = "form-field__message text-body-sm";
          msgEl.setAttribute("role", "alert");
          msgEl.id = (control && control.id ? control.id : block.id || "form-input") + "-message";
          footer.appendChild(msgEl);
          field.appendChild(footer);
          field.classList.add("form-field--reserve-message");
        }
        msgEl.textContent = message || "";
        if (control) {
          control.setAttribute("aria-invalid", message ? "true" : "false");
          this.toggleDescribedBy(control, msgEl.id, !!message);
        }
      } else {
        // radio / checkbox group or consent checkbox: block-rendered message.
        const msgEl = block.querySelector("[data-form-input-message]");
        if (msgEl) msgEl.textContent = message || "";
        if (control) {
          control.setAttribute("aria-invalid", message ? "true" : "false");
          this.toggleDescribedBy(control, msgEl ? msgEl.id : null, !!message);
        }
      }
    }
  }

  if (!customElements.get("x-form")) {
    customElements.define("x-form", SeedForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-card-balance"] && !Shopify.designMode) return;
  try {
    
  /* <gift-card-balance> handles input, loading/error states, the live Worker
     endpoint, and swapping in the result card through resolveBalance(). */
  class GiftCardBalance extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector("[data-gcb-form]");
      this.submitBtn = this.querySelector("[data-gcb-submit]");
      this.spinner = this.querySelector("[data-gcb-spinner]");
      this.statusEl = this.querySelector("[data-gcb-status]");
      this.testModeEl = this.querySelector("[data-gcb-testmode]");
      this.numberInput = this.querySelector("#gcb-card-number");
      this.pinInput = this.querySelector("#gcb-pin");
      this.resultEl = this.querySelector("[data-gcb-result]");
      this.resetBtn = this.querySelector("[data-gcb-reset]");
      if (!this.form || !this.submitBtn) return;

      this.proxyPath = (this.getAttribute("data-proxy-path") || "").trim();
      this.market = this.getAttribute("data-market") || "";

      /* Progressive enhancement: the submit ships disabled and only becomes
         operable once this element upgrades (no-JS the lookup cannot run).
         The button snippet pairs disabled with aria-disabled -- clear both. */
      this.submitBtn.removeAttribute("disabled");
      this.submitBtn.removeAttribute("aria-disabled");
      if (this.pinInput) this.pinInput.setAttribute("inputmode", "numeric");

      this.onSubmit = this.onSubmit.bind(this);
      this.onInput = this.onInput.bind(this);
      this.onReset = this.onReset.bind(this);
      this.form.addEventListener("submit", this.onSubmit);
      this.form.addEventListener("input", this.onInput);
      if (this.resetBtn) this.resetBtn.addEventListener("click", this.onReset);
    }

    /* POST { voucher, pin, market } to the same-origin App Proxy path; resolves
       the { voucherNumber, expiryDate, originalAmount, usedAmount,
       currentBalance, currency } contract or rejects 'invalid_card'|'unavailable'. */
    resolveBalance(voucher, pin) {
      if (!this.proxyPath) {
        /* Blank path uses the labelled mock only in the theme editor. Live
           shoppers must never see a fabricated balance, so outside the editor
           the lookup stays unavailable until balance_proxy_path is set. */
        if (this.hasAttribute("data-test-mode")) {
          return new Promise((resolve) => {
            setTimeout(function () {
              resolve({
                voucherNumber: "2077797679088752",
                expiryDate: "2028-04-24",
                originalAmount: 100,
                usedAmount: 0,
                currentBalance: 100,
                currency: "AUD",
                testMode: true,
              });
            }, 600);
          });
        }
        return Promise.reject("unavailable");
      }
      return fetch(this.proxyPath, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ voucher: voucher, pin: pin, market: this.market }),
      }).then((r) =>
        r
          .json()
          .catch(() => ({}))
          .then((data) => {
            if (r.ok) return data;
            const code = data && data.error === "invalid_card" ? "invalid_card" : "unavailable";
            return Promise.reject(code);
          }),
      );
    }

    onSubmit(event) {
      event.preventDefault();
      if (this.submitBtn.getAttribute("aria-busy") === "true") return;
      if (!this.form.reportValidity()) return;

      this.clearStatus();
      this.setLoading(true);
      const voucher = this.numberInput ? this.numberInput.value.trim() : "";
      const pin = this.pinInput ? this.pinInput.value.trim() : "";

      this.resolveBalance(voucher, pin)
        .then((res) => {
          this.setLoading(false);
          this.showResult(res);
        })
        .catch((code) => {
          this.setLoading(false);
          const key = code === "invalid_card" ? "data-error-invalid" : "data-error-unavailable";
          this.showError(this.getAttribute(key) || "");
        });
    }

    onInput() {
      this.clearStatus();
    }

    onReset() {
      /* Refocus the card-number field so keyboard users restart from the first input. */
      this.hideResult();
      this.clearStatus();
      if (this.numberInput) this.numberInput.value = "";
      if (this.pinInput) this.pinInput.value = "";
      if (this.form) this.form.hidden = false;
      if (this.numberInput) this.numberInput.focus();
    }

    setLoading(on) {
      if (this.spinner) this.spinner.hidden = !on;
      [this.numberInput, this.pinInput].forEach((input) => {
        if (input) input.disabled = on;
      });
      if (on) {
        this.submitBtn.setAttribute("aria-busy", "true");
        this.submitBtn.setAttribute("aria-disabled", "true");
      } else {
        this.submitBtn.removeAttribute("aria-busy");
        this.submitBtn.removeAttribute("aria-disabled");
      }
    }

    /* Group a card number into blocks of four for display (e.g. 2077 7976 …). */
    groupDigits(value) {
      const s = String(value == null ? "" : value).replace(/\s+/g, "");
      const grouped = s.replace(/(.{4})/g, "$1 ").trim();
      return grouped || s;
    }

    /* ISO / YYYY-MM-DD -> DD/MM/YYYY; anything else passes through unchanged. */
    formatExpiry(value) {
      const s = String(value == null ? "" : value);
      const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
      return m ? m[3] + "/" + m[2] + "/" + m[1] : s;
    }

    /* Numeric amount -> currency ($100.00) using the market's currency. */
    formatMoney(value, currency) {
      const n = Number(value);
      if (isNaN(n)) return value == null ? "" : String(value);
      const cur = currency || "AUD";
      const locale = cur === "NZD" ? "en-NZ" : "en-AU";
      try {
        return new Intl.NumberFormat(locale, { style: "currency", currency: cur }).format(n);
      } catch (e) {
        return "$" + n.toFixed(2);
      }
    }

    setText(selector, text) {
      const el = this.querySelector(selector);
      if (el) el.textContent = text;
    }

    showResult(res) {
      if (!this.resultEl) return;
      const cur = res.currency;
      this.setText("[data-gcb-number]", this.groupDigits(res.voucherNumber));
      this.setText("[data-gcb-expiry]", this.formatExpiry(res.expiryDate));
      this.setText("[data-gcb-original]", this.formatMoney(res.originalAmount, cur));
      this.setText("[data-gcb-used]", this.formatMoney(res.usedAmount, cur));
      this.setText("[data-gcb-balance]", this.formatMoney(res.currentBalance, cur));

      this.clearStatus();
      if (this.form) this.form.hidden = true;
      this.resultEl.hidden = false;
      if (this.testModeEl) this.testModeEl.hidden = !res.testMode;
    }

    hideResult() {
      if (this.resultEl) this.resultEl.hidden = true;
    }

    showError(text) {
      if (!this.statusEl) return;
      this.statusEl.textContent = text;
      this.statusEl.classList.add("gift-card-balance__status--error");
      this.statusEl.hidden = false;
      if (this.testModeEl) this.testModeEl.hidden = true;
    }

    clearStatus() {
      if (this.statusEl) {
        this.statusEl.hidden = true;
        this.statusEl.textContent = "";
        this.statusEl.classList.remove("gift-card-balance__status--error");
      }
      if (this.testModeEl) this.testModeEl.hidden = true;
    }
  }

  if (!customElements.get("gift-card-balance")) {
    customElements.define("gift-card-balance", GiftCardBalance);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-card-landing"] && !Shopify.designMode) return;
  try {
    
  /* <gift-card-grid> owns tab filtering, count announcement, and opening the
     quick-add drawer locked to a tile's design. `overlay` handles focus trap,
     scroll lock and scrim; <gift-card-form> handles purchase logic. */
  class GiftCardGrid extends HTMLElement {
    connectedCallback() {
      this.tablist = this.querySelector('[role="tablist"]');
      this.tiles = Array.prototype.slice.call(this.querySelectorAll(".gc-tile"));
      this.countEl = this.querySelector("[data-gc-count]");
      this.countTpl = this.getAttribute("data-count-label") || "";

      this.onClick = this.onClick.bind(this);
      this.addEventListener("click", this.onClick);

      /* <x-tabs> emits no selection event; watch aria-selected on the tablist. */
      if (this.tablist) {
        this.observer = new MutationObserver(() => this.applyFilter());
        this.observer.observe(this.tablist, {
          subtree: true,
          attributes: true,
          attributeFilter: ["aria-selected"],
        });
      }
      this.applyFilter();

      /* Pre-select ?design=<code> so a shared link reloads with the chosen
         design visibly selected. Visual state only -- focus is not moved. */
      this.restoreSelection();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    currentHandle() {
      const sel = this.tablist && this.tablist.querySelector('[role="tab"][aria-selected="true"]');
      if (!sel || !sel.id) return "all";
      return sel.id.replace("gc-occ-", "") || "all";
    }

    applyFilter() {
      const handle = this.currentHandle();
      let shown = 0;
      this.tiles.forEach((tile) => {
        const occ = (tile.getAttribute("data-occasions") || "").split(/\s+/);
        const show = handle === "all" || occ.indexOf(handle) !== -1;
        const cell = tile.closest(".gift-card-landing__cell") || tile;
        cell.hidden = !show;
        if (show) shown += 1;
      });
      if (this.countEl && this.countTpl) {
        this.countEl.textContent = this.countTpl.split("[[count]]").join(String(shown));
      }
    }

    onClick(event) {
      const tile = event.target.closest(".gc-tile");
      if (!tile) return;
      /* No drawer available (JS partial / removed) -> let the link navigate. */
      if (this.openDrawer(tile)) event.preventDefault();
    }

    /* Open the quick-add drawer locked to `tile`'s design. False means the drawer
       is unavailable and the caller should fall back to plain navigation. */
    openDrawer(tile) {
      const overlay = document.querySelector('x-overlay[data-overlay-id="gift-card-quick-add"]');
      const form = overlay ? overlay.querySelector("gift-card-form") : null;
      if (!overlay || !form || typeof overlay.open !== "function") return false;
      /* Focus the tile before opening so the overlay can return focus to the
         triggering tile after it closes. */
      tile.focus();
      const design = tile.getAttribute("data-design");
      /* Mark this tile selected and persist ?design=<code> before opening so
         the selection remains visible after closing or reloading. */
      this.selectTile(tile);
      this.writeDesignParam(design);
      /* prepareForDesign resets the form (and any pending cart-line edit) and
         locks the design the amount chips are then read from. */
      if (typeof form.prepareForDesign === "function") form.prepareForDesign(design);
      overlay.open();
      return true;
    }

    /* Single-selection: mark `tile` as the chosen design, clear the rest. Marks
       the visual state only -- it never moves DOM focus, so restoring a selection
       on load shows no focus ring (the tile's own focus-visible box-shadow still
       fires normally for real click / keyboard interaction). */
    selectTile(tile) {
      this.tiles.forEach((t) => {
        const on = t === tile;
        t.classList.toggle("gc-tile--selected", on);
        if (on) t.setAttribute("aria-current", "true");
        else t.removeAttribute("aria-current");
      });
    }

    /* Persist the chosen design to the URL (replaceState -> no history spam,
       matches the buy-box ?variant= precedent). Preserves any other param + hash;
       a null code clears it. */
    writeDesignParam(code) {
      try {
        const url = new URL(window.location.href);
        if (code) url.searchParams.set("design", code);
        else url.searchParams.delete("design");
        window.history.replaceState({}, "", url.pathname + url.search + url.hash);
      } catch (err) {
        /* URL/history API unavailable -- leave the address bar as-is. */
      }
    }

    /* Restore selection from ?design=<code> on load: match a tile by data-design
       and mark it selected. Indication only -- the drawer is NOT auto-opened and
       focus is NOT moved (no focus ring on refresh). */
    restoreSelection() {
      let code = null;
      try {
        code = new URLSearchParams(window.location.search).get("design");
      } catch (err) {
        code = null;
      }
      if (!code) return;
      const tile = this.tiles.find((t) => t.getAttribute("data-design") === code);
      if (tile) this.selectTile(tile);
    }
  }

  if (!customElements.get("gift-card-grid")) {
    customElements.define("gift-card-grid", GiftCardGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-with-purchase"]) return;
  try {
    
  /* Headless GWP controller. Reacts to the cart runtime's `cart:updated`,
     diffs observed vs desired gift state, and dispatches runtime intents
     (`cart:request-add` / `quantity:change`) -- it never calls the cart API or
     renders anything itself. Every dispatch is conditional on a state
     mismatch, so the cycle converges and cannot loop. */
  class GiftWithPurchase extends HTMLElement {
    connectedCallback() {
      const configEl = this.querySelector("[data-gwp-config]");
      if (!configEl) return;
      try {
        this.config = JSON.parse(configEl.textContent);
      } catch (error) {
        return;
      }

      this.giftVariantId = String(this.config.giftVariantId);
      this.removingKey = null; // guard while this controller's removal is pending
      this.addRequested = false; // guard while this controller's add is pending
      this.lastHadGift = false;
      this.fetchInFlight = false;
      this.fetchPending = false;

      document.addEventListener("cart:updated", (event) => {
        const cart = event.detail && event.detail.cart;
        /* The runtime's bundled-add path emits a count-only cart; fall back to
           a cart.js read whenever the items array is missing. */
        if (cart && Array.isArray(cart.items)) this.evaluate(cart);
        else this.refresh();
      });

      this.refresh(); // reconcile the server-rendered cart before cart:updated fires
    }

    routeRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    }

    async refresh() {
      if (this.fetchInFlight) {
        this.fetchPending = true;
        return;
      }
      this.fetchInFlight = true;
      try {
        const response = await fetch(this.routeRoot() + "cart.js", {
          headers: { Accept: "application/json" },
        });
        this.evaluate(await response.json());
      } catch (error) {
        /* leave the cart untouched on failure */
      } finally {
        this.fetchInFlight = false;
        if (this.fetchPending) {
          this.fetchPending = false;
          this.refresh();
        }
      }
    }

    isExcluded(item) {
      if (item.properties && item.properties._isGWP) return true;
      if (item.properties && item.properties._gift_bundle_id) return true;
      /* Gift cards are stored value, not spend. cart.js exposes no product tags, so the
         eGift card (a regular product tagged `gift card`) is matched on its `Gift Card`
         product type instead. This check must stay at least as broad as the gift-discount
         function's, or the controller adds a gift the function then declines to zero. */
      if (item.gift_card) return true;
      if (String(item.product_type || "").indexOf("Gift Card") !== -1) return true;
      const productId = String(item.product_id);
      if (this.config.donationProductId && productId === String(this.config.donationProductId))
        return true;
      if (
        this.config.giftWrappingProductId &&
        productId === String(this.config.giftWrappingProductId)
      )
        return true;
      return false;
    }

    qualifies(cart) {
      let eligibleSubtotal = 0;
      let hasQualifyingProduct = false;
      const qualifyingIds = (this.config.qualifyingProductIds || []).map(String).filter(Boolean);

      cart.items.forEach((item) => {
        if (this.isExcluded(item)) return;
        eligibleSubtotal += item.final_line_price;
        if (qualifyingIds.length && qualifyingIds.indexOf(String(item.product_id)) !== -1) {
          hasQualifyingProduct = true;
        }
      });

      const meetsThreshold =
        this.config.thresholdCents > 0 ? eligibleSubtotal >= this.config.thresholdCents : true;
      const productOk = this.config.requireQualifyingProduct ? hasQualifyingProduct : true;
      return meetsThreshold && productOk;
    }

    findGiftLine(cart) {
      return cart.items.find(
        (item) =>
          String(item.variant_id) === this.giftVariantId &&
          item.properties &&
          item.properties._isGWP,
      );
    }

    /* Read the gift line's stable id straight from its rendered data-line-id -- the SAME
       string cart-line-item.liquid built with `url_encode` -- rather than re-encoding it in
       JS. This keeps ONE source of truth for the id: a JS encoder (encodeURIComponent) does
       NOT match Liquid `url_encode` for every character (space, `!'()~`, ...), so a future
       gift-line property carrying one of those would silently stop matching. The gift line
       is server-rendered in the (globally present) cart drawer whenever it is in the cart,
       so it is in the DOM here; returns null otherwise and the next cart:updated re-evaluates. */
    giftLineIdFromDom() {
      const els = document.querySelectorAll(
        'x-cart-line-item[data-variant-id="' + this.giftVariantId + '"]',
      );
      for (const el of els) {
        const id = el.getAttribute("data-line-id") || "";
        if (/(^|;)_isGWP=/.test(id)) return id; // the GWP line, not a normally-purchased line of the same variant
      }
      return null;
    }

    dispatch(name, detail) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
    }

    declined() {
      try {
        return sessionStorage.getItem("gwp:declined") === "true";
      } catch (error) {
        return false;
      }
    }

    setDeclined(value) {
      try {
        if (value) sessionStorage.setItem("gwp:declined", "true");
        else sessionStorage.removeItem("gwp:declined");
      } catch (error) {
        /* storage unavailable -> the latch degrades to re-adding */
      }
    }

    /* Retry back-off for the auto-add. The gift add is dispatched to the cart
       runtime, and when it does not land -- e.g. a throttled cart endpoint -- the
       retry is itself a cart write, so re-attempting on every qualifying page load
       feeds the throttle that is blocking it. Each attempt widens the window
       exponentially (cap 120s); a landed gift or a drop below the threshold clears
       it. Persisted per session because the amplification is navigation-driven:
       each page load mounts a fresh controller that would otherwise re-attempt. */
    addBackoffUntil() {
      try {
        return parseInt(sessionStorage.getItem("gwp:addBackoffUntil") || "0", 10) || 0;
      } catch (error) {
        return 0;
      }
    }

    noteAddAttempt() {
      try {
        const attempts = (parseInt(sessionStorage.getItem("gwp:addAttempts") || "0", 10) || 0) + 1;
        const delay = Math.min(8000 * Math.pow(2, attempts - 1), 120000);
        sessionStorage.setItem("gwp:addAttempts", String(attempts));
        sessionStorage.setItem("gwp:addBackoffUntil", String(Date.now() + delay));
      } catch (error) {
        /* storage unavailable -> back-off degrades to the in-flight guard + 8s timer */
      }
    }

    clearAddBackoff() {
      try {
        sessionStorage.removeItem("gwp:addAttempts");
        sessionStorage.removeItem("gwp:addBackoffUntil");
      } catch (error) {
        /* storage unavailable -> nothing to clear */
      }
    }

    evaluate(cart) {
      const gift = this.findGiftLine(cart);
      const giftLineId = gift ? this.giftLineIdFromDom() : null;
      const qualified = this.qualifies(cart);

      if (gift) {
        this.addRequested = false; // our add landed
        this.clearAddBackoff(); // a landed gift clears any retry back-off
      }

      if (!gift && this.removingKey) {
        this.removingKey = null; // our removal landed -- not a shopper decline
      } else if (!gift && this.lastHadGift && qualified) {
        /* The gift disappeared while still qualified and we did not remove it:
           the shopper declined it. Latch until the cart drops below the rule. */
        this.setDeclined(true);
      }
      if (!qualified) {
        this.setDeclined(false);
        this.clearAddBackoff(); // dropping below the rule resets the retry back-off
      }
      this.lastHadGift = !!gift;

      if (qualified && !gift) {
        if (this.declined() || this.addRequested) return;
        /* Skip the auto-add while backing off from a prior attempt that never
           landed the gift, so a throttled cart endpoint is not re-hit every cycle. */
        if (Date.now() < this.addBackoffUntil()) return;
        this.noteAddAttempt();
        this.addRequested = true;
        /* Release the guard if the add never lands (e.g. gift out of stock),
           so a later cart change can retry instead of wedging forever. */
        clearTimeout(this.addReleaseTimer);
        this.addReleaseTimer = setTimeout(() => {
          this.addRequested = false;
        }, 8000);
        this.dispatch("cart:request-add", {
          id: Number(this.giftVariantId),
          quantity: 1,
          properties: { _isGWP: "true" },
        });
        return;
      }

      if (!qualified && gift) {
        if (this.removingKey === gift.key) return; // removal already dispatched
        // Don't pin the guard on a DOM miss: if the gift line isn't painted yet (e.g. a
        // cart.js refresh() racing the drawer render), dispatching a null lineId would
        // no-op AND wedge removingKey so it never retries. Skip and re-evaluate next tick.
        if (!giftLineId) return;
        this.removingKey = gift.key;
        this.dispatch("quantity:change", { value: 0, lineId: giftLineId });
        return;
      }

      if (qualified && gift) {
        /* Re-qualified while our removal was still debounced: overwrite the
           pending 0 through the same per-line path. Also clamps a shopper
           bumping the free gift's quantity back to the single free unit. */
        if (this.removingKey === gift.key || gift.quantity !== 1) {
          if (!giftLineId) return; // gift line not painted yet -> re-evaluate next tick
          this.removingKey = null;
          this.dispatch("quantity:change", { value: 1, lineId: giftLineId });
        }
      }
    }
  }

  if (!customElements.get("gift-with-purchase")) {
    customElements.define("gift-with-purchase", GiftWithPurchase);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Publishes the stuck header's occupied height as `--header-height` on <html>, so
     page-level sticky elements (the Coveo "Filters & Sort" bar) can pin BELOW it
     instead of sliding under it. The header has no fixed height -- it is content-
     driven and differs per breakpoint (the Tablet/Mobile search bar adds a row), so
     it must be measured. When the header is not sticky it scrolls away and nothing
     needs an offset: the property stays unset and consumers fall back to 0px. */
  (function () {
    var header = document.querySelector(".header--sticky");
    if (!header) return;
    var section = header.closest(".shopify-section") || header;

    function sync() {
      // The sticky section inset belongs in the published header height. Floor
      // fractional heights so consumers tuck under the header by <1px instead
      // of exposing a hairline gap below it.
      var nudge = parseFloat(getComputedStyle(section).insetBlockStart) || 0;
      document.documentElement.style.setProperty(
        "--header-height",
        Math.floor(header.getBoundingClientRect().height) + nudge + "px",
      );
    }

    sync();
    if (window.ResizeObserver) new ResizeObserver(sync).observe(header);
    else window.addEventListener("resize", sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-dashudson"] && !Shopify.designMode) return;
  try {
    
  class DashHudsonGallery extends HTMLElement {
    connectedCallback() {
      this.endpoint = (this.dataset.endpoint || "").replace(/\/+$/, "");
      this.brandId = this.dataset.brandId;
      this.galleryId = this.dataset.galleryId;
      this.lightboxId = this.dataset.lightboxId || "";

      this.carousel = this.querySelector("x-carousel");
      this.track = this.querySelector("[data-carousel-track]");
      this.status = this.querySelector("[data-dh-status]");
      this.arrows = this.querySelector("[data-dh-arrows]");
      this.prevBtn = this.querySelector("[data-dh-prev]");
      this.nextBtn = this.querySelector("[data-dh-next]");

      this.overlayEl = this.querySelector('x-overlay[data-overlay-id="' + this.lightboxId + '"]');
      this.stage = this.querySelector("[data-dh-stage]");
      this.modalArrows = this.querySelector("[data-dh-modal-arrows]");
      this.modalPrev = this.querySelector("[data-dh-modal-prev]");
      this.modalNext = this.querySelector("[data-dh-modal-next]");
      this.tileTpl = this.querySelector("[data-dh-tile-tpl]");
      this.slideTpl = this.querySelector("[data-dh-slide-tpl]");
      this.productTpl = this.querySelector("[data-dh-product-tpl]");
      this.pinTpl = this.querySelector("[data-dh-pin-tpl]");
      this.items = [];
      this.modalBuilt = false;
      this.activeIndex = 0;

      if (this.prevBtn) {
        this.prevBtn.addEventListener("click", () => {
          if (this.carousel) this.carousel.prev();
        });
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener("click", () => {
          if (this.carousel) this.carousel.next();
        });
      }
      this.addEventListener("carousel:change", (e) => {
        if (e.target === this.carousel) this._syncArrows();
      });

      // Tile click -> open the lightbox at that index (delegated; survives inject).
      // On touch (no-hover) devices there is no hover to reveal the "Shop now"
      // scrim, so mirror the live site's two-tap pattern: the first tap reveals
      // the affordance, the second tap opens the lightbox.
      if (this.track) {
        this.track.addEventListener("click", (e) => {
          const tile = e.target.closest("[data-dh-tile]");
          if (!tile) return;
          if (this._isTouch() && !tile.classList.contains("instagram-dashudson__tile--revealed")) {
            this._revealTile(tile);
            return;
          }
          const idx = parseInt(tile.dataset.index, 10);
          this._clearRevealed();
          this._openLightbox(isNaN(idx) ? 0 : idx);
        });
      }

      // Modal nav arrows: cross-fade one post.
      if (this.modalPrev) this.modalPrev.addEventListener("click", () => this._modalGo(-1));
      if (this.modalNext) this.modalNext.addEventListener("click", () => this._modalGo(1));
      // Mobile swipe (the carousel's native scroll-snap is gone with the fade stack).
      if (this.stage) {
        let sx = 0,
          sy = 0;
        this.stage.addEventListener(
          "touchstart",
          (e) => {
            sx = e.touches[0].clientX;
            sy = e.touches[0].clientY;
          },
          { passive: true },
        );
        this.stage.addEventListener(
          "touchend",
          (e) => {
            const dx = e.changedTouches[0].clientX - sx;
            const dy = e.changedTouches[0].clientY - sy;
            if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) this._modalGo(dx < 0 ? 1 : -1);
          },
          { passive: true },
        );
      }
      // Pause media when the modal closes. Bound + retained so disconnectedCallback
      // can remove it (the editor re-renders the section, so an un-removed
      // document-level listener would leak, bound to a detached instance).
      this._onOverlayClose = (e) => {
        if (e.detail && e.detail.id === this.lightboxId) {
          this._lbOpen = false;
          this._pauseVideos();
        }
      };
      document.addEventListener("overlay:close", this._onOverlayClose);

      // Re-derive the card width across the mobile/desktop breakpoint. The stage
      // carries an INLINE width (the desktop card hugs the active post); that inline
      // value beats the mobile `inline-size:100%` rule and isn't recomputed on its
      // own, so a resize while the modal is open would otherwise leave the card stuck
      // at the wrong-breakpoint width. Recompute (debounced) so each side gets the
      // layout its media query expects. Bound + retained for disconnectedCallback.
      this._lbOpen = false;
      this._onResize = () => {
        if (!this._lbOpen) return;
        clearTimeout(this._dhResizeT);
        this._dhResizeT = setTimeout(() => this._applyCardWidth(), 150);
      };
      window.addEventListener("resize", this._onResize);

      if (!this.brandId || !this.galleryId) {
        this._showMessage("empty");
        return;
      }
      // Skeleton tiles are already in the markup (server-rendered) so the grey
      // placeholders paint with no delay; just mark the region busy and fetch.
      if (this.carousel) this.carousel.setAttribute("aria-busy", "true");
      this.setAttribute("data-dh-state", "loading");
      this._load();
    }

    disconnectedCallback() {
      // Remove the document/window listeners registered in connectedCallback so
      // they don't pile up (and leak this detached instance) when the theme
      // editor re-renders the section. Element-scoped listeners die with the node.
      if (this._onOverlayClose) document.removeEventListener("overlay:close", this._onOverlayClose);
      if (this._onResize) window.removeEventListener("resize", this._onResize);
      if (this._onDocTap) document.removeEventListener("click", this._onDocTap);
      clearTimeout(this._dhResizeT);
    }

    async _load() {
      const url =
        this.endpoint +
        "/public/brands/" +
        encodeURIComponent(this.brandId) +
        "/galleries/" +
        encodeURIComponent(this.galleryId) +
        "/media";
      try {
        const res = await fetch(url, { headers: { accept: "application/json" } });
        if (!res.ok) throw new Error("HTTP " + res.status);
        const json = await res.json();
        const data = json && json.data ? json.data : [];
        const items = data.slice().sort((a, b) => (a.order || 0) - (b.order || 0));
        if (!items.length) {
          this._showMessage("empty");
          return;
        }
        this.items = items;
        this._render(items);
      } catch (e) {
        this._showMessage("error");
      }
    }

    _tileSrc(media) {
      if (!media) return "";
      const sizes = media.image_sizes || {};
      if (sizes.original && sizes.original.url) return sizes.original.url;
      if (sizes.medium_square && sizes.medium_square.url) return sizes.medium_square.url;
      if (media.urls && media.urls.full) return media.urls.full;
      return "";
    }

    _render(items) {
      const frag = document.createDocumentFragment();
      if (!this.tileTpl) return;
      items.forEach((item, index) => {
        const src = this._tileSrc(item.media);
        if (!src) return;

        // Clone the tile template: media + a dim hover scrim carrying the DS
        // "Shop now" button. The whole tile opens the lightbox at this index
        // (delegated click on data-dh-tile); the button is the focusable control.
        const tile = this.tileTpl.content.firstElementChild.cloneNode(true);
        tile.dataset.index = index;
        const img = tile.querySelector("[data-dh-tile-img]");
        if (img) img.src = src;
        frag.appendChild(tile);
      });

      if (!frag.childNodes.length) {
        this._showMessage("empty");
        return;
      }

      this._clearSkeletons();
      this.track.appendChild(frag);
      if (this.status) this.status.hidden = true;
      this.removeAttribute("data-dh-state");
      if (this.carousel) {
        this.carousel.hidden = false;
        this.carousel.removeAttribute("aria-busy");
      }
      requestAnimationFrame(() => this._updateArrowVisibility());
    }

    _clearSkeletons() {
      this.track.querySelectorAll("[data-dh-skeleton]").forEach((el) => el.remove());
    }

    // Empty / error: a text message in place of the carousel.
    _showMessage(state) {
      this._clearSkeletons();
      if (this.status) {
        this.status.textContent = state === "empty" ? this.dataset.msgEmpty : this.dataset.msgError;
        this.status.hidden = false;
      }
      if (this.arrows) this.arrows.hidden = true;
      if (this.carousel) {
        this.carousel.hidden = true;
        this.carousel.removeAttribute("aria-busy");
      }
      this.setAttribute("data-dh-state", state);
    }

    _updateArrowVisibility() {
      if (!this.arrows || !this.track) return;
      const overflow = this.track.scrollWidth > this.track.clientWidth + 1;
      this.arrows.hidden = !overflow;
      this._syncArrows();
    }

    _syncArrows() {
      if (!this.track) return;
      // Read the track's own live scroll metrics rather than the carousel's
      // data-at-start/data-at-end attributes: those are set on activate while
      // the track is still empty (before tiles are injected), so they read
      // stale until the first user scroll.
      const atStart = this.track.scrollLeft <= 1;
      const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 1;
      if (this.prevBtn) this.prevBtn.disabled = atStart;
      if (this.nextBtn) this.nextBtn.disabled = atEnd;
    }

    // ---- Tile reveal (touch two-tap) ----------------------------------------

    // No-hover devices only: hover/focus can't reveal the scrim on touch, so the
    // tile needs an explicit reveal before the second tap opens the lightbox.
    _isTouch() {
      return !!(window.matchMedia && window.matchMedia("(hover: none)").matches);
    }

    // Reveal this tile's "Shop now" scrim (one at a time) and arm an outside-tap
    // dismiss. The delegated track handler runs before this document handler
    // (bubbles inner-first), so a tap on a tile is handled there and skipped here.
    _revealTile(tile) {
      this._clearRevealed(tile);
      tile.classList.add("instagram-dashudson__tile--revealed");
      if (!this._onDocTap) {
        this._onDocTap = (ev) => {
          const t = ev.target.closest && ev.target.closest("[data-dh-tile]");
          if (t && this.track && this.track.contains(t)) return;
          this._clearRevealed();
        };
        document.addEventListener("click", this._onDocTap);
      }
    }

    _clearRevealed(except) {
      if (!this.track) return;
      this.track.querySelectorAll(".instagram-dashudson__tile--revealed").forEach((el) => {
        if (el !== except) el.classList.remove("instagram-dashudson__tile--revealed");
      });
    }

    // ---- Lightbox -----------------------------------------------------------

    _mediaSrc(media) {
      if (!media) return "";
      if (media.type === "VIDEO") {
        const vs = media.video_sizes || {};
        if (vs.original && vs.original.url) return vs.original.url;
        if (media.urls && media.urls.full) return media.urls.full;
        return "";
      }
      const sizes = media.image_sizes || {};
      if (sizes.original && sizes.original.url) return sizes.original.url;
      if (media.urls && media.urls.full) return media.urls.full;
      if (sizes.medium_square && sizes.medium_square.url) return sizes.medium_square.url;
      return "";
    }

    _posterSrc(media) {
      const sizes = (media && media.image_sizes) || {};
      if (sizes.original && sizes.original.url) return sizes.original.url;
      if (media && media.urls && media.urls["640"]) return media.urls["640"];
      return "";
    }

    _buildLightbox(items) {
      if (!this.stage || !this.slideTpl) return;
      const frag = document.createDocumentFragment();
      items.forEach((item) => {
        const media = item.media || {};
        const src = this._mediaSrc(media);
        if (!src) return;

        const slide = this.slideTpl.content.firstElementChild.cloneNode(true);
        // Card width tracks the post's media aspect (decimal w/h; 3:4 fallback in CSS).
        if (media.original_width && media.original_height) {
          slide.style.setProperty("--dh-ar", media.original_width / media.original_height);
        }
        const frame = slide.querySelector("[data-dh-frame]");
        const products = slide.querySelector("[data-dh-products]");

        // Media -- the one client-injected, bespoke element (no snippet renders it).
        let mediaEl;
        if (media.type === "VIDEO") {
          mediaEl = document.createElement("video");
          mediaEl.controls = true;
          mediaEl.playsInline = true;
          mediaEl.preload = "metadata";
          const poster = this._posterSrc(media);
          if (poster) mediaEl.poster = poster;
          const source = document.createElement("source");
          source.src = src;
          source.type = "video/mp4";
          mediaEl.appendChild(source);
        } else {
          mediaEl = document.createElement("img");
          mediaEl.src = src;
          mediaEl.alt = "";
          mediaEl.loading = "lazy";
        }
        mediaEl.className = "instagram-dashudson__lightbox-img";
        frame.appendChild(mediaEl);

        const tagged = item.products || [];
        tagged.forEach((product, i) => {
          const num = i + 1;
          // Pin (bespoke positioned hotspot).
          if (this.pinTpl && typeof product.x === "number" && typeof product.y === "number") {
            const pin = this.pinTpl.content.firstElementChild.cloneNode(true);
            pin.style.left = product.x * 100 + "%";
            pin.style.top = product.y * 100 + "%";
            pin.querySelector("[data-dh-pin-num]").textContent = num;
            frame.appendChild(pin);
          }
          // Product row (DS button cloned from template; only href + text patched).
          if (this.productTpl) {
            const group = (product.product_groups && product.product_groups[0]) || {};
            const title = product.title || group.title || "";
            const url = product.url || group.url || "";
            const row = this.productTpl.content.firstElementChild.cloneNode(true);
            row.querySelector("[data-dh-num]").textContent = num;
            row.querySelector("[data-dh-title]").textContent = title;
            const shop = row.querySelector("[data-dh-shop]");
            if (url) {
              shop.setAttribute("href", url);
            } else if (shop) {
              shop.remove();
            }
            products.appendChild(row);
          }
        });

        // Posts with no tagged products keep the layout (media + the info panel)
        // and just render an empty right panel, so the card doesn't change shape.
        frag.appendChild(slide);
      });
      this.stage.appendChild(frag);
      this.modalBuilt = true;
    }

    _openLightbox(index) {
      if (!this.overlayEl) return;
      if (!this.modalBuilt) this._buildLightbox(this.items);
      this.activeIndex = index || 0;
      this._lbOpen = true;
      this.overlayEl.open();
      // Measure + size after the dialog lays out (still within the fade-in, so
      // the initial width set isn't seen as an animation).
      requestAnimationFrame(() => this._setActive(this.activeIndex));
    }

    // True cross-dissolve: toggle the active class (opacity cross-fades the
    // overlapping slides) and drive the card width to the active post.
    _setActive(i) {
      const slides = this.stage ? this.stage.children : [];
      if (!slides.length) return;
      const n = Math.max(0, Math.min(i, slides.length - 1));
      const prev = this.activeIndex;
      for (let k = 0; k < slides.length; k++) {
        const on = k === n;
        slides[k].classList.toggle("instagram-dashudson__lightbox-slide--active", on);
        slides[k].setAttribute("aria-hidden", on ? "false" : "true");
      }
      // Keep the outgoing slide painted (and on its own layer) while it fades
      // out, then drop it so only one slide paints at rest.
      if (prev !== n && slides[prev]) {
        const leaving = slides[prev];
        leaving.classList.add("instagram-dashudson__lightbox-slide--leaving");
        clearTimeout(leaving._dhLeaveT);
        leaving._dhLeaveT = setTimeout(() => {
          leaving.classList.remove("instagram-dashudson__lightbox-slide--leaving");
        }, 400);
      }
      this.activeIndex = n;
      this._applyCardWidth();
      this._pauseVideos();
      this._syncModalArrows();
    }

    // The card hugs the active post: drive the stage width to the active slide's
    // natural width (frame-by-aspect + info). px->px animates between posts;
    // mobile is full-bleed so the inline width is cleared.
    _applyCardWidth() {
      if (!this.stage) return;
      // <= 1024 (tablet upper bound) mirrors the lightbox's mobile-layout media
      // query: below the desktop breakpoint the sheet is full-bleed, so clear the
      // desktop card-hug width; at >=1025 drive the stage to the active post.
      if (window.innerWidth <= 1024) {
        this.stage.style.inlineSize = "";
        return;
      }
      const active = this.stage.children[this.activeIndex];
      if (active) this.stage.style.inlineSize = active.offsetWidth + "px";
    }

    _modalGo(dir) {
      this._setActive(this.activeIndex + dir);
    }

    _syncModalArrows() {
      if (!this.stage || !this.modalArrows) return;
      const total = this.stage.children.length;
      this.modalArrows.hidden = total <= 1;
      if (total <= 1) return;
      if (this.modalPrev) this.modalPrev.disabled = this.activeIndex <= 0;
      if (this.modalNext) this.modalNext.disabled = this.activeIndex >= total - 1;
    }

    _pauseVideos() {
      if (!this.stage) return;
      this.stage.querySelectorAll("video").forEach((v) => {
        try {
          v.pause();
        } catch (e) {
          /* noop */
        }
      });
    }
  }

  customElements.define("x-dash-hudson-gallery", DashHudsonGallery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-column"] && !Shopify.designMode) return;
  try {
    
  /* Wires the external prev/next arrow buttons to the composed carousel's public
     prev()/next() API and reflects the carousel's at-start/at-end edges onto the
     buttons' disabled state. The carousel owns scroll-snap, keyboard and swipe;
     this element only adds the desktop arrow affordance. */
  class MultiColumnCarousel extends HTMLElement {
    connectedCallback() {
      this.carousel = this.querySelector("x-carousel");
      this.prevButton = this.querySelector("[data-mc-prev]");
      this.nextButton = this.querySelector("[data-mc-next]");
      if (!this.carousel) return;

      this._onPrev = () => this.carousel.prev();
      this._onNext = () => this.carousel.next();
      this._onChange = () => this._syncEdges();

      if (this.prevButton) this.prevButton.addEventListener("click", this._onPrev);
      if (this.nextButton) this.nextButton.addEventListener("click", this._onNext);
      this.carousel.addEventListener("carousel:change", this._onChange);

      this._syncEdges();
      requestAnimationFrame(() => this._syncEdges());
    }

    disconnectedCallback() {
      if (this.prevButton) this.prevButton.removeEventListener("click", this._onPrev);
      if (this.nextButton) this.nextButton.removeEventListener("click", this._onNext);
      this.carousel?.removeEventListener("carousel:change", this._onChange);
    }

    _syncEdges() {
      if (!this.carousel) return;
      if (this.prevButton) this.prevButton.disabled = this.carousel.hasAttribute("data-at-start");
      if (this.nextButton) this.nextButton.disabled = this.carousel.hasAttribute("data-at-end");
    }
  }

  customElements.define("x-mc-carousel", MultiColumnCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-modal"]) return;
  try {
    
  (function () {
    if (!window.customElements) return;
    if (customElements.get("x-newsletter-modal")) return;

    var SUBSCRIBED_KEY = "seed-newsletter-subscribed";
    var DISMISSED_KEY = "seed-newsletter-dismissed";
    var DAY_MS = 24 * 60 * 60 * 1000;
    var OVERLAY_ID = "newsletter-modal";

    customElements.define(
      "x-newsletter-modal",
      class extends HTMLElement {
        connectedCallback() {
          if (this._initialised) return;
          this._initialised = true;

          this.delaySeconds = parseInt(this.dataset.delaySeconds, 10);
          if (isNaN(this.delaySeconds)) this.delaySeconds = 5;
          this.dismissDays = parseInt(this.dataset.dismissDays, 10) || 30;

          this.form = this.querySelector("[data-newsletter-form]");
          this.main = this.querySelector("[data-newsletter-main]");
          this.success = this.querySelector("[data-newsletter-success]");
          this.alert = this.querySelector("[data-newsletter-alert]");
          this.allCheckbox = this.querySelector("[data-pref-all]");
          this.itemCheckboxes = Array.prototype.slice.call(
            this.querySelectorAll("[data-pref-item]"),
          );

          this.onSubmit = this.onSubmit.bind(this);
          this.onOverlayClose = this.onOverlayClose.bind(this);
          this.onAllToggle = this.onAllToggle.bind(this);
          this.onItemToggle = this.onItemToggle.bind(this);

          if (this.form) this.form.addEventListener("submit", this.onSubmit);
          document.addEventListener("overlay:close", this.onOverlayClose);

          if (this.allCheckbox) {
            this.allCheckbox.addEventListener("change", this.onAllToggle);
          }
          this.itemCheckboxes.forEach(
            function (cb) {
              cb.addEventListener("change", this.onItemToggle);
            }.bind(this),
          );

          this.evaluate();
        }

        disconnectedCallback() {
          document.removeEventListener("overlay:close", this.onOverlayClose);
          if (this._timer) clearTimeout(this._timer);
        }

        /* ---- Persistence (mirrors region-modal: a self-clearing dismissed flag
           with an expiry + a permanent subscribed flag). ---- */
        isSubscribed() {
          try {
            return window.localStorage.getItem(SUBSCRIBED_KEY) === "true";
          } catch (error) {
            return false;
          }
        }

        setSubscribed() {
          try {
            window.localStorage.setItem(SUBSCRIBED_KEY, "true");
          } catch (error) {
            /* storage unavailable -- fail open */
          }
        }

        isDismissed() {
          try {
            var raw = window.localStorage.getItem(DISMISSED_KEY);
            if (!raw) return false;
            var data = JSON.parse(raw);
            if (data && data.expiresAt && data.expiresAt > Date.now()) return true;
            window.localStorage.removeItem(DISMISSED_KEY);
            return false;
          } catch (error) {
            return false;
          }
        }

        setDismissed() {
          try {
            var expiresAt = Date.now() + this.dismissDays * DAY_MS;
            window.localStorage.setItem(
              DISMISSED_KEY,
              JSON.stringify({ dismissed: true, expiresAt: expiresAt }),
            );
          } catch (error) {
            /* storage unavailable -- fail open */
          }
        }

        isSuppressed() {
          return this.isSubscribed() || this.isDismissed();
        }

        /* ---- Trigger: gated on BOTH the timed delay AND the geo gate. ----
           The newsletter waits for max(trigger-duration, geo-settled): the
           delay timer starts at page load and runs CONCURRENTLY with the geo
           flow, so when no geo surfaces the appearance time is just the delay,
           and when geo surfaces the newsletter is held until the geo modal
           closes (its duration has typically already elapsed during the geo
           interaction). See geoSettled() for the gate's contract. ---- */
        evaluate() {
          if (this.isSuppressed()) return;
          var self = this;
          var delayElapsed = new Promise(function (resolve) {
            self._timer = window.setTimeout(resolve, self.delaySeconds * 1000);
          });
          Promise.all([delayElapsed, this.geoSettled()]).then(function () {
            self.tryOpen();
          });
        }

        /* Resolve when the geo flow has SETTLED. Geo is in
           play iff <x-region-modal> is present in the DOM; if it is absent
           there is nothing to wait for. When present, the region element is
           the authority and publishes window.Seed.geo -- but custom-element
           upgrade order is not guaranteed, so resolve via whichever signal
           lands first and never miss an already-fired settle:
             - the synchronous Seed.geo.done flag (settled before we looked);
             - the Seed.geo.settled promise (gate exists, still pending);
             - a one-shot `seed:geo-settled` event (gate created/settled after
               we attached, e.g. region upgrades later).
           customElements.whenDefined('x-region-modal') re-reads the gate once
           the region element upgrades, covering the present-but-not-yet-defined
           window. This does NOT depend on region rendering before newsletter. */
        geoSettled() {
          if (!document.querySelector("x-region-modal")) return Promise.resolve();
          return new Promise(function (resolve) {
            var done = false;
            var settle = function () {
              if (done) return;
              done = true;
              document.removeEventListener("seed:geo-settled", settle);
              resolve();
            };
            var readGate = function () {
              var gate = window.Seed && window.Seed.geo;
              if (!gate) return;
              if (gate.done) {
                settle();
              } else if (gate.settled && typeof gate.settled.then === "function") {
                gate.settled.then(settle);
              }
            };
            document.addEventListener("seed:geo-settled", settle);
            readGate();
            if (!done && window.customElements && customElements.whenDefined) {
              customElements.whenDefined("x-region-modal").then(readGate);
            }
          });
        }

        tryOpen() {
          if (this.isSuppressed()) return;
          // A PLP back-navigation restore is returning the shopper to their exact
          // scroll position; opening now would take the scroll-lock (pinning the
          // body) mid-restore, so the restore's scroll-to-product becomes a no-op
          // and it lands on the first page. Defer until the restore signals done.
          if (window.__coveoPlpRestore) {
            this._deferred = true;
            if (!this._restoreWait) {
              this._restoreWait = true;
              var self = this;
              document.addEventListener(
                "coveo:plp-restore-done",
                function () {
                  self._restoreWait = false;
                  if (self._deferred) self.tryOpen();
                },
                { once: true },
              );
            }
            return;
          }
          // Gate (delay + geo settle) is satisfied, but if some OTHER overlay
          // happens to be open at this instant (e.g. the visitor opened
          // search/cart during the wait), DEFER and retry on the next
          // overlay:close rather than permanently no-op'ing -- the
          // single-overlay rule means we must never stack.
          if (document.querySelector("dialog.overlay[open]")) {
            this._deferred = true;
            return;
          }
          this._deferred = false;
          this.openOverlay();
        }

        openOverlay() {
          var overlay = this.querySelector("x-overlay");
          if (overlay && typeof overlay.open === "function") {
            overlay.open();
            this.focusContainer();
            return;
          }
          // The overlay base element may upgrade after this one; wait for it.
          if (customElements.whenDefined) {
            var self = this;
            customElements.whenDefined("x-overlay").then(function () {
              var el = self.querySelector("x-overlay");
              if (el && typeof el.open === "function") {
                el.open();
                self.focusContainer();
              }
            });
          }
        }

        focusContainer() {
          // No-focus-on-open (mirrors region-modal): the overlay
          // base focuses the close ((x)) synchronously inside open(). Move initial
          // focus to the dialog container itself instead so NOTHING appears
          // focused -- WebKit does match :focus-visible on programmatic focus, so
          // the ring is kept off the container by `outline: 0` in the overlay
          // base. tabindex=-1 keeps it out of the tab order; focus stays
          // inside the dialog so the native focus-trap + Escape are unaffected.
          // Next frame, so it lands AFTER the base's synchronous close-focus.
          var self = this;
          var raf = window.requestAnimationFrame;
          if (!raf) return;
          raf(function () {
            var dialog = self.querySelector("dialog.overlay");
            if (dialog && typeof dialog.focus === "function") {
              dialog.setAttribute("tabindex", "-1");
              dialog.focus();
            }
          });
        }

        onOverlayClose(event) {
          if (!event.detail) return;
          if (event.detail.id === OVERLAY_ID) {
            // X / Escape / backdrop all route through overlay:close -- record the
            // dismissal once, for every dismiss path (unless they subscribed).
            if (!this.isSubscribed()) this.setDismissed();
          } else if (this._deferred) {
            // A previously-blocking overlay closed; the gate was already
            // satisfied, so retry now that the field is clear. (The geo modal
            // closing is handled by the geoSettled gate, not here.)
            this.tryOpen();
          }
        }

        /* ---- "All" checkbox interplay: All is MUTUALLY
           EXCLUSIVE with the five specific options. Selecting All clears the
           five (it does NOT pre-check them); selecting any specific option
           clears All. (When All stays checked it still expands to every
           category in the payload -- see buildPayload.) ---- */
        onAllToggle() {
          if (this.allCheckbox.checked) {
            this.itemCheckboxes.forEach(function (cb) {
              cb.checked = false;
            });
          }
        }

        onItemToggle() {
          if (!this.allCheckbox) return;
          var anyItemChecked = this.itemCheckboxes.some(function (cb) {
            return cb.checked;
          });
          if (anyItemChecked) this.allCheckbox.checked = false;
        }

        /* ---- Submit: validate client-side, POST via the App Proxy, then show
           the success panel + Braze events, or the form-level alert on failure. ---- */
        onSubmit(event) {
          event.preventDefault();
          if (this._submitting) return;

          if (!this.validateFields()) return;

          this._submitting = true;
          var submitButton = this.form.querySelector('button[type="submit"]');
          if (submitButton) submitButton.disabled = true;
          this.hideAlert();

          // buildPayload's snake_case field names map to the Worker route's
          // camelCase transport keys; dob is already ISO (YYYY-MM-DD) and
          // preferences already has "All" expanded to the five concrete values.
          var payload = this.buildPayload();
          var self = this;

          fetch("/apps/cloud/newsletter-modal", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({
              email: payload.email,
              firstName: payload.first_name,
              lastName: payload.last_name,
              dob: payload.dob,
              preferences: payload.preferences,
            }),
          })
            .then(function (response) {
              return response
                .json()
                .catch(function () {
                  return {};
                })
                .then(function (body) {
                  // A returning subscriber is not a signup: surface it on the
                  // email field instead of the success panel, and make no
                  // Shopify write because profile edits belong to account UI.
                  if (response.ok && body && body.error === "already_subscribed") {
                    throw new Error("already_subscribed");
                  }
                  if (!response.ok || !body || body.success !== true) {
                    throw new Error((body && body.error) || "newsletter_failed");
                  }
                  return body;
                });
            })
            .then(function (body) {
              self.logBraze(body);
              self.onSubscribed();
            })
            .catch(function (err) {
              // already_subscribed / non-2xx / network / malformed response: no
              // success state, re-enable the submit for a retry.
              self._submitting = false;
              if (submitButton) submitButton.disabled = false;
              if (err && err.message === "already_subscribed") {
                self.showAlreadySubscribed();
                return;
              }
              self.showAlert();
            });
        }

        /* ---- Braze: identify + tag the signup after a successful subscription.
           Degrades silently when the wrapper is absent, so the subscribe flow
           never depends on it. ---- */
        logBraze(body) {
          try {
            var braze = window.SeedBraze;
            if (!braze) return;
            if (body && body.customerId) braze.changeUser(body.customerId);
            braze.safeLog("online_signup", { source: "popup" });
          } catch (err) {
            /* analytics must never break the subscribe flow */
          }
        }

        showAlert() {
          if (!this.alert) return;
          this.alert.textContent = this.dataset.errorGeneric || "";
          this.alert.hidden = false;
        }

        /* An already-subscribed reply is about ONE field, so it renders on the
           email input through the DS input's sticky external-error API (footer
           parity) rather than the form-level alert -- editing the address
           dismisses it, and the field's own format check cannot wipe it. */
        showAlreadySubscribed() {
          var control = this.form.querySelector('[name="email"]');
          var emailInput = control ? control.closest("x-input") : null;
          if (emailInput && typeof emailInput.setExternalError === "function") {
            emailInput.setExternalError(this.dataset.errorAlready);
            if (typeof control.focus === "function") control.focus();
            return;
          }
          if (!this.alert) return;
          this.alert.textContent = this.dataset.errorAlready || "";
          this.alert.hidden = false;
        }

        hideAlert() {
          if (!this.alert) return;
          this.alert.hidden = true;
          this.alert.textContent = "";
        }

        validateFields() {
          // Trigger each DS field's own opt-in validation (required / email /
          // date format), which renders the inline message in its form-field
          // slot. Then block on any field left in the error state.
          var fields = this.querySelectorAll("x-input, x-date-picker");
          Array.prototype.forEach.call(fields, function (el) {
            if (typeof el.validate === "function") el.validate();
          });
          var firstError = this.querySelector(".form-field--error");
          if (firstError) {
            var control = firstError.querySelector("input");
            if (control && typeof control.focus === "function") control.focus();
            return false;
          }
          return true;
        }

        buildPayload() {
          var get = function (name) {
            var el = this.form.querySelector('[name="' + name + '"]');
            return el ? el.value.trim() : "";
          }.bind(this);

          // "All" is a meta-control, never itself a payload value. When it is
          // checked it MEANS every category -- including the default state,
          // where "All" ships checked with the five items visually unchecked.
          // Expand it to the five item values so the common
          // accept-the-default submit carries all preferences, not an empty
          // array. Otherwise serialise just the individually-checked items.
          var preferences = [];
          if (this.allCheckbox && this.allCheckbox.checked) {
            this.itemCheckboxes.forEach(function (cb) {
              preferences.push(cb.value);
            });
          } else {
            this.itemCheckboxes.forEach(function (cb) {
              if (cb.checked) preferences.push(cb.value);
            });
          }

          // dob is the date-picker's hidden ISO (YYYY-MM-DD) input.
          var dobEl = this.form.querySelector('[name="dob"]');
          return {
            email: get("email"),
            first_name: get("first_name"),
            last_name: get("last_name"),
            dob: dobEl ? dobEl.value : "",
            preferences: preferences,
          };
        }

        onSubscribed() {
          this.setSubscribed();
          if (this.main) this.main.hidden = true;
          if (this.success) {
            this.success.hidden = false;
            var heading = this.success.querySelector("[data-newsletter-success-heading]");
            if (heading && typeof heading.focus === "function") heading.focus();
          }
          // GA4 generate_lead for the modal surface. This form is AJAX, so success
          // is known client-side here; publish the custom event the storefront
          // web pixel bridges to GA4. No-ops if Shopify.analytics is unavailable.
          try {
            var api = window.Shopify && window.Shopify.analytics;
            if (api && typeof api.publish === "function") {
              var currency =
                (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "";
              api.publish("custom_generate_lead", {
                event: "generate_lead",
                currency: currency,
                value: 0,
              });
            }
          } catch (err) {
            /* analytics must never break the subscribe flow */
          }
        }
      },
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  class SeedPasswordReveal extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector("[data-password-reveal-trigger]");
      this.input = this.querySelector(".input__control");

      // Mark enhanced so the CSS collapses to the trigger until revealed.
      this.classList.add("is-enhanced");

      // A server-side error means an incorrect password was just submitted --
      // start revealed so the field and its error are visible immediately.
      if (this.querySelector(".form-field--error")) {
        this.classList.add("is-revealed");
      }

      if (!this.trigger) return;
      this.onReveal = this.onReveal.bind(this);
      this.trigger.addEventListener("click", this.onReveal);
    }

    onReveal(event) {
      event.preventDefault();
      this.classList.add("is-revealed");
      if (this.input) this.input.focus();
    }
  }

  if (!customElements.get("x-password-reveal")) {
    customElements.define("x-password-reveal", SeedPasswordReveal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  /* Wires the external prev/next arrow buttons to the composed carousel's public prev()/next()
     API, reflects the carousel's at-start/at-end edges onto the buttons' disabled state, and shows
     the arrow group only when the active carousel overflows. Edge/overflow state is read from LIVE
     track geometry (not the carousel's data-at-* attributes, which can be stale right after a tab
     swap on a previously-hidden panel). In tabbed mode the active carousel is whichever panel is
     visible; <x-tabs> toggles panel [hidden] with no event, so a MutationObserver re-points the
     arrows on tab change. The carousel owns scroll-snap, keyboard and swipe. */
  class XProductCarousel extends HTMLElement {
    connectedCallback() {
      this.isTabs = this.hasAttribute("data-tabs");
      /* Scoped to the nav group because every product card carries arrows under the same
         attribute names, and in tabbed mode the cards precede the group in document order. */
      this.prevButton = this.querySelector("[data-pc-nav] [data-pc-prev]");
      this.nextButton = this.querySelector("[data-pc-nav] [data-pc-next]");
      this.nav = this.querySelector("[data-pc-nav]");

      this._onPrev = () => {
        const c = this._active();
        if (c) c.prev();
      };
      this._onNext = () => {
        const c = this._active();
        if (c) c.next();
      };
      this._onChange = () => this._schedule();
      this._onResize = () => this._schedule();

      if (this.prevButton) this.prevButton.addEventListener("click", this._onPrev);
      if (this.nextButton) this.nextButton.addEventListener("click", this._onNext);
      this.addEventListener("carousel:change", this._onChange);
      window.addEventListener("resize", this._onResize, { passive: true });

      if (this.isTabs) {
        this._mo = new MutationObserver(() => this._schedule());
        this.querySelectorAll('[role="tabpanel"]').forEach((p) =>
          this._mo.observe(p, { attributes: true, attributeFilter: ["hidden"] }),
        );
      }

      // Defer past the inner carousel's own connect + first page-count sync.
      this._schedule();
      requestAnimationFrame(() => this._schedule());
    }

    disconnectedCallback() {
      if (this.prevButton) this.prevButton.removeEventListener("click", this._onPrev);
      if (this.nextButton) this.nextButton.removeEventListener("click", this._onNext);
      this.removeEventListener("carousel:change", this._onChange);
      window.removeEventListener("resize", this._onResize);
      if (this._mo) this._mo.disconnect();
    }

    _active() {
      if (this.isTabs) {
        const panel = this.querySelector('[role="tabpanel"]:not([hidden])');
        return panel ? panel.querySelector("x-carousel") : null;
      }
      return this.querySelector("x-carousel");
    }

    _schedule() {
      // Double rAF: a just-unhidden panel's carousel needs a layout pass before its track geometry
      // is correct (a hidden panel measures 0-width and latches a stale state with no event).
      if (this._raf) cancelAnimationFrame(this._raf);
      this._raf = requestAnimationFrame(() => {
        this._raf = requestAnimationFrame(() => this._refresh());
      });
    }

    _refresh() {
      const c = this._active();
      if (!c || !this.nav) return;
      const track = c.querySelector("[data-carousel-track]");
      if (!track) return;
      // Static grid (mobile grid mode) collapses the track to display:contents, so it never scrolls
      // -- scrollWidth <= clientWidth keeps overflow false and the nav stays hidden. On desktop the
      // track is the scroll container and this reflects real overflow + edges.
      const overflow = track.scrollWidth > track.clientWidth + 1;
      if (overflow) this.nav.setAttribute("data-has-overflow", "");
      else this.nav.removeAttribute("data-has-overflow");
      const atStart = track.scrollLeft <= 1;
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      if (this.prevButton) this.prevButton.disabled = atStart;
      if (this.nextButton) this.nextButton.disabled = atEnd;
    }
  }

  if (!customElements.get("x-product-carousel")) {
    customElements.define("x-product-carousel", XProductCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  class ProductReviews extends HTMLElement {
    connectedCallback() {
      this._onClick = this._onClick.bind(this);
      document.addEventListener("click", this._onClick);
    }

    disconnectedCallback() {
      document.removeEventListener("click", this._onClick);
      this._stopTracking();
    }

    _onClick(event) {
      // Above-fold stars / any #reviews link -> smooth-scroll to this section.
      const scrollTrigger = event.target.closest('[data-reviews-scroll], a[href="#reviews"]');
      if (!scrollTrigger) return;
      event.preventDefault();
      this._scrollToSection();
    }

    // Offset for the sticky header so it doesn't cover the section top. The header
    // is `position: sticky` on its `.shopify-section` wrapper (only when the
    // merchant enables sticky -> `.header--sticky`); measure that pinned box live
    // (its height differs desktop/mobile), plus a small breathing gap. 0 when the
    // header isn't sticky (it scrolls away with the page).
    _headerOffset() {
      const stickyHeader = document.querySelector(".header--sticky");
      const headerSection = stickyHeader ? stickyHeader.closest(".shopify-section") : null;
      return headerSection ? Math.ceil(headerSection.getBoundingClientRect().height) + 16 : 0;
    }

    _align(behavior) {
      this.style.scrollMarginTop = this._headerOffset() + "px";
      this.scrollIntoView({ behavior: behavior, block: "start" });
    }

    // This section is LAST on the PDP, below product recommendations and
    // recently-viewed -- sections that inject their content late and push this one
    // down after the click. A single scroll targets a Y that's about to move and
    // overshoots onto a neighbouring section. So fire a NATIVE smooth scroll (no
    // per-frame jank, natural speed), then re-align only when the section actually
    // drifts -- a few times a second until the page settles, the user takes over,
    // or a time budget elapses. When the page is already settled it fires once and
    // corrects nothing.
    _scrollToSection() {
      const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      this._align(reduceMotion ? "auto" : "smooth");
      if (reduceMotion) return;

      this._stopTracking();
      const startedAt = Date.now();
      const onUser = () => {
        this._userTookOver = true;
      };
      // Keyboard scrolling (arrows, Space, PageUp/Down, Home/End) and
      // scrollbar-drag fire neither wheel nor touchmove, so a keyboard user who
      // scrolls away during the re-align window would be yanked back. Treat the
      // scroll keys as takeover too. A generic `scroll` listener can't be used --
      // our own scrollIntoView('smooth') emits scroll events for the whole
      // animation, which would false-trigger takeover and defeat the re-align.
      const scrollKeys = [
        "ArrowUp",
        "ArrowDown",
        "PageUp",
        "PageDown",
        "Home",
        "End",
        " ",
        "Spacebar",
      ];
      const onKey = (e) => {
        if (scrollKeys.includes(e.key)) this._userTookOver = true;
      };
      this._userTookOver = false;
      window.addEventListener("wheel", onUser, { passive: true });
      window.addEventListener("touchmove", onUser, { passive: true });
      window.addEventListener("keydown", onKey, { passive: true });
      this._trackCleanup = () => {
        window.removeEventListener("wheel", onUser);
        window.removeEventListener("touchmove", onUser);
        window.removeEventListener("keydown", onKey);
      };
      this._trackTimer = setInterval(() => {
        if (this._userTookOver || Date.now() - startedAt > 3000) {
          this._stopTracking();
          return;
        }
        const drift = this.getBoundingClientRect().top - this._headerOffset();
        if (Math.abs(drift) > 4) this._align("smooth");
      }, 200);
    }

    _stopTracking() {
      clearInterval(this._trackTimer);
      this._trackTimer = null;
      if (this._trackCleanup) {
        this._trackCleanup();
        this._trackCleanup = null;
      }
    }
  }

  if (!customElements.get("product-reviews")) {
    customElements.define("product-reviews", ProductReviews);
  }

  // Custom write-review form -> Yotpo public submit API. Owns star/chip/field
  // state, single-select chip groups, validation, the urlencoded POST, and the
  // form <-> thank-you swap. Footer CTAs live in the overlay footer slot (a
  // sibling region inside the same dialog), wired via the dialog root.
  class ReviewForm extends HTMLElement {
    connectedCallback() {
      const cfgEl = this.querySelector("[data-review-config]");
      try {
        this.cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {};
      } catch (e) {
        this.cfg = {};
      }

      this.formPanel = this.querySelector('[data-review-panel="form"]');
      this.thanksPanel = this.querySelector('[data-review-panel="thanks"]');
      this.errorEl = this.querySelector("[data-review-error]");

      const dialog = this.closest(".overlay");
      this.footer = dialog ? dialog.querySelector(".overlay__footer") : null;
      this.ctaForm = this.footer ? this.footer.querySelector('[data-review-cta="form"]') : null;
      this.ctaThanks = this.footer ? this.footer.querySelector('[data-review-cta="thanks"]') : null;
      this.submitBtn = this.footer ? this.footer.querySelector("[data-review-submit]") : null;
      this.clearBtn = this.footer ? this.footer.querySelector("[data-review-clear]") : null;

      this._onChipChange = this._onChipChange.bind(this);
      this._onSubmit = this._onSubmit.bind(this);
      this._onClear = this._onClear.bind(this);
      this._onOverlayClose = this._onOverlayClose.bind(this);
      // Keep Submit enabled state in sync with form completeness. Text/textarea
      // edits bubble `input`; star radios and the terms checkbox bubble `change`,
      // so one listener of each on the host catches every required control.
      this._syncSubmitState = this._syncSubmitState.bind(this);

      this.addEventListener("size-chip:change", this._onChipChange);
      this.addEventListener("input", this._syncSubmitState);
      this.addEventListener("change", this._syncSubmitState);
      if (this.submitBtn) this.submitBtn.addEventListener("click", this._onSubmit);
      if (this.clearBtn) this.clearBtn.addEventListener("click", this._onClear);
      document.addEventListener("overlay:close", this._onOverlayClose);

      this._syncSubmitState();
    }

    disconnectedCallback() {
      this.removeEventListener("size-chip:change", this._onChipChange);
      this.removeEventListener("input", this._syncSubmitState);
      this.removeEventListener("change", this._syncSubmitState);
      if (this.submitBtn) this.submitBtn.removeEventListener("click", this._onSubmit);
      if (this.clearBtn) this.clearBtn.removeEventListener("click", this._onClear);
      document.removeEventListener("overlay:close", this._onOverlayClose);
    }

    // Single-select: pressing a chip selects it and releases its siblings.
    _onChipChange(event) {
      const detail = event.detail || {};
      const group = this.querySelectorAll('.size-chip[data-size-chip-name="' + detail.name + '"]');
      group.forEach((chip) => {
        const on = chip.dataset.sizeChipValue === detail.value;
        chip.classList.toggle("size-chip--selected", on);
        if (on) {
          chip.setAttribute("aria-pressed", "true");
        } else {
          chip.removeAttribute("aria-pressed");
        }
      });
    }

    _showError(message) {
      if (!this.errorEl) return;
      if (message) {
        this.errorEl.textContent = message;
        this.errorEl.hidden = false;
      } else {
        this.errorEl.textContent = "";
        this.errorEl.hidden = true;
      }
    }

    _selectedChip(group) {
      const el = this.querySelector(
        ".review-form__chips--" + group + ' .size-chip[aria-pressed="true"]',
      );
      return el ? el.dataset.sizeChipValue : "";
    }

    _validate() {
      const controls = ["#review-name", "#review-title", "#review-body"];
      for (let i = 0; i < controls.length; i += 1) {
        const el = this.querySelector(controls[i]);
        if (el && !el.checkValidity()) {
          el.reportValidity();
          el.focus();
          return false;
        }
      }
      // Email delegates to the DS <x-input> so required + format use the design
      // system's stricter rule (rejects e.g. name@domain with no dotted TLD) and
      // surface the inline DS error. Fall back to native if <x-input> hasn't upgraded.
      const emailEl = this.querySelector("#review-email");
      if (emailEl) {
        const emailX = emailEl.closest("x-input");
        if (emailX && typeof emailX.checkValidity === "function") {
          if (!emailX.checkValidity()) {
            emailEl.focus();
            return false;
          }
        } else if (!emailEl.checkValidity()) {
          emailEl.reportValidity();
          emailEl.focus();
          return false;
        }
      }
      const score = this.querySelector('input[name="review_score"]:checked');
      if (!score) {
        this._showError(this.cfg.ratingRequired || "Please choose a star rating.");
        return false;
      }
      const terms = this.querySelector("#review-terms");
      if (terms && !terms.checked) {
        this._showError(this.cfg.termsRequired || "Please accept the terms to continue.");
        return false;
      }
      return true;
    }

    // Side-effect-free completeness check that gates the Submit button. Mirrors
    // _validate()'s required set field-for-field (no reportValidity/focus/error),
    // so Submit is enabled iff _validate() would pass. Fit/recommend chips are optional.
    _isComplete() {
      const controls = ["#review-name", "#review-title", "#review-body"];
      for (let i = 0; i < controls.length; i += 1) {
        const el = this.querySelector(controls[i]);
        if (el && !el.checkValidity()) return false;
      }
      // Email must be non-empty and pass the DS dotted-domain rule. Reuse
      // x-input.isValidEmail so the gate matches the DS blur error without repainting
      // the field red while the shopper is still typing; native fallback if needed.
      const emailEl = this.querySelector("#review-email");
      if (emailEl) {
        const emailX = emailEl.closest("x-input");
        if (emailEl.value.trim() === "") return false;
        if (emailX && typeof emailX.isValidEmail === "function") {
          if (!emailX.isValidEmail(emailEl.value)) return false;
        } else if (!emailEl.checkValidity()) {
          return false;
        }
      }
      if (!this.querySelector('input[name="review_score"]:checked')) return false;
      const terms = this.querySelector("#review-terms");
      if (terms && !terms.checked) return false;
      return true;
    }

    // Enable/disable Submit from _isComplete(). Skips while a submit is in flight
    // (aria-busy) so an input/change racing the POST can't re-enable the button.
    _syncSubmitState() {
      if (!this.submitBtn) return;
      if (this.submitBtn.getAttribute("aria-busy") === "true") return;
      const complete = this._isComplete();
      this.submitBtn.disabled = !complete;
      this.submitBtn.setAttribute("aria-disabled", complete ? "false" : "true");
    }

    _onSubmit() {
      this._showError("");
      if (!this.cfg.appkey) {
        this._showError(this.cfg.error || "Reviews are not configured.");
        return;
      }
      if (!this._validate()) return;

      const q = (s) => this.querySelector(s);
      const score = q('input[name="review_score"]:checked');
      const name = q("#review-name");
      const email = q("#review-email");
      const title = q("#review-title");
      const body = q("#review-body");
      const anon = q("#review-anonymous");

      const displayName =
        anon && anon.checked ? this.cfg.anonymousName || "Anonymous" : name.value.trim();

      const params = new URLSearchParams();
      params.set("appkey", this.cfg.appkey);
      params.set("sku", String(this.cfg.sku || ""));
      params.set("review_score", score.value);
      params.set("review_title", title.value.trim());
      params.set("review_content", body.value.trim());
      params.set("display_name", displayName);
      params.set("email", email.value.trim());
      params.set("review_source", "widget_v3");
      params.set("uploaded_images", "[]");
      if (this.cfg.productTitle) params.set("product_title", this.cfg.productTitle);
      if (this.cfg.productUrl) params.set("product_url", this.cfg.productUrl);
      if (this.cfg.productImageUrl) params.set("product_image_url", this.cfg.productImageUrl);

      const fit = this._selectedChip("fit");
      if (fit) params.set("custom_fields[--" + this.cfg.fitFieldId + "]", fit);
      const rec = this._selectedChip("rec");
      if (rec) params.set("custom_fields[--" + this.cfg.recFieldId + "]", rec);

      if (this.submitBtn) {
        this.submitBtn.disabled = true;
        this.submitBtn.setAttribute("aria-busy", "true");
      }

      // Cross-origin urlencoded POST. Yotpo does not send CORS headers to the
      // storefront, so use no-cors: the response is opaque and a resolved fetch is
      // the only success signal available.
      fetch(this.cfg.endpoint, {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: params.toString(),
      })
        .then(() => {
          this._showThanks();
        })
        .catch(() => {
          this._showError(this.cfg.error || "Something went wrong. Please try again.");
          if (this.submitBtn) {
            this.submitBtn.disabled = false;
            this.submitBtn.removeAttribute("aria-busy");
          }
        });
    }

    _showThanks() {
      this._showError("");
      if (this.formPanel) this.formPanel.hidden = true;
      if (this.thanksPanel) this.thanksPanel.hidden = false;
      if (this.ctaForm) this.ctaForm.hidden = true;
      if (this.ctaThanks) this.ctaThanks.hidden = false;
    }

    _showForm() {
      if (this.thanksPanel) this.thanksPanel.hidden = true;
      if (this.formPanel) this.formPanel.hidden = false;
      if (this.ctaThanks) this.ctaThanks.hidden = true;
      if (this.ctaForm) this.ctaForm.hidden = false;
      // Clear the in-flight busy flag, then re-gate on completeness; the reset form
      // returns Submit to disabled.
      if (this.submitBtn) this.submitBtn.removeAttribute("aria-busy");
      this._syncSubmitState();
    }

    _onClear() {
      this._showError("");
      this.querySelectorAll("input, textarea").forEach((el) => {
        if (el.type === "radio" || el.type === "checkbox") {
          el.checked = false;
        } else {
          el.value = "";
        }
        // Clear is a RESET, not a submit: strip any existing error/warning/
        // completed state on the owning DS field FIRST, then sync counters/labels
        // via `input`/`change`. Crucially we do NOT dispatch `blur` -- the DS
        // fields validate on blur, so a blur here would surface "Required" on
        // every empty field. Stripping the state before the `input` dispatch also
        // stops <x-input>'s onInput from re-validating a still-erroring field.
        const field = el.closest(".form-field");
        if (field) {
          field.classList.remove(
            "form-field--error",
            "form-field--warning",
            "form-field--completed",
          );
          el.removeAttribute("aria-invalid");
          const msg = field.querySelector('.form-field__message[role="alert"]');
          if (msg) msg.textContent = "";
        }
        el.dispatchEvent(new Event("input", { bubbles: true }));
        el.dispatchEvent(new Event("change", { bubbles: true }));
      });
      this.querySelectorAll('.size-chip[aria-pressed="true"]').forEach((chip) => {
        chip.classList.remove("size-chip--selected");
        chip.removeAttribute("aria-pressed");
      });
      // Chip release fires no input/change, so sync the now-empty submit gate explicitly.
      this._syncSubmitState();
    }

    _onOverlayClose(event) {
      if (!event.detail || event.detail.id !== "review-drawer") return;
      // If the drawer closes after a successful submit, reset it for next open.
      if (this.thanksPanel && !this.thanksPanel.hidden) {
        this._onClear();
        this._showForm();
      }
    }
  }

  if (!customElements.get("review-form")) {
    customElements.define("review-form", ReviewForm);
  }

  // Custom reviews state: fetches Yotpo's public v3 storefront reviews API and
  // renders theme-owned summary, list and pager markup.
  //
  // One Yotpo call per surface on load: the PDP hits the buy-box /ratings call
  // and this section's /reviews call. The /reviews response also carries the
  // custom-question aggregate (bottomline.customFieldsBottomline), which positions
  // the fit slider. The recommend percentage cannot use that aggregate because
  // Yotpo rounds the mean, so it is counted from the review set on first load.
  // Further list pages are fetched on demand when Next is pressed.
  class ReviewsList extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      const cfgEl = this.querySelector("[data-reviews-config]");
      try {
        this.cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {};
      } catch (e) {
        this.cfg = {};
      }
      this.labels = this.cfg.labels || {};
      this.perPage = this.cfg.perPage || 3;
      this.sort = "date";
      this.page = 1;
      this.pages = 1;
      this._pagesFromTotal = 1;
      this.hasNext = false;
      this.cache = {};

      this.itemsEl = this.querySelector("[data-reviews-items]");
      // Snapshot the SSR'd skeleton rows so sort reloads can restore them after
      // a render has cleared the container.
      this._skeletonHtml = this.itemsEl ? this.itemsEl.innerHTML : "";
      this.countEl = this.querySelector("[data-reviews-count]");
      this.summaryStars = this.querySelector(
        ".reviews-summary__card--stars [data-star-rating-fill]",
      );
      this.recommendCard = this.querySelector('[data-reviews-card="recommend"]');
      this.recommendEl = this.querySelector("[data-reviews-recommend]");
      this.fitCard = this.querySelector('[data-reviews-card="fit"]');
      this.fitMarker = this.querySelector("[data-reviews-fit-marker]");
      this.pagerEl = this.querySelector("[data-reviews-pager]");
      this.statusEl = this.querySelector("[data-reviews-status]");
      this.prevBtn = this.querySelector("[data-reviews-prev]");
      this.nextBtn = this.querySelector("[data-reviews-next]");
      this.rowTpl = this.querySelector("template[data-review-row]");

      this._onSort = this._onSort.bind(this);
      this._onPrev = this._onPrev.bind(this);
      this._onNext = this._onNext.bind(this);
      // The DS dropdown emits a bubbling `dropdown:change` -- listen on the host.
      this.addEventListener("dropdown:change", this._onSort);
      if (this.prevBtn) this.prevBtn.addEventListener("click", this._onPrev);
      if (this.nextBtn) this.nextBtn.addEventListener("click", this._onNext);

      if (!this.cfg.appkey || !this.cfg.productId || !this.rowTpl) return;
      this._showLoading();
      this._goToPage(1);
    }

    // Enter the loading state: restore SSR'd skeleton rows after prior renders and
    // mark the list busy again.
    _showLoading() {
      this.setAttribute("data-reviews-state", "loading");
      if (this.itemsEl) {
        this.itemsEl.innerHTML = this._skeletonHtml;
        this.itemsEl.setAttribute("aria-busy", "true");
      }
    }

    disconnectedCallback() {
      this.removeEventListener("dropdown:change", this._onSort);
      if (this.prevBtn) this.prevBtn.removeEventListener("click", this._onPrev);
      if (this.nextBtn) this.nextBtn.removeEventListener("click", this._onNext);
    }

    _apiBase() {
      return (
        "https://api-cdn.yotpo.com/v3/storefront/store/" +
        encodeURIComponent(this.cfg.appkey) +
        "/product/" +
        encodeURIComponent(this.cfg.productId) +
        "/reviews"
      );
    }

    _url(page) {
      const base = this._apiBase();
      let params = "page=" + page + "&perPage=" + this.perPage;
      if (this.sort === "rating-desc") params += "&sort=rating&direction=desc";
      else if (this.sort === "rating-asc") params += "&sort=rating&direction=asc";
      else params += "&sort=date";
      return base + "?" + params;
    }

    _fetchPage(page) {
      const key = this.sort + ":" + page;
      if (this.cache[key]) return Promise.resolve(this.cache[key]);
      const self = this;
      return fetch(this._url(page), { headers: { Accept: "application/json" } })
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .then(function (data) {
          if (data) self.cache[key] = data;
          return data;
        });
    }

    _goToPage(page) {
      const self = this;
      this._fetchPage(page)
        .then(function (data) {
          if (!data) {
            self.setAttribute("data-reviews-state", "error");
            return;
          }
          // Empty state: the product has no reviews at all. Only decided on the
          // first page (a later page being empty just means we've paged past the
          // end). `totalReview` is the authoritative count; fall back to the
          // pagination total, then to the actual row count.
          const bl = data.bottomline || {};
          const rowCount = (data.reviews || []).length;
          if (page === 1) {
            var totalCount =
              bl.totalReview != null
                ? bl.totalReview
                : (data.pagination && data.pagination.total) || 0;
            if (totalCount === 0 && rowCount === 0) {
              self._showEmpty();
              return;
            }
          }
          // Paged past the end (a rare over-reported total): step back rather than
          // show an empty page, and pin this as the last page.
          if (page > 1 && rowCount === 0) {
            self.hasNext = false;
            self._pagesFromTotal = self.page;
            self._syncPager();
            return;
          }
          self.page = page;
          self._renderContent(data);
          self.setAttribute("data-reviews-state", "loaded");
          // Pager is driven by Yotpo's `pagination.total` -- reliable now the
          // review set has settled. No page-prefetch, so the initial load stays a
          // single /reviews request; Next fetches its page on demand.
          const total = (data.pagination && data.pagination.total) || 0;
          self._pagesFromTotal = Math.max(1, Math.ceil(total / self.perPage));
          self.hasNext = page < self._pagesFromTotal;
          self._syncPager();
        })
        .catch(function () {
          self.setAttribute("data-reviews-state", "error");
        });
    }

    _renderContent(data) {
      const bl = data.bottomline || {};
      const total = (data.pagination && data.pagination.total) || 0;

      const avg = Number(bl.averageScore) || 0;
      if (this.summaryStars) {
        this.summaryStars.style.setProperty("--sr-fill", this._pct(avg) + "%");
      }
      if (this.countEl && this.labels.countTemplate) {
        const count = bl.totalReview != null ? bl.totalReview : total;
        this.countEl.textContent = this.labels.countTemplate
          .replace("{score}", String(Math.round(avg * 10) / 10))
          .replace("{count}", String(count));
      }

      // Card 3 (fit slider) -- positioned from the custom-question aggregate on
      // THIS v3 response (bottomline.customFieldsBottomline); the same values
      // across pages, so rendering per page is idempotent.
      const cfb = bl.customFieldsBottomline;
      if (cfb && Object.keys(cfb).length) this._renderFitAggregate(cfb);

      // Card 2 (recommend %) -- counted from the review set once on first load
      // (the aggregate's rounded mean can't give an accurate percentage).
      this._ensureRecommendPct();

      this.itemsEl.innerHTML = "";
      const reviews = data.reviews || [];
      for (let i = 0; i < reviews.length; i += 1) {
        this.itemsEl.appendChild(this._buildRow(reviews[i]));
      }
      this.itemsEl.setAttribute("aria-busy", "false");
    }

    // Pager driven by `pagination.total` (via `_pagesFromTotal`); `hasNext` is
    // `page < pages`. Hidden entirely when one page covers everything.
    _syncPager() {
      const pages = Math.max(
        this._pagesFromTotal || 1,
        this.page + (this.hasNext ? 1 : 0),
        this.page,
      );
      this.pages = pages;
      const show = pages > 1 || this.page > 1 || this.hasNext;
      this.pagerEl.hidden = !show;
      if (!show) return;
      this.statusEl.textContent = this.page + " / " + pages;
      this.statusEl.setAttribute(
        "aria-label",
        (this.labels.pagerAria || "{page} / {pages}")
          .replace("{page}", String(this.page))
          .replace("{pages}", String(pages)),
      );
      this._disable(this.prevBtn, this.page <= 1);
      this._disable(this.nextBtn, !this.hasNext);
    }

    // No reviews: CSS keyed off `data-reviews-state="empty"` reveals the empty
    // block and hides the summary/sort/list/pager. Mark the host too so the
    // header's ghost "Leave a review" button gives way to the block's solid CTA.
    _showEmpty() {
      this.setAttribute("data-reviews-state", "empty");
      if (this.itemsEl) {
        this.itemsEl.innerHTML = "";
        this.itemsEl.setAttribute("aria-busy", "false");
      }
      const host = this.closest("[data-product-reviews]");
      if (host) host.setAttribute("data-reviews-empty", "");
    }

    // Fit slider from the v3 aggregate that rides on the /reviews response
    // (bottomline.customFieldsBottomline). Fit field is 1 small / 2 true / 3 large:
    // map the server mean (1..3) to a 0..100% marker position across the three
    // labels. Fit is a coarse visual position, so the aggregate's integer-rounded
    // mean is acceptable here (unlike the recommend %, which needs an exact count).
    _renderFitAggregate(cf) {
      const fit = this._blScore(cf, this.cfg.fitFieldId);
      if (fit != null && this.fitCard && this.fitMarker) {
        const pos = Math.max(0, Math.min(100, ((fit - 1) / 2) * 100));
        this.fitMarker.style.setProperty("--reviews-fit-pos", pos + "%");
        this.fitCard.hidden = false;
      }
    }

    // Recommend card: "{pct}% of customers would recommend this product". Yotpo's
    // custom-field aggregate only exposes the mean ROUNDED to an integer (a true
    // 1.8 reads as 2.0), so it can't yield an accurate percentage -- count the
    // recommend answers from the review set instead. Runs once per surface.
    _ensureRecommendPct() {
      if (this._recPctStarted || !this.recommendCard || !this.recommendEl) return;
      if (!this.cfg.recFieldId || !this.labels.recPercent) return;
      this._recPctStarted = true;
      this._countRecommend(1, 0, 0);
    }

    // Page the review set (perPage=150, Yotpo's max) counting recommend answers,
    // capped at MAX_PAGES to bound the on-load cost -- beyond the cap the counted
    // reviews stand in as a representative sample. "Would recommend" is value >= 2
    // (Yes / Strongly recommend), matching the per-review row; the denominator is
    // reviews that ANSWERED the question (value present), not every review.
    _countRecommend(page, answered, yes) {
      const self = this;
      const REC_PER_PAGE = 150; // Yotpo's max page size
      const MAX_PAGES = 3; // cap on-load cost at 450 reviews
      fetch(this._apiBase() + "?page=" + page + "&perPage=" + REC_PER_PAGE + "&sort=date", {
        headers: { Accept: "application/json" },
      })
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .then(function (data) {
          if (!data) return;
          const reviews = data.reviews || [];
          for (let i = 0; i < reviews.length; i += 1) {
            const v = self._cfValue(reviews[i].customFields || {}, self.cfg.recFieldId);
            if (v >= 1) {
              answered += 1;
              if (v >= 2) yes += 1;
            }
          }
          const total = (data.pagination && data.pagination.total) || reviews.length;
          const hasMore = page < Math.ceil(total / REC_PER_PAGE) && reviews.length === REC_PER_PAGE;
          if (hasMore && page < MAX_PAGES) {
            self._countRecommend(page + 1, answered, yes);
            return;
          }
          if (answered > 0) {
            const pct = Math.round((yes / answered) * 100);
            self.recommendEl.textContent = self.labels.recPercent.replace("{pct}", String(pct));
            self.recommendCard.hidden = false;
          }
        })
        .catch(function () {
          /* leave the recommend card hidden on failure */
        });
    }

    // Read a custom field's aggregate from customFieldsBottomline. Keys are
    // prefixed `--<id>`; prefer the float `score`, fall back to the rounded
    // average (v3 camelCase `averageScore`, or `average_score` for safety).
    _blScore(cf, id) {
      if (!id) return null;
      const entry = cf["--" + id] || cf[id];
      if (!entry) return null;
      let v = entry.score;
      if (v == null) v = entry.averageScore != null ? entry.averageScore : entry.average_score;
      return v != null ? Number(v) : null;
    }

    _buildRow(review) {
      const node = this.rowTpl.content.firstElementChild.cloneNode(true);
      const q = function (sel) {
        return node.querySelector(sel);
      };
      const user = review.user || {};

      q("[data-review-author]").textContent = user.displayName || "";
      q("[data-review-date]").textContent = this._formatDate(review.createdAt);

      const fill = node.querySelector("[data-star-rating-fill]");
      if (fill) fill.style.setProperty("--sr-fill", this._pct(Number(review.score) || 0) + "%");

      q("[data-review-title]").textContent = review.title || "";
      q("[data-review-text]").textContent = review.content || "";

      const cf = review.customFields || {};

      const fitVal = this._cfValue(cf, this.cfg.fitFieldId);
      const fitLine = q("[data-review-fit]");
      if (fitVal && fitLine) {
        let label = this.labels.fitTrue;
        if (fitVal === 1) label = this.labels.fitSmall;
        else if (fitVal === 3) label = this.labels.fitLarge;
        q("[data-review-fit-label]").textContent = this.labels.fits || "";
        q("[data-review-fit-value]").textContent = label || "";
        fitLine.hidden = false;
      }

      const recVal = this._cfValue(cf, this.cfg.recFieldId);
      const recLine = q("[data-review-recommend]");
      if (recVal && recLine) {
        const yes = recVal >= 2;
        q("[data-review-recommend-word]").textContent = yes
          ? this.labels.recWordYes || ""
          : this.labels.recWordNo || "";
        q("[data-review-recommend-rest]").textContent =
          ", " + (yes ? this.labels.recYes || "" : this.labels.recNo || "");
        recLine.hidden = false;
      }
      return node;
    }

    _cfValue(cf, id) {
      if (!id) return 0;
      const entry = cf[id] || cf["--" + id];
      return entry ? Number(entry.value) || 0 : 0;
    }

    _pct(score) {
      return Math.max(0, Math.min(100, (score / 5) * 100));
    }

    _formatDate(iso) {
      if (!iso) return "";
      const d = new Date(iso);
      if (isNaN(d.getTime())) return "";
      const day = d.getDate();
      let suffix = "th";
      const rem = day % 10;
      if (rem === 1 && day !== 11) suffix = "st";
      else if (rem === 2 && day !== 12) suffix = "nd";
      else if (rem === 3 && day !== 13) suffix = "rd";
      let month = "";
      try {
        month = new Intl.DateTimeFormat(this.cfg.locale || "en", { month: "long" }).format(d);
      } catch (e) {
        month = "";
      }
      return day + suffix + " " + month + " " + d.getFullYear();
    }

    _disable(btn, off) {
      if (!btn) return;
      btn.disabled = !!off;
      btn.setAttribute("aria-disabled", off ? "true" : "false");
    }

    _onSort(event) {
      if (!event.detail || (event.target && event.target.id !== "reviews-sort")) return;
      this.sort = event.detail.value || "date";
      this._showLoading();
      this._goToPage(1);
    }

    _onPrev() {
      if (this.page > 1) this._goToPage(this.page - 1);
    }
    _onNext() {
      if (this.hasNext) this._goToPage(this.page + 1);
    }
  }

  if (!customElements.get("reviews-list")) {
    customElements.define("reviews-list", ReviewsList);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  class XProductZoom extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector(".product-zoom__stage");
      this.track = this.stage ? this.stage.querySelector("[data-carousel-track]") : null;
      this.counter = this.querySelector("[data-zoom-counter]");
      this.thumbs = Array.prototype.slice.call(this.querySelectorAll("[data-zoom-thumb]"));
      this.toggle = this.querySelector("[data-zoom-toggle]");
      this.total = parseInt(this.dataset.total || "0", 10);
      this.tpl = this.dataset.counterTpl || "Image __C__ of __T__";

      this._onChange = this._onChange.bind(this);
      this._onOpen = this._onOpen.bind(this);
      this._onClick = this._onClick.bind(this);
      this._onTriggerCapture = this._onTriggerCapture.bind(this);

      if (this.stage) this.stage.addEventListener("carousel:change", this._onChange);
      document.addEventListener("overlay:open", this._onOpen);
      // Capture phase is required: overlay.liquid opens the dialog and dispatches
      // overlay:open from a BUBBLE-phase document listener, so a bubble listener here
      // could run after _onOpen has already resolved the start index.
      document.addEventListener("click", this._onTriggerCapture, true);
      this.addEventListener("click", this._onClick);

      this._sync(0);
    }

    disconnectedCallback() {
      document.removeEventListener("overlay:open", this._onOpen);
      document.removeEventListener("click", this._onTriggerCapture, true);
    }

    // Which gallery tile was clicked, if any -- null when the open came from the
    // gallery's own zoom button (which sits outside the tiles).
    _onTriggerCapture(event) {
      var tile = event.target.closest("[data-zoom-index]");
      this._pendingIndex = tile ? parseInt(tile.dataset.zoomIndex, 10) : null;
    }

    _onOpen(event) {
      if (!event.detail || event.detail.id !== "product-zoom") return;
      var index = this._pendingIndex;
      this._pendingIndex = null;
      if (index == null) index = this._galleryIndex();
      if (isNaN(index) || index < 0) index = 0;
      if (index > this.total - 1) index = this.total - 1;
      this._setZoom(false);
      this._sync(index);
      // Two frames, not one: the stage was display:none until now, so the carousel
      // re-measures its snap geometry in a ResizeObserver callback, which is delivered
      // AFTER this frame's rAF callbacks. Jumping before that lands the scroll but
      // commits the index against stale (all-zero) snaps, leaving the carousel's own
      // index -- and every later change event -- out of step with the visible slide.
      var self = this;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          self._goTo(index, true);
        });
      });
    }

    // Zoom index of the gallery's currently-paged tile. The gallery counts ALL media
    // while the stage is image-only, so the tile's own data-zoom-index is the mapping
    // (a video tile carries none -> first image).
    _galleryIndex() {
      var gallery = document.querySelector(".product-gallery__carousel");
      if (!gallery) return 0;
      var tiles = gallery.querySelectorAll(".product-gallery__tile");
      var tile = tiles[parseInt(gallery.getAttribute("data-index") || "0", 10)];
      if (!tile || tile.dataset.zoomIndex == null) return 0;
      return parseInt(tile.dataset.zoomIndex, 10);
    }

    _onClick(event) {
      var thumb = event.target.closest("[data-zoom-thumb]");
      if (thumb) {
        this._goTo(parseInt(thumb.dataset.zoomThumb, 10), false);
        return;
      }
      if (event.target.closest("[data-zoom-prev]") && this.stage && this.stage.prev) {
        this.stage.prev();
        return;
      }
      if (event.target.closest("[data-zoom-next]") && this.stage && this.stage.next) {
        this.stage.next();
        return;
      }
      if (event.target.closest("[data-zoom-toggle]")) {
        this._setZoom(!this.hasAttribute("data-zoomed"));
        return;
      }

      // Anything else inside a slide is either the image (toggle zoom) or the scrim
      // the fit leaves around it (dismiss). Clicks on the arrows / strip / dots never
      // reach here -- none of them live inside a slide.
      var slide = event.target.closest(".product-zoom__slide");
      if (!slide) return;
      var img = slide.querySelector("img");
      if (!img) return;
      var rect = img.getBoundingClientRect();
      var onImage =
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom;
      if (onImage) {
        this._setZoom(!this.hasAttribute("data-zoomed"));
        return;
      }
      // Zoomed, the scrim is only the thin band a 2.5x image cannot cover -- dismissing
      // there would fire mid-pan, so the close control and Escape own the exit.
      if (this.hasAttribute("data-zoomed")) return;
      var dialog = this.closest("dialog.overlay");
      if (dialog) dialog.close();
    }

    // Zoomed state is CSS-only (the attribute swaps the image's max-* box so the slide
    // overflows and pans natively). Zooming in centres the pan on the middle of the
    // image -- reading scrollWidth after the attribute flip resolves the zoomed layout.
    _setZoom(on) {
      this.toggleAttribute("data-zoomed", on);
      if (this.toggle) {
        this.toggle.setAttribute("aria-pressed", on ? "true" : "false");
        var label = on ? this.dataset.zoomOutLabel : this.dataset.zoomInLabel;
        if (label) this.toggle.setAttribute("aria-label", label);
      }
      if (!this.track) return;
      var slides = this.track.querySelectorAll(".product-zoom__slide");
      for (var i = 0; i < slides.length; i++) {
        var slide = slides[i];
        slide.scrollLeft = on ? (slide.scrollWidth - slide.clientWidth) / 2 : 0;
        slide.scrollTop = on ? (slide.scrollHeight - slide.clientHeight) / 2 : 0;
      }
    }

    _onChange(event) {
      this._setZoom(false);
      this._sync(event.detail ? event.detail.index : 0);
    }

    _goTo(index, instant) {
      if (!this.track) return;
      var slides = this.track.querySelectorAll(".carousel__slide");
      var target = slides[index];
      if (!target) return;
      this.track.scrollTo({ left: target.offsetLeft, behavior: instant ? "auto" : "smooth" });
    }

    _sync(index) {
      if (this.counter) {
        this.counter.textContent = this.tpl
          .replace("__C__", index + 1)
          .replace("__T__", this.total);
      }
      this.thumbs.forEach(function (button, i) {
        var active = i === index;
        button.classList.toggle("is-active", active);
        button.setAttribute("aria-current", active ? "true" : "false");
      });
    }
  }

  if (!customElements.get("x-product-zoom")) {
    customElements.define("x-product-zoom", XProductZoom);
  }

  // Desktop: the gallery region pins (position: sticky) so the image area stays
  // in view while a taller buy-box scrolls past. Its sticky `top` must clear the
  // sticky header -- a merchant toggle whose height differs by breakpoint -- so
  // measure the pinned header live and expose it as a CSS custom property.
  // Consumed only inside the >=1025px media query; harmless below it.
  class XPdpLayout extends HTMLElement {
    connectedCallback() {
      this._update = this._update.bind(this);
      this._onNavClick = this._onNavClick.bind(this);
      this._resetNav = this._resetNav.bind(this);
      // The dim + loader CSS is rooted on the inner `.product__layout` grid (its
      // direct children are the gallery + buy-box regions), not this custom element.
      this._layout = this.querySelector(".product__layout");
      this._update();
      window.addEventListener("resize", this._update, { passive: true });

      // Reveal the loading state when a colourway swatch (an `<a href>` to a
      // sibling product) is activated; delegated on the layout so it covers both
      // the buy-box and any re-rendered swatch row.
      this.addEventListener("click", this._onNavClick);
      // Clear the state if the browser restores this page from the bfcache on a Back
      // navigation (a restored page must never stay dimmed).
      window.addEventListener("pageshow", this._resetNav);
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this._update);
      this.removeEventListener("click", this._onNavClick);
      window.removeEventListener("pageshow", this._resetNav);
    }

    _onNavClick(event) {
      // Ignore anything that isn't a plain same-tab left-click -- a modified or
      // middle click (or target=_blank) opens a new tab and does NOT navigate this
      // document, so it must not dim it.
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var link = event.target.closest("a[data-swatch][href]");
      if (!link || link.target === "_blank") return;
      // Only PDP colourway / letter swatches (the buy-box swatch row) are navigations.
      if (!link.closest(".buy-box__swatches") || !this._layout) return;

      this._layout.classList.add("product__layout--navigating");
      this._layout.setAttribute("aria-busy", "true");
      link.setAttribute("aria-busy", "true");
    }

    _resetNav() {
      if (!this._layout) return;
      this._layout.classList.remove("product__layout--navigating");
      this._layout.removeAttribute("aria-busy");
      var busy = this._layout.querySelectorAll('[data-swatch][aria-busy="true"]');
      for (var i = 0; i < busy.length; i++) busy[i].removeAttribute("aria-busy");
    }

    _update() {
      var stickyHeader = document.querySelector(".header--sticky");
      var headerSection = stickyHeader ? stickyHeader.closest(".shopify-section") : null;
      var offset = headerSection
        ? Math.ceil(headerSection.getBoundingClientRect().height) + 16
        : 16;
      this.style.setProperty("--pdp-media-sticky-top", offset + "px");
    }
  }

  if (!customElements.get("x-pdp-layout")) {
    customElements.define("x-pdp-layout", XPdpLayout);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["region-modal"]) return;
  try {
    
  (function () {
    if (!window.customElements) return;
    if (customElements.get("x-region-modal")) return;

    var STORAGE_KEY = "seed-region-dismissed";
    var CACHE_KEY = "seed-region-detected";
    var DAY_MS = 24 * 60 * 60 * 1000;

    // ---- Geo-settled gate -------------------------------------------------
    // This element is the geo AUTHORITY for on-load popup sequencing. When it
    // is present (geo in play), it publishes a one-shot "settled" signal that
    // the newsletter modal awaits before it may open, so the two on-load
    // popups never collide. The gate is created ONLY when geo is in play
    // (inside connectedCallback below, which runs only when <x-region-modal>
    // is rendered). Contract -- window.Seed.geo:
    //   .settled : Promise that resolves EXACTLY ONCE, on every geo path.
    //   .resolve : the resolver for .settled (called by settleGeo()).
    //   .done    : synchronous boolean, true once settled (so a late reader
    //              can't miss an already-fired settle).
    // A one-shot `seed:geo-settled` document event also fires at settle, for
    // listeners attached after the promise is created. "Settled" means geo has
    // finished deciding: dismissed, not-required, detection-failed, or
    // opened-then-closed. See settleGeo() for the call sites.
    function ensureGeoGate() {
      window.Seed = window.Seed || {};
      if (window.Seed.geo) return window.Seed.geo;
      var resolve;
      var settled = new Promise(function (res) {
        resolve = res;
      });
      window.Seed.geo = { settled: settled, resolve: resolve, done: false };
      return window.Seed.geo;
    }

    customElements.define(
      "x-region-modal",
      class extends HTMLElement {
        connectedCallback() {
          if (this._initialised) return;
          this._initialised = true;

          // Stand up the geo gate immediately: geo is in play (this element
          // exists), so the newsletter must wait until we settle it below.
          ensureGeoGate();

          this.currentRegion = this.dataset.currentRegion;
          this.targetRegion = this.dataset.targetRegion;
          this.nzCountries = (this.dataset.nzCountries || "")
            .split(",")
            .map(function (code) {
              return code.trim().toLowerCase();
            })
            .filter(Boolean);
          this.dismissDays = parseInt(this.dataset.dismissDays, 10) || 30;
          this.overlay = this.querySelector("x-overlay");

          this.onOverlayClose = this.onOverlayClose.bind(this);
          document.addEventListener("overlay:close", this.onOverlayClose);

          var continueButton = this.querySelector("[data-region-continue]");
          if (continueButton) {
            continueButton.addEventListener("click", this.onContinue.bind(this));
          }

          this.evaluate();
        }

        disconnectedCallback() {
          document.removeEventListener("overlay:close", this.onOverlayClose);
        }

        isDismissed() {
          try {
            var raw = window.localStorage.getItem(STORAGE_KEY);
            if (!raw) return false;
            var data = JSON.parse(raw);
            if (data && data.expiresAt && data.expiresAt > Date.now()) return true;
            // Self-clearing: an expired flag is removed so the visitor is
            // eligible again.
            window.localStorage.removeItem(STORAGE_KEY);
            return false;
          } catch (error) {
            return false;
          }
        }

        setDismissed() {
          try {
            var expiresAt = Date.now() + this.dismissDays * DAY_MS;
            window.localStorage.setItem(
              STORAGE_KEY,
              JSON.stringify({ dismissed: true, expiresAt: expiresAt }),
            );
          } catch (error) {
            /* storage unavailable -- fail open, the modal simply re-evaluates */
          }
        }

        regionFor(country) {
          // No / unknown country -> treat as the current region so the modal
          // never opens on a detection failure (fail safe, no flash).
          if (!country) return this.currentRegion;
          return this.nzCountries.indexOf(country.toLowerCase()) !== -1 ? "nz" : "au";
        }

        detectCountry() {
          // Manual override: ?geo_country=<ISO> stubs the detected country and
          // bypasses the fetch so the flow can be exercised deterministically.
          var params = new URLSearchParams(window.location.search);
          var override = params.get("geo_country");
          if (override) return Promise.resolve(override.toLowerCase());

          try {
            var cached = window.sessionStorage.getItem(CACHE_KEY);
            if (cached !== null) return Promise.resolve(cached);
          } catch (error) {
            /* sessionStorage blocked -- fall through to the network */
          }

          var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

          return fetch(root + "browsing_context_suggestions.json", {
            headers: { Accept: "application/json" },
          })
            .then(function (response) {
              return response.ok ? response.json() : null;
            })
            .then(function (data) {
              var handle =
                data &&
                data.detected_values &&
                data.detected_values.country &&
                data.detected_values.country.handle;
              handle = handle ? handle.toLowerCase() : "";
              try {
                window.sessionStorage.setItem(CACHE_KEY, handle);
              } catch (error) {
                /* ignore cache write failure */
              }
              return handle;
            })
            .catch(function () {
              return "";
            });
        }

        settleGeo() {
          // Resolve the geo gate exactly once. Idempotent: guarded by .done so
          // the multiple settle paths (dismissed / not-required / detection
          // failure / opened-then-closed) can all call it safely.
          var gate = window.Seed && window.Seed.geo;
          if (!gate || gate.done) return;
          gate.done = true;
          if (typeof gate.resolve === "function") gate.resolve();
          document.dispatchEvent(new CustomEvent("seed:geo-settled"));
        }

        evaluate() {
          // Path 1 -- already dismissed: the modal never opens, so geo has
          // settled immediately.
          if (this.isDismissed()) {
            this.settleGeo();
            return;
          }
          var self = this;
          this.detectCountry().then(function (country) {
            // Path 2 -- detection resolved to the current region (or failed
            // safe to it): the modal does NOT open, so geo settles now.
            if (self.regionFor(country) === self.currentRegion) {
              self.settleGeo();
              return;
            }
            // Path 3 -- the modal opens; geo settles later, when it CLOSES
            // (see onOverlayClose).
            self.openOverlay();
          });
        }

        openOverlay() {
          var self = this;
          var overlay = this.querySelector("x-overlay");
          if (overlay && typeof overlay.open === "function") {
            overlay.open();
            this.focusContainer();
            return;
          }
          // The overlay base custom element may be upgraded after this one (the
          // override path resolves on a microtask that can beat x-overlay's
          // define() in the shared JS bundle). Wait for it, then open.
          if (window.customElements && customElements.whenDefined) {
            customElements.whenDefined("x-overlay").then(function () {
              var el = self.querySelector("x-overlay");
              if (el && typeof el.open === "function") {
                el.open();
                self.focusContainer();
              }
            });
          }
        }

        focusContainer() {
          // Region-scoped a11y override: the overlay base focuses the close ((x))
          // control synchronously inside open(). Move initial focus to the
          // dialog container itself instead so NOTHING appears focused on open
          // -- WebKit does match :focus-visible on programmatic focus, so the ring
          // is kept off the container by `outline: 0` in the overlay base.
          // tabindex=-1 makes the container programmatically
          // focusable without adding it to the tab order. Focus on the next
          // frame so it lands AFTER the base's synchronous close-focus, in BOTH
          // open paths. Focus stays inside the dialog, so the native focus-trap
          // + Escape are unaffected. Does NOT touch the base, so other consumers
          // (cart drawer) keep close-focus.
          var self = this;
          var raf = window.requestAnimationFrame;
          if (!raf) return;
          raf(function () {
            var dialog = self.querySelector("dialog.overlay");
            if (dialog && typeof dialog.focus === "function") {
              dialog.setAttribute("tabindex", "-1");
              dialog.focus();
            }
          });
        }

        onOverlayClose(event) {
          // Stay / X / Escape / backdrop all close the overlay base, which
          // dispatches overlay:close -- that single signal records the dismissal
          // for every dismiss path. It is also Path 3's settle point: once the
          // opened region modal closes, geo is settled and the newsletter may
          // appear.
          if (event.detail && event.detail.id === "region-modal") {
            this.setDismissed();
            this.settleGeo();
          }
        }

        onContinue() {
          // The CTA is an anchor, so the navigation is the browser's own link
          // activation. Only the dismissal is recorded here; the click is
          // never intercepted.
          this.setDismissed();
        }
      },
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* One document-level init survives Section Rendering reloads. Desktop stays
       on product-card quick-add; mobile records passive size chips, then
       delegates to SeedQuickAdd. */
    if (window.__seedShopTheLookInit) return;
    window.__seedShopTheLookInit = true;

    /* Polite live-region feedback inside the product's drawer. `kind` selects the
       pre-translated message stamped on the status element (sold-out vs error). */
    function setStatus(productEl, kind) {
      var drawer = productEl.closest(".overlay");
      var status = drawer ? drawer.querySelector("[data-stl-status]") : null;
      if (!status) return;
      if (!kind) {
        status.textContent = "";
        return;
      }
      var attr = kind === "soldout" ? "data-msg-soldout" : "data-msg-error";
      status.textContent = status.getAttribute(attr) || "";
    }

    function previewMeta(productEl) {
      var node = productEl.querySelector("[data-pc-preview]");
      if (!node) return {};
      try {
        return JSON.parse(node.textContent) || {};
      } catch (e) {
        return {};
      }
    }

    /* Derive one primary action from the product policy and resolved variant.
       Coming soon takes product-level precedence; otherwise only an unavailable
       variant swaps Add to bag for Notify me or a disabled Add to bag. */
    function primaryAction(productEl, variant) {
      var action = previewMeta(productEl).action;
      if (action === "coming-soon") return "register";
      if (!variant || variant.available !== false) return "add";
      return action === "disabled" ? "disabled" : "notify";
    }

    function resolveSelected(productEl) {
      if (!window.SeedQuickAdd) return null;
      return window.SeedQuickAdd.resolve(productEl, productEl.dataset.stlSize);
    }

    /* Mobile: keep the drawer CTA on the shopper's current selection so an
       out-of-stock choice never reads as Add to bag. */
    function reflectPrimary(productEl) {
      var addBtn = productEl.querySelector("[data-stl-add]");
      var actionBtn = productEl.querySelector("[data-stl-notify]");
      if (!addBtn || !actionBtn) return;
      var mode = primaryAction(productEl, resolveSelected(productEl));
      var alternate = mode === "notify" || mode === "register";
      var label = actionBtn.querySelector(".btn__label");
      if (label && !actionBtn.dataset.notifyLabel)
        actionBtn.dataset.notifyLabel = label.textContent;
      if (label) {
        label.textContent =
          mode === "register" && window.SeedComingSoon
            ? window.SeedComingSoon.getTriggerLabel()
            : actionBtn.dataset.notifyLabel || "";
      }
      actionBtn.hidden = !alternate;
      addBtn.hidden = alternate;
      addBtn.disabled = mode === "disabled";
      if (mode === "disabled") addBtn.setAttribute("aria-disabled", "true");
      else addBtn.removeAttribute("aria-disabled");
    }

    /* One-size and coming-soon products never fire a chip change, so settle every
       product's CTA -- including hidden colourways -- when the drawer opens. */
    document.addEventListener("overlay:open", function (event) {
      var id = event.detail && event.detail.id;
      if (!id || String(id).indexOf("stl-drawer-") !== 0) return;
      var host = document.querySelector('x-overlay[data-overlay-id="' + id + '"]');
      if (!host) return;
      var products = host.querySelectorAll("[data-stl-product]");
      for (var i = 0; i < products.length; i++) reflectPrimary(products[i]);
    });

    /* Mobile: the size chips are passive -- record the chosen size; read back by the
       Add-to-bag handler below. */
    document.addEventListener("size-chip:change", function (event) {
      if (!event.detail || event.detail.name !== "stl-size") return;
      var productEl = event.target.closest("[data-stl-product]");
      if (!productEl) return;
      productEl.dataset.stlSize = event.detail.value;
      productEl.classList.remove("stl-drawer__product--needs-size");

      var chosen = event.target.closest(".size-chip");
      var chips = productEl.querySelectorAll(".size-chip");
      for (var i = 0; i < chips.length; i++) {
        var isSel = chips[i] === chosen;
        chips[i].classList.toggle("size-chip--selected", isSel);
        if (isSel) chips[i].setAttribute("aria-pressed", "true");
        else chips[i].removeAttribute("aria-pressed");
      }

      reflectPrimary(productEl);
    });

    /* The alternate drawer action delegates to the shared shells for its current
       mode. Register interest is product-level; Notify me carries the resolved
       sold-out variant. */
    document.addEventListener("click", function (event) {
      var actionBtn = event.target.closest("[data-stl-notify]");
      if (!actionBtn) return;
      var scope = actionBtn.closest("[data-pc-quickadd-scope]");
      if (!scope) return;
      var meta = previewMeta(scope);
      var variant = resolveSelected(scope);
      var mode = primaryAction(scope, variant);
      if (mode === "register") {
        if (!window.SeedComingSoon) return;
        var img = scope.querySelector(".stl-drawer__entry-media img");
        window.SeedComingSoon.open({
          productId: meta.id,
          title: meta.title,
          price: meta.priceLabel,
          compare: meta.compareLabel,
          url: meta.url,
          image: img ? img.currentSrc || img.src : "",
        });
        return;
      }
      if (mode !== "notify" || !variant || !window.SeedNotify) return;
      window.SeedNotify.open(
        {
          variantId: variant.id,
          title: meta.title,
          price: meta.priceLabel,
          compare: meta.compareLabel,
        },
        { sourceOverlay: scope.closest("x-overlay") },
      );
    });

    /* Mobile add resolves the chosen chip through shared quick-add; needs-size
       and sold-out feedback belong to this drawer, while network errors come
       from add-core. */
    document.addEventListener("click", function (event) {
      var addBtn = event.target.closest("[data-stl-add]");
      if (!addBtn) return;
      var scope = addBtn.closest("[data-pc-quickadd-scope]");
      if (!scope || !window.SeedQuickAdd) return;

      /* Clear any stale status (a prior sold-out/error) at the start of every fresh
         attempt so an old message never lingers under a new action. */
      setStatus(scope, null);

      var size = scope.dataset.stlSize;
      var variant = window.SeedQuickAdd.resolve(scope, size);
      if (!variant) {
        /* No size chosen yet -- surface the size group rather than guessing. */
        scope.classList.add("stl-drawer__product--needs-size");
        var firstChip = scope.querySelector(".size-chip:not([disabled])");
        if (firstChip) firstChip.focus();
        return;
      }
      window.SeedQuickAdd.add(variant.id, 1, addBtn);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-finder"] && !Shopify.designMode) return;
  try {
    
  // Reveal five rows per click so long result sets stay scannable.
  const RESULTS_PAGE = 5;
  // Radius, in km from the searched point, that counts as the vicinity. The
  // camera opens on the matches inside it, so a search frames the searched area
  // rather than one building -- or the whole country when a distant match exists.
  const MAP_VICINITY_KM = 5;
  // Zoom the camera eases to when a shopper selects a store row.
  const MAP_FOCUS_ZOOM = 16;

  class StoreFinder extends HTMLElement {
    connectedCallback() {
      const dataEl = this.querySelector("[data-store-finder-data]");
      try {
        this.stores = dataEl ? JSON.parse(dataEl.textContent) : [];
      } catch (e) {
        this.stores = [];
      }
      // Tab order is merchant-driven (the default country leads), so read the
      // same ordered list the tabs + panels were rendered from -- this keeps the
      // tab-index -> country map aligned when the default changes.
      this.countries = (this.dataset.countries || "AU,NZ,SG").split(",");
      this.active = this.dataset.defaultCountry || this.countries[0] || "AU";
      // Browse vs searched-results: searchActive flips on a postcode search or a
      // GPS fix; origin is the resolved coordinate the list sorts by.
      this.searchActive = false;
      this.origin = null;
      this.loading = false;
      this.shown = RESULTS_PAGE;
      this.filters = { store_type: "", departments: "" };
      // Monotonic token: a search/GPS/tab change bumps it so a late async
      // geocode that has been superseded can detect it and bail.
      this._searchSeq = 0;
      // The row whose store the camera is framed on; a re-render clears it.
      this.selectedCard = null;

      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll("[data-country]"));
      this.map = this.querySelector("[data-store-map]");
      this.token = this.map ? this.map.dataset.token || "" : "";
      this.countTmpl = this.dataset.resultsCountTmpl || "";
      this.searchingLabel = this.dataset.searchingLabel || "";
      this.myLocationLabel = this.dataset.myLocationLabel || "";
      this.field = this.querySelector(".store-finder__field .input__control");
      this.submitBtns = Array.from(this.querySelectorAll("[data-sf-submit]"));
      this.gpsBtn = this.querySelector("[data-sf-gps]");
      this.gpsMsg = this.querySelector("[data-sf-gps-msg]");

      // tabs/tab-item drive aria-selected; the controller re-filters off it
      // (these tabs carry no panels of their own -- one shared list re-renders).
      this.tabObserver = new MutationObserver(() => this.onTabChange());
      this.tabs.forEach((t) =>
        this.tabObserver.observe(t, { attributes: true, attributeFilter: ["aria-selected"] }),
      );

      if (this.field) {
        this.field.addEventListener("keydown", (e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            this.onSearch();
          }
        });
        // Native search-field clear (the x) empties the value -> back to browse.
        this.field.addEventListener("input", () => {
          if (this.searchActive && this.field.value.trim() === "") {
            this.clearSearch();
            this.apply();
          }
        });
      }
      this.submitBtns.forEach((b) => b.addEventListener("click", () => this.onSearch()));
      if (this.gpsBtn) this.gpsBtn.addEventListener("click", () => this.onGps());
      this.addEventListener("dropdown:change", (e) => this.onFilter(e));
      this.addEventListener("click", (e) => {
        if (!e.target.closest) return;
        if (e.target.closest("[data-view-more]")) {
          this.onViewMore();
          return;
        }
        const card = e.target.closest(".store-finder__card-item");
        if (card) this.selectCard(card);
      });
      // Keyboard parity: tabbing into a row's link selects it too, so framing a
      // store never needs a pointer (same contract as the find-in-store list).
      this.addEventListener("focusin", (e) => {
        const card = e.target.closest && e.target.closest(".store-finder__card-item");
        if (card) this.selectCard(card);
      });

      // Browse cards render in metaobject order; alphabetise each region/flat list
      // once before the first paint (search mode re-sorts by distance, filters only
      // toggle visibility, so a single pass holds for the page's lifetime).
      this.sortBrowseCards();

      this.apply();
    }

    disconnectedCallback() {
      if (this.tabObserver) this.tabObserver.disconnect();
    }

    // Alphabetise the SSR browse cards within every region accordion and flat
    // country list by store name. Reorders existing nodes -- it does not build
    // cards, so the "browse composes store-info-card, never JS-built" rule holds.
    sortBrowseCards() {
      this.panels.forEach((panel) => {
        panel.querySelectorAll("[data-browse] .store-finder__cards").forEach((list) => {
          Array.from(list.querySelectorAll(":scope > .store-finder__card-item"))
            .sort((a, b) => (a.dataset.name || "").localeCompare(b.dataset.name || ""))
            .forEach((li) => list.appendChild(li));
        });
      });
    }

    onTabChange() {
      const sel = this.tabs.find((t) => t.getAttribute("aria-selected") === "true");
      if (!sel) return;
      const idx = this.tabs.indexOf(sel);
      const country = this.countries[idx] || "AU";
      if (country === this.active) return;
      this.active = country;
      // Search coordinates are country-scoped, so switching tabs resets the active search.
      this.clearSearch();
      this.apply();
    }

    onSearch() {
      const q = this.field ? this.field.value.trim() : "";
      if (!q) {
        this.clearSearch();
        this.apply();
        return;
      }
      const seq = ++this._searchSeq;
      this.searchActive = true;
      this.shown = RESULTS_PAGE;
      this.origin = null;
      this.loading = true;
      this.setSubmitLoading(true);
      this.apply();
      this.geocode(q).then((coords) => {
        // Bail if a newer search / GPS fix / tab switch has superseded this one.
        if (seq !== this._searchSeq) return;
        this.loading = false;
        this.origin = coords;
        this.setSubmitLoading(false);
        this.apply();
      });
    }

    onGps() {
      if (!navigator.geolocation || !this.gpsBtn) return;
      const seq = ++this._searchSeq; // invalidate any in-flight geocode
      this.gpsBtn.classList.add("is-loading");
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          if (seq !== this._searchSeq) return;
          this.gpsBtn.classList.remove("is-loading");
          if (this.gpsMsg) this.gpsMsg.hidden = true;
          this.searchActive = true;
          this.shown = RESULTS_PAGE;
          this.loading = false;
          this.origin = { lat: pos.coords.latitude, lng: pos.coords.longitude };
          // Label the field so the native clear control appears -> the user can
          // exit GPS results back to browse. A reverse geocode then upgrades
          // the label to the resolved area name.
          if (this.field) this.field.value = this.myLocationLabel;
          this.apply();
          this.reverseGeocode(this.origin).then((label) => {
            if (seq === this._searchSeq && label && this.field) this.field.value = label;
          });
        },
        () => {
          if (seq !== this._searchSeq) return;
          this.gpsBtn.classList.remove("is-loading");
          if (this.gpsMsg) this.gpsMsg.hidden = false;
        },
      );
    }

    onFilter(e) {
      const wrap = e.target.closest ? e.target.closest("[data-sf-filter]") : null;
      if (!wrap) return;
      const key = wrap.dataset.sfFilter;
      let val = e.detail ? e.detail.value : "";
      if (Array.isArray(val)) val = val[0] || "";
      this.filters[key] = val || "";
      this.shown = RESULTS_PAGE;
      this.apply();
    }

    onViewMore() {
      const panel = this.activePanel();
      if (!panel) return;
      const els = this.panelEls(panel);
      const prevShown = this.shown;
      this.shown += RESULTS_PAGE;
      const clones = Array.from(els.list.children);
      clones.forEach((c, i) => {
        c.hidden = i >= this.shown;
      });
      const exhausted = clones.length <= this.shown;
      if (els.viewMore) els.viewMore.hidden = exhausted;
      this.setStatus(els, this.formatCount(Math.min(this.shown, clones.length), clones.length));
      // When the button hides on the final reveal, move focus to the first newly
      // revealed row so it isn't dropped to <body>.
      if (exhausted && clones[prevShown]) {
        clones[prevShown].setAttribute("tabindex", "-1");
        clones[prevShown].focus();
      }
    }

    clearSearch() {
      this._searchSeq++; // invalidate any in-flight geocode
      this.searchActive = false;
      this.origin = null;
      this.loading = false;
      this.shown = RESULTS_PAGE;
      if (this.field) this.field.value = "";
      if (this.gpsMsg) this.gpsMsg.hidden = true;
      this.setSubmitLoading(false);
    }

    setSubmitLoading(on) {
      this.submitBtns.forEach((b) => b.classList.toggle("is-loading", !!on));
    }

    matchesFilters(li) {
      const f = this.filters;
      if (f.store_type && li.dataset.storeType !== f.store_type) return false;
      if (f.departments) {
        const depts = (li.dataset.departments || "").split("|");
        if (depts.indexOf(f.departments) === -1) return false;
      }
      return true;
    }

    // Geo helpers delegate to window.SeedGeoUtils from the geo-utils snippet.
    haversine(a, b) {
      return window.SeedGeoUtils.haversine(a, b);
    }

    formatKm(d) {
      return window.SeedGeoUtils.formatKm(d);
    }

    geocode(query) {
      return window.SeedGeoUtils.geocode(query, this.token, this.active);
    }

    reverseGeocode(point) {
      if (!this.token || !point) return Promise.resolve(null);
      const url =
        "https://api.mapbox.com/geocoding/v5/mapbox.places/" +
        point.lng +
        "," +
        point.lat +
        ".json?access_token=" +
        encodeURIComponent(this.token) +
        "&types=place,locality,postcode&limit=1";
      return fetch(url)
        .then((r) => (r.ok ? r.json() : null))
        .then((d) => {
          const f = d && d.features && d.features[0];
          return f ? f.text || f.place_name || null : null;
        })
        .catch(() => null);
    }

    activePanel() {
      return this.panels.find((p) => p.dataset.country === this.active) || null;
    }

    panelEls(panel) {
      return {
        browse: panel.querySelector("[data-browse]"),
        results: panel.querySelector("[data-results-mode]"),
        list: panel.querySelector("[data-results-list]"),
        viewMore: panel.querySelector("[data-view-more]"),
        status: panel.querySelector("[data-results-status]"),
        empty: panel.querySelector(".store-finder__empty"),
      };
    }

    setStatus(els, text) {
      if (els && els.status) els.status.textContent = text || "";
    }

    formatCount(shown, total) {
      if (!this.countTmpl) return "";
      return this.countTmpl.replace("%c%", shown).replace("%t%", total);
    }

    markerFor(li) {
      const s = this.stores.find((x) => x.handle === li.dataset.storeHandle);
      if (!s || s.lat == null || s.lng == null) return null;
      return { lat: s.lat, lng: s.lng, label: s.name, url: s.url };
    }

    // Selecting a store row frames that store on the map and bolds the row; the
    // surrounding pins stay put, so the vicinity stays readable.
    selectCard(li) {
      if (!li || li === this.selectedCard) return;
      this.clearSelection();
      li.classList.add("store-finder__card-item--selected");
      this.selectedCard = li;
      const lat = parseFloat(li.dataset.lat);
      const lng = parseFloat(li.dataset.lng);
      if (!this.map || isNaN(lat) || isNaN(lng)) return;
      this.map.dispatchEvent(
        new CustomEvent("store-map:focus", {
          bubbles: true,
          detail: { lat: lat, lng: lng, zoom: MAP_FOCUS_ZOOM },
        }),
      );
    }

    clearSelection() {
      if (this.selectedCard) {
        this.selectedCard.classList.remove("store-finder__card-item--selected");
      }
      this.selectedCard = null;
    }

    // `fit` (optional) is the subset the camera opens on; the full marker set is
    // still pinned so every row in the list has a pin to zoom to.
    updateMap(markers, fit) {
      if (!this.map) return;
      this.map.dataset.markers = JSON.stringify(markers);
      this.map.dispatchEvent(
        new CustomEvent("store-map:update", {
          bubbles: true,
          detail: { markers: markers, fit: fit },
        }),
      );
    }

    apply() {
      this.panels.forEach((p) => {
        p.hidden = p.dataset.country !== this.active;
      });
      const panel = this.activePanel();
      if (!panel) return;
      if (this.searchActive) {
        this.renderResults(panel);
      } else {
        this.renderBrowse(panel);
      }
    }

    renderBrowse(panel) {
      const els = this.panelEls(panel);
      this.clearSelection();
      this.setStatus(els, "");
      if (els.results) els.results.hidden = true;
      if (els.browse) els.browse.hidden = false;

      const items = els.browse
        ? Array.from(els.browse.querySelectorAll(".store-finder__card-item"))
        : [];
      let visible = 0;
      items.forEach((li) => {
        const ok = this.matchesFilters(li);
        li.hidden = !ok;
        if (ok) visible += 1;
      });

      // Region accordions: hide an empty group, keep its live count current.
      panel.querySelectorAll(".store-finder__region").forEach((acc) => {
        const lis = Array.from(acc.querySelectorAll(".store-finder__card-item"));
        const vis = lis.filter((li) => !li.hidden);
        acc.hidden = vis.length === 0;
        const sec = acc.querySelector(".accordion__secondary");
        if (sec) sec.textContent = "(" + vis.length + ")";
      });

      if (els.empty) els.empty.hidden = visible > 0;

      const markers = items
        .filter((li) => !li.hidden)
        .map((li) => this.markerFor(li))
        .filter(Boolean);
      this.updateMap(markers);
    }

    renderResults(panel) {
      const els = this.panelEls(panel);
      // A full re-render restarts the reveal (onViewMore increments between renders)
      // and destroys the row clones, so any framed selection goes with them.
      this.shown = RESULTS_PAGE;
      this.clearSelection();
      if (els.results) {
        els.results.hidden = false;
        els.results.setAttribute("aria-busy", this.loading ? "true" : "false");
      }
      if (els.viewMore) els.viewMore.hidden = true;

      // Loading (awaiting geocode): leave whatever is already on screen in place
      // -- the browse list on a first search, or the previous results on a refine
      // -- and only announce via the live region. Deferring the swap until
      // results exist means the browse -> results transition paints exactly once
      // (no empty-collapse flash / CLS). The empty results-mode shown here is
      // visually nil -- :empty zeroes the list padding, and the live status is
      // position:absolute.
      if (this.loading) {
        if (els.empty) els.empty.hidden = true;
        this.setStatus(els, this.searchingLabel);
        return;
      }

      if (els.browse) els.browse.hidden = true;
      if (els.list) els.list.innerHTML = "";

      const items = els.browse
        ? Array.from(els.browse.querySelectorAll(".store-finder__card-item"))
        : [];
      const matching = items.filter((li) => this.matchesFilters(li));

      // No resolved location (unknown query / no token) or no matches -> empty.
      if (!this.origin || matching.length === 0) {
        if (els.empty) els.empty.hidden = false;
        this.setStatus(els, "");
        this.updateMap([]);
        return;
      }
      if (els.empty) els.empty.hidden = true;

      // Distance-sort ALL matches (no radius cull), nearest first.
      const sorted = matching
        .map((li) => {
          const lat = parseFloat(li.dataset.lat);
          const lng = parseFloat(li.dataset.lng);
          const d =
            !isNaN(lat) && !isNaN(lng)
              ? this.haversine(this.origin, { lat: lat, lng: lng })
              : Infinity;
          return { li: li, d: d };
        })
        .sort((a, b) => a.d - b.d);

      sorted.forEach((entry, i) => {
        const clone = entry.li.cloneNode(true);
        if (isFinite(entry.d)) {
          const meta = clone.querySelector(".store-info-card__meta");
          if (meta && !meta.querySelector(".store-info-card__distance")) {
            const span = document.createElement("span");
            span.className = "store-info-card__distance text-body-sm";
            span.textContent = this.formatKm(entry.d);
            meta.insertBefore(span, meta.firstChild);
          }
        }
        clone.hidden = i >= this.shown;
        if (els.list) els.list.appendChild(clone);
      });

      if (els.viewMore) els.viewMore.hidden = sorted.length <= this.shown;
      this.setStatus(els, this.formatCount(Math.min(this.shown, sorted.length), sorted.length));

      // Every match is pinned, so selecting any row -- including one revealed by
      // "View more" -- zooms onto a real pin. The camera, though, opens only on
      // the matches inside the searched vicinity: fitting all of them would frame
      // the whole country whenever the nearest stores are hundreds of km apart.
      // A sparse region with nothing inside the radius falls back to the nearest
      // match so the view still lands on a store.
      const near = sorted.filter((entry) => isFinite(entry.d) && entry.d <= MAP_VICINITY_KM);
      const toMarker = (entry) => this.markerFor(entry.li);
      const markers = sorted.map(toMarker).filter(Boolean);
      const fit = (near.length ? near : sorted.slice(0, 1)).map(toMarker).filter(Boolean);
      this.updateMap(markers, fit);
    }
  }

  if (!customElements.get("store-finder")) {
    customElements.define("store-finder", StoreFinder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"] && !Shopify.designMode) return;
  try {
    
  class XWishlistPage extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.CHUNK = 24;
      this.grid = this.querySelector("[data-wishlist-grid]");
      this.section = this.closest(".shopify-section");
      this.emptyEl = this.section ? this.section.querySelector("[data-wishlist-empty]") : null;
      this.countEl = this.section ? this.section.querySelector("[data-wishlist-count]") : null;
      this.skeletonEl = this.section
        ? this.section.querySelector("[data-wishlist-skeleton]")
        : null;
      this.countSkelEl = this.section
        ? this.section.querySelector("[data-wishlist-count-skel]")
        : null;

      this._onSizeChange = this._onSizeChange.bind(this);
      this._onClick = this._onClick.bind(this);
      this.addEventListener("size-chip:change", this._onSizeChange);
      this.addEventListener("click", this._onClick);

      this._boot();
    }

    disconnectedCallback() {
      this.removeEventListener("size-chip:change", this._onSizeChange);
      this.removeEventListener("click", this._onClick);
      if (this._onContent) document.removeEventListener("wishlist:content", this._onContent);
    }

    _boot() {
      var W = window.SeedWishlist;
      // The runtime bundle can register after this element upgrades, so retry
      // briefly instead of bailing before the guest gate or customer list can hydrate.
      if (!W || !W.items) {
        this._bootTries = (this._bootTries || 0) + 1;
        if (this._bootTries > 100) {
          // Mirrors the runtime's own SDK grace period.
          this._showEmpty();
          return;
        }
        var retry = this;
        setTimeout(function () {
          retry._boot();
        }, 100);
        return;
      }
      var html = document.documentElement;
      if (
        html.hasAttribute("data-wishlist-unavailable") ||
        (W.isUnavailable && W.isUnavailable())
      ) {
        this._showEmpty();
        return;
      }
      // Guests see the empty-state chrome behind the sign-in prompt, never list content.
      if (!W.isLoggedIn()) {
        this._showEmpty();
        if (window.SeedWishlistGate && window.SeedWishlistGate.prompt) {
          window.SeedWishlistGate.prompt();
        }
        return;
      }
      var self = this;
      // Reconcile on every wishlist change, including mutations from other
      // surfaces. _apply renders first and then only SRA-fetches genuinely new
      // products, avoiding a refetch loop.
      this._onContent = function () {
        var WW = window.SeedWishlist;
        if (!WW) return;
        if (WW.isUnavailable && WW.isUnavailable()) {
          if (!self._rendered) self._showEmpty();
          return;
        }
        if (WW.isReady && WW.isReady()) {
          self._apply(self._prepare((WW.items && WW.items()) || []));
        }
      };
      document.addEventListener("wishlist:content", this._onContent);

      // Hydrate from the fastest source first, then converge on the SDK truth.
      // Both paths call _apply(), which renders on the first non-empty list and
      // reconciles later deltas; matching lists cost no SRA request.
      // If the SDK is already warm, apply it now; the listener still covers later changes.
      if (W.isReady()) {
        this._apply(this._prepare((W.items && W.items()) || []));
        return;
      }

      // Fast tier races the SDK boot; the SDK's own resolve arrives via _onContent.
      if (W.fastFetch && !this._fastTried) {
        this._fastTried = true;
        W.fastFetch(function (items) {
          if (items && items.length) self._apply(self._prepare(items));
        });
      }
    }

    // Sort newest-first by SWYM's create timestamp (cts, epoch ms) and collapse
    // to one entry per product (empi) -- SWYM may hold legacy per-variant rows.
    // (SWYM's `dt` is the display title, not a time, so it is NOT a sort key.)
    _prepare(items) {
      var arr = (items || []).slice();
      var hasCts = arr.some(function (it) {
        return it && it.cts;
      });
      if (hasCts) {
        arr.sort(function (a, b) {
          return (b.cts || 0) - (a.cts || 0);
        });
      } else {
        arr.reverse();
      }
      var seen = {};
      var list = [];
      for (var i = 0; i < arr.length; i++) {
        var k = String(arr[i].empi);
        if (!k || seen[k]) continue;
        seen[k] = 1;
        list.push(arr[i]);
      }
      return list;
    }

    // Apply a resolved list from any tier. The first non-empty list renders the
    // grid; later lists reconcile the delta. `_latest` always holds the newest
    // list, so if one lands mid-render it is applied the moment the current
    // render/reconcile settles -- the tiers converge to the truth in any order.
    _apply(list) {
      this._latest = list;
      if (this._busy) return;
      this._run();
    }

    _run() {
      var self = this;
      var list = this._latest;
      this._busy = true;
      var done = function () {
        self._busy = false;
        if (self._latest !== list) self._run(); // a newer list arrived meanwhile
      };
      if (!this._rendered) {
        this._rendered = true;
        this._renderItems(list, done);
      } else {
        this._reconcile(list, done);
      }
    }

    _renderItems(list, done) {
      this._items = list;
      if (!list.length) {
        this._showEmpty();
        if (done) done();
        return;
      }
      var self = this;
      this._appendItems(list, function () {
        self._finish();
        self._healOrphans(list);
        if (done) done();
      });
    }

    // Self-heal: a saved product that no longer renders a card (deleted /
    // unpublished / drafted) leaves the header heart filled with no on-page control
    // to clear it. On the initial render -- where the fetch is the authoritative
    // resolvability check -- prune those from SWYM so the header and count correct.
    // Guarded to items whose chunk fetch actually returned markup (`_lastOkIds`), so
    // a failed request never prunes; matches by product id, so a renamed product
    // (still rendered by id) is kept, and an OOS product (still rendered) is kept.
    _healOrphans(list) {
      if (!window.SeedWishlist || !window.SeedWishlist.pruneOrphans) return;
      var okIds = this._lastOkIds || {};
      var rendered = {};
      var cards = this.grid.querySelectorAll("[data-wishlist-card]");
      Array.prototype.forEach.call(cards, function (card) {
        rendered[String(card.dataset.productId)] = true;
      });
      var orphans = [];
      for (var i = 0; i < list.length; i++) {
        var id = String(list[i].empi);
        if (okIds[id] && !rendered[id]) orphans.push(id);
      }
      try {
        sessionStorage.setItem("wishlist:validated", "1");
      } catch (e) {}
      if (orphans.length) window.SeedWishlist.pruneOrphans(orphans);
    }

    // Fetch cards through the SRA search render and append them. SRA is the
    // page's primary content, so chunks are requested at high priority and fire
    // concurrently. Cards append in chunk order for stable progressive paint.
    _appendItems(items, done) {
      var self = this;
      // Products whose chunk fetch returned the wishlist SRA markup, so the render
      // is a trustworthy signal of which items resolve -- the self-heal only prunes
      // within this set, never on a failed/foreign response.
      self._lastOkIds = {};
      var chunks = [];
      for (var c = 0; c < items.length; c += this.CHUNK) {
        chunks.push(items.slice(c, c + this.CHUNK));
      }
      var fetches = chunks.map(function (chunk) {
        var ids = chunk.map(function (it) {
          return String(it.empi);
        });
        return fetch(self._searchUrl(ids), { priority: "high" })
          .then(function (res) {
            return res.ok ? res.text() : "";
          })
          .catch(function () {
            return "";
          });
      });
      var added = [];
      var appendChunk = function (i) {
        if (i >= fetches.length) {
          // Apply the saved size to the cards THIS call appended only -- never
          // re-touch already-rendered cards, so a reconcile triggered by an
          // unrelated change can't revert another card's in-flight size selection.
          added.forEach(function (card) {
            self._applySaved(card);
          });
          if (done) done();
          return;
        }
        fetches[i].then(function (htmlText) {
          if (htmlText) {
            var doc = new DOMParser().parseFromString(htmlText, "text/html");
            var inner = doc.querySelector(".wishlist__inner");
            // `.wishlist__inner` renders only when at least one id matched; an
            // all-orphan chunk returns the section's empty-state branch instead.
            // Either proves the search ran, so mark the chunk resolvable for the
            // self-heal; only append cards when the SRA markup is present.
            if (inner || doc.querySelector("[data-wishlist-empty]")) {
              chunks[i].forEach(function (it) {
                self._lastOkIds[String(it.empi)] = true;
              });
            }
            if (inner) {
              Array.prototype.forEach.call(inner.children, function (cell) {
                var node = document.importNode(cell, true);
                self.grid.appendChild(node);
                var card = node.querySelector ? node.querySelector("[data-wishlist-card]") : null;
                if (card) added.push(card);
              });
            }
          }
          appendChunk(i + 1);
        });
      };
      appendChunk(0);
    }

    // Reconcile the rendered grid against a later tier's list: drop cards no
    // longer saved, append newly-saved ones (SRA runs ONLY for these -- an empi
    // set that matches the current grid adds nothing, so a no-change reconcile is
    // network-free; _appendItems applies saved size to the new cards only), then
    // _finish() updates the count. Already-rendered cards are left untouched.
    _reconcile(list, done) {
      var self = this;
      this._items = list;
      var authMap = {};
      for (var i = 0; i < list.length; i++) authMap[String(list[i].empi)] = true;

      var rendered = {};
      var cards = this.grid.querySelectorAll("[data-wishlist-card]");
      Array.prototype.forEach.call(cards, function (card) {
        var id = String(card.dataset.productId);
        // A card whose variant this page just switched keeps its slot while SWYM
        // briefly removes/re-adds it; otherwise the fresh timestamp would move it
        // to the top.
        if (!authMap[id] && !self._isSwapGuarded(id)) {
          var cell =
            card.closest("[data-wishlist-cell]") ||
            card.closest("[data-pc-quickadd-scope]") ||
            card;
          cell.remove();
        } else {
          rendered[id] = true;
        }
      });

      var toAdd = [];
      for (var j = 0; j < list.length; j++) {
        if (!rendered[String(list[j].empi)]) toAdd.push(list[j]);
      }
      if (toAdd.length) {
        this._appendItems(toAdd, function () {
          // _appendItems always adds at the grid END, but `list` is sorted
          // newest-first -- so a just-saved item (hearted on another surface while
          // this page is open) would land LAST. Re-order the grid to list order so
          // it slots into its correct position; already-ordered cards don't move.
          self._reorderGrid(list);
          self._finish();
          if (done) done();
        });
      } else {
        self._finish();
        if (done) done();
      }
    }

    // Arrange grid cells to match the authoritative newest-first `list` order.
    // Re-appending cells in list order sorts the grid; cells already in the right
    // relative order don't visibly move. Only called by _reconcile after an append.
    _reorderGrid(list) {
      var self = this;
      var byEmpi = {};
      Array.prototype.forEach.call(
        this.grid.querySelectorAll("[data-wishlist-card]"),
        function (card) {
          var cell =
            card.closest("[data-wishlist-cell]") ||
            card.closest("[data-pc-quickadd-scope]") ||
            card;
          if (cell.parentNode === self.grid) byEmpi[String(card.dataset.productId)] = cell;
        },
      );
      list.forEach(function (it) {
        // Hold variant switches in place until SWYM's remove/re-add settles.
        if (self._isSwapGuarded(it.empi)) return;
        var cell = byEmpi[String(it.empi)];
        if (cell) self.grid.appendChild(cell);
      });
    }

    // A page-initiated size change must not let its own wishlist:content
    // reconcile reorder the card. SWYM's updateVariant re-timestamps the row, so
    // guard the product for the swap round-trip; genuine later changes still sort
    // normally once the guard clears.
    _guardSwap(empi) {
      var self = this;
      var key = String(empi);
      this._swapGuard = this._swapGuard || {};
      if (this._swapGuard[key]) clearTimeout(this._swapGuard[key]);
      this._swapGuard[key] = setTimeout(function () {
        delete self._swapGuard[key];
      }, 1500);
    }

    _isSwapGuarded(empi) {
      return !!(this._swapGuard && this._swapGuard[String(empi)]);
    }

    _searchUrl(ids) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      var base = root.endsWith("/") ? root : root + "/";
      var sectionId = this.section ? this.section.id.replace(/^shopify-section-/, "") : "";
      var query = ids
        .map(function (id) {
          return "id:" + id;
        })
        .join(" OR ");
      return (
        base +
        "search?q=" +
        encodeURIComponent(query) +
        "&type=product&section_id=" +
        encodeURIComponent(sectionId)
      );
    }

    // Finalise a render/reconcile: count + reveal. Saved-size selection is applied
    // per-card by _appendItems as cards are added (NOT re-applied to existing cards
    // here), so an unrelated reconcile never disturbs an in-flight size change.
    _finish() {
      var cards = this.grid.querySelectorAll("[data-wishlist-card]");
      if (!cards.length) {
        this._showEmpty();
        return;
      }
      this._setCount(cards.length);
      this._hideSkeleton();
      this.hidden = false;
      if (this.emptyEl) this.emptyEl.hidden = true;
    }

    _showEmpty() {
      this._hideSkeleton();
      this.hidden = true;
      if (this.emptyEl) this.emptyEl.hidden = false;
      if (this.countEl) this.countEl.hidden = true;
    }

    _hideSkeleton() {
      if (this.skeletonEl) this.skeletonEl.hidden = true;
      if (this.countSkelEl) this.countSkelEl.hidden = true;
    }

    _setCount(n) {
      if (!this.countEl) return;
      var tpl =
        n === 1
          ? this.dataset.countOne
          : (this.dataset.countOther || "").replace("__count__", String(n));
      this.countEl.textContent = tpl;
      this.countEl.hidden = false;
    }

    _itemFor(card) {
      var empi = card.dataset.productId;
      var list = this._items || [];
      for (var i = 0; i < list.length; i++) {
        if (String(list[i].empi) === String(empi)) return list[i];
      }
      return null;
    }

    _variants(card) {
      var scope = card.closest("[data-pc-quickadd-scope]");
      var island = scope ? scope.querySelector("[data-pc-variants]") : null;
      if (!island) return [];
      try {
        var parsed = JSON.parse(island.textContent);
        return Array.isArray(parsed) ? parsed : (parsed && parsed.variants) || [];
      } catch (e) {
        return [];
      }
    }

    _preview(card) {
      var scope = card.closest("[data-pc-quickadd-scope]");
      var island = scope ? scope.querySelector("[data-pc-preview]") : null;
      if (!island) return null;
      try {
        return JSON.parse(island.textContent);
      } catch (e) {
        return null;
      }
    }

    _selectedVariant(card) {
      var variants = this._variants(card);
      var chip = this._selectedChip(card);
      if (chip) {
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].size) === String(chip.dataset.sizeChipValue)) return variants[i];
        }
        return null;
      }
      var item = this._itemFor(card);
      if (item && item.epi) {
        for (var j = 0; j < variants.length; j++) {
          if (String(variants[j].id) === String(item.epi)) return variants[j];
        }
      }
      return variants[0] || null;
    }

    _chips(card) {
      return card.querySelectorAll('[data-size-chip-name="wishlist-size"]');
    }

    _selectedChip(card) {
      return card.querySelector('[data-size-chip-name="wishlist-size"][aria-pressed="true"]');
    }

    _markSelected(card, chip) {
      Array.prototype.forEach.call(this._chips(card), function (c) {
        var on = c === chip;
        c.setAttribute("aria-pressed", on ? "true" : "false");
        c.classList.toggle("size-chip--selected", on);
      });
    }

    _syncCta(card, variant) {
      var cta = card.querySelector("[data-wishlist-add]");
      if (!cta) return "disabled";
      var scope = card.closest("[data-pc-quickadd-scope]");
      var meta = this._preview(card);
      var isBundle = scope && scope.hasAttribute("data-pc-bundle");
      var state = "disabled";
      if (isBundle) {
        if (!card.classList.contains("wishlist-card--sold-out")) state = "add";
      } else if (variant && variant.available === true) {
        state = "add";
      } else if (variant && variant.available === false && meta && meta.notify === true) {
        state = "notify";
      }

      cta.dataset.wishlistAction = state;
      cta.disabled = state === "disabled";
      if (cta.disabled) cta.setAttribute("aria-disabled", "true");
      else cta.removeAttribute("aria-disabled");
      var label = cta.querySelector(".btn__label");
      if (label)
        label.textContent = state === "notify" ? this.dataset.notifyLabel : this.dataset.addLabel;
      return state;
    }

    // Pre-select the SWYM-saved size so the shopper sees their saved choice on
    // arrival. If that variant no longer resolves, use the first available variant
    // without writing the fallback back to SWYM.
    _applySaved(card) {
      var variants = this._variants(card);
      if (!variants.length) return;
      var item = this._itemFor(card);
      var target = null;
      if (item && item.epi) {
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(item.epi)) {
            target = variants[i];
            break;
          }
        }
      }
      if (!target) {
        for (var j = 0; j < variants.length; j++) {
          if (variants[j].available) {
            target = variants[j];
            break;
          }
        }
      }
      if (!target) target = variants[0];

      var chips = this._chips(card);
      if (chips.length > 1 && target && target.size) {
        for (var k = 0; k < chips.length; k++) {
          if (chips[k].dataset.sizeChipValue === String(target.size)) {
            this._markSelected(card, chips[k]);
            break;
          }
        }
      }
      // The variant carrier drives all three CTA states, including one-size
      // products whose sole sold-out variant has no size chip.
      this._syncCta(card, target);
    }

    _onSizeChange(e) {
      var detail = e.detail || {};
      if (detail.name !== "wishlist-size") return;
      var chip = e.target.closest('[data-size-chip-name="wishlist-size"]');
      var card = e.target.closest("[data-wishlist-card]");
      if (!chip || !card) return;

      var prev = this._selectedChip(card);
      if (prev === chip) return;
      this._markSelected(card, chip);

      var variants = this._variants(card);
      var target = null;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].size) === String(detail.value)) {
          target = variants[i];
          break;
        }
      }
      this._syncCta(card, target);
      if (!target) return;

      // Persist the chosen variant to the SWYM list item (optimistic; revert
      // the selection if the round-trip fails).
      var self = this;
      var empi = card.dataset.productId;
      var du = card.dataset.wishlistDu;
      if (window.SeedWishlist && window.SeedWishlist.updateVariant) {
        // Hold this card's grid slot across the swap's wishlist:content reconcile
        // so the re-timestamped row does not jump to the top.
        this._guardSwap(empi);
        window.SeedWishlist.updateVariant(empi, target.id, du, function (ok) {
          if (ok) {
            var item = self._itemFor(card);
            if (item) item.epi = target.id;
            return;
          }
          if (prev) {
            self._markSelected(card, prev);
            var prevTarget = null;
            for (var j = 0; j < variants.length; j++) {
              if (String(variants[j].size) === String(prev.dataset.sizeChipValue)) {
                prevTarget = variants[j];
                break;
              }
            }
            self._syncCta(card, prevTarget);
          }
        });
      }
    }

    _onClick(e) {
      var removeBtn = e.target.closest("[data-wishlist-remove]");
      if (removeBtn) {
        this._remove(removeBtn, removeBtn.closest("[data-wishlist-card]"));
        return;
      }
      var addBtn = e.target.closest("[data-wishlist-add]");
      if (!addBtn) return;
      var card = addBtn.closest("[data-wishlist-card]");
      var variant = card ? this._selectedVariant(card) : null;
      var action = card ? this._syncCta(card, variant) : "disabled";
      if (action === "notify") this._notify(card, variant);
      else if (action === "add") this._add(addBtn, card);
    }

    _notify(card, variant) {
      if (!card || !variant || variant.available !== false || !window.SeedNotify) return;
      var meta = this._preview(card);
      if (!meta || meta.notify !== true) return;
      window.SeedNotify.open({
        variantId: variant.id,
        title: meta.title || "",
        price: meta.priceLabel || "",
        compare: meta.compareLabel || "",
      });
    }

    _remove(btn, card) {
      if (!card || !window.SeedWishlist || btn.getAttribute("aria-busy") === "true") return;
      var self = this;
      var empi = card.dataset.productId;
      var item = this._itemFor(card) || { empi: empi, epi: "", du: card.dataset.wishlistDu };
      btn.setAttribute("aria-busy", "true");
      window.SeedWishlist.toggle({ empi: item.empi, epi: item.epi, du: item.du }, function () {
        btn.removeAttribute("aria-busy");
        if (!window.SeedWishlist.isSaved(empi)) {
          self._removeCard(card);
        }
      });
    }

    _removeCard(card) {
      var cell =
        card.closest("[data-wishlist-cell]") || card.closest("[data-pc-quickadd-scope]") || card;
      cell.remove();
      this._items = (this._items || []).filter(function (it) {
        return String(it.empi) !== String(card.dataset.productId);
      });
      var remaining = this.grid.querySelectorAll("[data-wishlist-card]").length;
      if (remaining) {
        this._setCount(remaining);
      } else {
        this._showEmpty();
      }
    }

    // A successful simple add-to-bag moves the item out of the wishlist. Bundles
    // prefer the PDP route because the bundle page owns adding child items; the
    // payload fallback covers cards without a bundle URL.
    _add(btn, card) {
      if (!card || !window.SeedQuickAdd) return;
      var scope = card.closest("[data-pc-quickadd-scope]");
      if (!scope) return;

      if (scope.hasAttribute("data-pc-bundle")) {
        var bundleUrl = scope.getAttribute("data-pc-bundle-url");
        if (bundleUrl) {
          window.location.assign(bundleUrl);
          return;
        }
        var payloadEl = scope.querySelector("[data-pc-bundle-payload]");
        if (!payloadEl || !window.SeedQuickAdd.addItems) return;
        try {
          var payload = JSON.parse(payloadEl.textContent);
          var children = payload.children || [];
          if (!children.length) return;
          for (var i = 0; i < children.length; i++) {
            if (!children[i].available) return;
          }
          var lines = children.map(function (chd) {
            return { id: chd.id, quantity: 1, properties: payload.properties };
          });
          window.SeedQuickAdd.addItems(lines, btn);
        } catch (err) {
          /* Malformed bundle data cannot produce a safe cart payload. */
        }
        return;
      }

      var chip = this._selectedChip(card);
      var size = chip ? chip.dataset.sizeChipValue : "";
      var variant = window.SeedQuickAdd.resolve ? window.SeedQuickAdd.resolve(scope, size) : null;
      if (!variant || !variant.available) return;
      var self = this;
      // SeedQuickAdd.add returns the cart/add.js promise: the cart payload on
      // success, undefined on error (a failed add surfaces its own cart-status
      // error). Remove from the wishlist ONLY on a real success, so a failed add
      // never strips the item -- it stays for a retry.
      window.SeedQuickAdd.add(variant.id, 1, btn).then(function (data) {
        if (data) self._removeFromWishlist(card);
      });
    }

    // Drop a just-added card from the wishlist. Mirrors the trash-remove path
    // (_remove/_removeCard): toggle deletes the saved product from SWYM, and once
    // it is no longer saved the card leaves the DOM and the count/empty state
    // update. The persistent wishlist:content reconcile is idempotent against the
    // eager _removeCard, so there is no double-remove.
    _removeFromWishlist(card) {
      if (!card || !window.SeedWishlist) return;
      var self = this;
      var empi = card.dataset.productId;
      var item = this._itemFor(card) || { empi: empi, epi: "", du: card.dataset.wishlistDu };
      window.SeedWishlist.toggle({ empi: item.empi, epi: item.epi, du: item.du }, function () {
        if (!window.SeedWishlist.isSaved(empi)) {
          self._removeCard(card);
        }
      });
    }
  }

  if (!customElements.get("x-wishlist-page")) {
    customElements.define("x-wishlist-page", XWishlistPage);
  }

  } catch(e) { console.error(e); }
})();
})();
